<template>
  <div class="card mb-5 mb-xl-10">
    <div class="card-body pt-9 pb-0">
      <!--begin::Details-->
      <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
        <!--begin: Pic-->
        <div class="me-7 mb-4">
          <div
            class="symbol symbol-100px symbol-lg-160px symbol-fixed position-relative"
          >
            <img
              :src="
                modelEdit && modelEdit.imageProfile
                  ? modelEdit.imageProfile
                  : 'media/avatars/blank.png'
              "
              alt="image"
              style="object-fit: cover;"
              @error="setAltImg"
            />
            <!-- <div
              class="position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-body h-20px w-20px"
            ></div> -->
          </div>
        </div>
        <!--end::Pic-->

        <!--begin::Info-->
        <div class="flex-grow-1">
          <!--begin::Title-->
          <div
            class="d-flex justify-content-between align-items-start flex-wrap mb-2"
          >
            <!--begin::User-->
            <div class="d-flex flex-column">
              <!--begin::Name-->

              <div class="d-flex align-items-center mb-2">
                <span
                  class="text-title"
                  style="font-style: normal;
                          font-weight: 700;
                          color: #000000;"
                  >{{
                    userInfo ? userInfo.firstName + " " + userInfo.lastName : ""
                  }}</span
                >
                <span
                  v-if="userInfo && userInfo.activate == true"
                  class="svg-icon svg-icon-1 svg-icon-primary mx-2"
                  ><i class="fa fa-check-circle" style="color: #1BC5BD;"></i>
                </span>
                <span
                  v-else-if="userInfo && userInfo.activate == false"
                  class="svg-icon svg-icon-1 svg-icon-primary mx-2"
                >
                  <i class="fa fa-clock" style="color: #FFA800;"></i>
                </span>

                <button
                  v-if="userInfo && userInfo.activate == true"
                  class="btn btn-sm  btn-light-success fw-bold ms-2 fs-8 py-1 px-3"
                >
                  ยืนยันอีเมลแล้ว
                </button>
                <button
                  v-else-if="userInfo && userInfo.activate == false"
                  class="btn btn-sm btn-light-warning fw-bold ms-2 fs-8 py-1 px-3"
                >
                  รอยืนยันอีเมล
                </button>
              </div>

              <!--end::Name-->

              <!--begin::Info-->
              <div class="d-flex flex-wrap fw-semibold fs-6 mb-4 pe-2">
                <span
                  class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                >
                  <!--begin::Svg Icon | path: icons/duotune/communication/com006.svg-->
                  <span class="svg-icon svg-icon-4 me-1"
                    ><svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      width="24px"
                      height="24px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        stroke-width="1"
                        fill="none"
                        fill-rule="evenodd"
                      >
                        <polygon points="0 0 24 0 24 24 0 24" />
                        <path
                          d="M5.85714286,2 L13.7364114,2 C14.0910962,2 14.4343066,2.12568431 14.7051108,2.35473959 L19.4686994,6.3839416 C19.8056532,6.66894833 20,7.08787823 20,7.52920201 L20,20.0833333 C20,21.8738751 19.9795521,22 18.1428571,22 L5.85714286,22 C4.02044787,22 4,21.8738751 4,20.0833333 L4,3.91666667 C4,2.12612489 4.02044787,2 5.85714286,2 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                        />
                        <rect
                          fill="#000000"
                          x="6"
                          y="11"
                          width="9"
                          height="2"
                          rx="1"
                        />
                        <rect
                          fill="#000000"
                          x="6"
                          y="15"
                          width="5"
                          height="2"
                          rx="1"
                        />
                      </g>
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                  {{
                    modelEdit.type == 2
                      ? "ผู้รับผิดชอบด้านพลังงานสามัญ"
                      : modelEdit.type == 3
                      ? "ผู้รับผิดชอบด้านพลังงานอาวุโส"
                      : modelEdit.type == 4
                      ? "ผู้ตรวจประเมิน BEC"
                      : "ผู้ใช้งานทั่วไป"
                  }}
                </span>
                <span
                  class="d-flex align-items-center text-gray-400 text-hover-primary me-5 mb-2"
                >
                  <!--begin::Svg Icon | path: icons/duotune/general/gen018.svg-->
                  <span class="svg-icon svg-icon-4 me-1"
                    ><svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.3"
                        d="M18.0624 15.3453L13.1624 20.7453C12.5624 21.4453 11.5624 21.4453 10.9624 20.7453L6.06242 15.3453C4.56242 13.6453 3.76242 11.4453 4.06242 8.94534C4.56242 5.34534 7.46242 2.44534 11.0624 2.04534C15.8624 1.54534 19.9624 5.24534 19.9624 9.94534C20.0624 12.0453 19.2624 13.9453 18.0624 15.3453Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M12.0624 13.0453C13.7193 13.0453 15.0624 11.7022 15.0624 10.0453C15.0624 8.38849 13.7193 7.04535 12.0624 7.04535C10.4056 7.04535 9.06241 8.38849 9.06241 10.0453C9.06241 11.7022 10.4056 13.0453 12.0624 13.0453Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                  <!--end::Svg Icon-->
                  {{
                    userInfo && userInfo.addressProfile
                      ? userInfo.addressProfile.provinceTh
                      : ""
                  }}
                </span>
                <span
                  class="d-flex align-items-center text-gray-400 text-hover-primary mb-2"
                >
                  <!--begin::Svg Icon | path: icons/duotune/communication/com011.svg-->
                  <span class="svg-icon svg-icon-4 me-1"
                    ><svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        opacity="0.3"
                        d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
                        fill="currentColor"
                      ></path>
                      <path
                        d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
                        fill="currentColor"
                      ></path>
                    </svg>
                  </span>
                  {{ userInfo ? userInfo.email : "" }}
                </span>
              </div>
              <div>
                <button
                  v-if="userInfo && userInfo.currentSpecialistStatus == 2"
                  class="btn btn-sm  btn-light-success fw-bold ms-2 fs-8 py-1 px-3"
                >
                  อนุมัติข้อมูลภาคบังคับแล้ว
                </button>
                <button
                  v-else-if="userInfo && userInfo.currentSpecialistStatus == 1"
                  class="btn btn-sm btn-light-warning fw-bold ms-2 fs-8 py-1 px-3"
                >
                  รออนุมัติข้อมูลภาคบังคับ
                </button>
                <button
                  v-else-if="userInfo && userInfo.currentSpecialistStatus == 3"
                  class="btn btn-sm btn-light-danger fw-bold ms-2 fs-8 py-1 px-3"
                >
                  ไม่อนุมัติข้อมูลภาคบังคับ
                </button>
              </div>
              <!--end::Info-->
            </div>

            <!--end::User-->

            <!--begin::Actions-->
            <div class="d-flex my-4">
              <button
                v-if="userInfo && userInfo.pdpaAllowed == true"
                class="btn mx-2 mb-2"
                type="button"
                @click="(dialogDeletePdpa = true), (flgPdpaIndex = 1)"
                style="
                    border-radius: 8px;
                    color: #ff7786;
                    background: #ffffff;
                    border: 1px solid #ff7786;
                  "
              >
                ถอนคำยินยอม
              </button>
              <button
                v-if="userInfo && userInfo.flgPdpa2 == 'y'"
                class="btn mx-2 mb-2"
                type="button"
                @click="(dialogDeletePdpa = true), (flgPdpaIndex = 2)"
                style="
                    border-radius: 8px;
                    color: #ff7786;
                    background: #ffffff;
                    border: 1px solid #ff7786;
                  "
              >
                ถอนคำยินยอม
              </button>
              <button
                class="btn mx-2 mb-2"
                type="button"
                @click="dialogDeleteUser = true"
                style="
                    border-radius: 8px;
                    color: #ff7786;
                    background: #ffffff;
                    border: 1px solid #ff7786;
                  "
              >
                ยกเลิกบัญชีผู้ใช้งาน
              </button>

              <!--end::Menu-->
            </div>
            <!--end::Actions-->
          </div>
          <!--end::Title-->

          <!--begin::Stats-->
          <div class="d-flex flex-wrap flex-stack">
            <!--begin::Wrapper-->
            <div class="d-flex flex-column flex-grow-1 pe-8">
              <!--begin::Stats-->
              <div class="d-flex flex-wrap">
                <!--begin::Stat-->
                <div
                  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
                >
                  <!--begin::Number-->
                  <div class="d-flex align-items-center">
                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->
                    <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                    </span>
                    <!--end::Svg Icon-->
                    <div class="fs-2 fw-bold counted">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M14.9997 2.16699H6.66634C5.78229 2.16699 4.93444 2.51818 4.30932 3.1433C3.6842 3.76842 3.33301 4.61627 3.33301 5.50033V15.5003C3.33301 16.3844 3.6842 17.2322 4.30932 17.8573C4.93444 18.4825 5.78229 18.8337 6.66634 18.8337H14.9997C15.4417 18.8337 15.8656 18.6581 16.1782 18.3455C16.4907 18.0329 16.6663 17.609 16.6663 17.167V3.83366C16.6663 3.39163 16.4907 2.96771 16.1782 2.65515C15.8656 2.34259 15.4417 2.16699 14.9997 2.16699ZM4.99967 5.50033C4.99967 5.0583 5.17527 4.63437 5.48783 4.32181C5.80039 4.00925 6.22431 3.83366 6.66634 3.83366H14.9997V12.167H6.66634C6.07887 12.1695 5.503 12.3307 4.99967 12.6337V5.50033ZM6.66634 17.167C6.22431 17.167 5.80039 16.9914 5.48783 16.6788C5.17527 16.3663 4.99967 15.9424 4.99967 15.5003C4.99967 15.0583 5.17527 14.6344 5.48783 14.3218C5.80039 14.0093 6.22431 13.8337 6.66634 13.8337H14.9997V17.167H6.66634ZM8.33301 7.16699H11.6663C11.8874 7.16699 12.0993 7.0792 12.2556 6.92291C12.4119 6.76663 12.4997 6.55467 12.4997 6.33366C12.4997 6.11265 12.4119 5.90068 12.2556 5.7444C12.0993 5.58812 11.8874 5.50033 11.6663 5.50033H8.33301C8.11199 5.50033 7.90003 5.58812 7.74375 5.7444C7.58747 5.90068 7.49967 6.11265 7.49967 6.33366C7.49967 6.55467 7.58747 6.76663 7.74375 6.92291C7.90003 7.0792 8.11199 7.16699 8.33301 7.16699Z"
                          fill="#9999D3"
                        />
                      </svg>
                      {{ userInfo ? userInfo.courseRegistered : "" }}
                    </div>
                  </div>
                  <!--end::Number-->

                  <!--begin::Label-->
                  <div class="fw-semibold fs-6 text-gray-400">
                    ลงทะเบียน
                  </div>
                  <!--end::Label-->
                </div>
                <!--end::Stat-->

                <!--begin::Stat-->
                <div
                  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
                >
                  <!--begin::Number-->
                  <div class="d-flex align-items-center">
                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr065.svg-->
                    <span class="svg-icon svg-icon-3 svg-icon-danger me-2">
                    </span>
                    <!--end::Svg Icon-->
                    <div class="fs-2 fw-bold counted">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M17.6413 2.21693C17.044 2.11404 16.4391 2.06108 15.833 2.0586C13.765 2.0569 11.7401 2.64991 9.99966 3.76693C8.25479 2.66457 6.23021 2.08612 4.16633 2.10026C3.5602 2.10275 2.95533 2.15571 2.358 2.2586C2.16234 2.29233 1.98515 2.39481 1.85834 2.54759C1.73154 2.70037 1.66344 2.8934 1.66633 3.09193V13.0919C1.66455 13.2144 1.68977 13.3357 1.74021 13.4473C1.79064 13.5589 1.86505 13.658 1.95814 13.7376C2.05123 13.8171 2.16071 13.8752 2.27879 13.9076C2.39688 13.9401 2.52066 13.9461 2.64133 13.9253C3.83551 13.7185 5.059 13.7528 6.23972 14.0262C7.42044 14.2995 8.53452 14.8064 9.51633 15.5169L9.61633 15.5753H9.708C9.80042 15.6138 9.89954 15.6336 9.99966 15.6336C10.0998 15.6336 10.1989 15.6138 10.2913 15.5753H10.383L10.483 15.5169C11.458 14.7905 12.5688 14.2672 13.7498 13.9781C14.9307 13.6889 16.1577 13.6398 17.358 13.8336C17.4787 13.8544 17.6025 13.8484 17.7205 13.816C17.8386 13.7835 17.9481 13.7254 18.0412 13.6459C18.1343 13.5663 18.2087 13.4672 18.2591 13.3556C18.3096 13.244 18.3348 13.1227 18.333 13.0003V3.00026C18.3243 2.81039 18.251 2.62919 18.1252 2.48671C17.9994 2.34423 17.8287 2.24904 17.6413 2.21693ZM9.16633 13.2919C7.62457 12.4808 5.90843 12.0575 4.16633 12.0586C3.89133 12.0586 3.61633 12.0586 3.333 12.0586V3.72526C3.61054 3.70927 3.88878 3.70927 4.16633 3.72526C5.94415 3.7233 7.68318 4.24501 9.16633 5.22526V13.2919ZM16.6663 12.0919C16.383 12.0919 16.108 12.0919 15.833 12.0919C14.0909 12.0909 12.3748 12.5142 10.833 13.3253V5.22526C12.3162 4.24501 14.0552 3.7233 15.833 3.72526C16.1105 3.70927 16.3888 3.70927 16.6663 3.72526V12.0919ZM17.6413 15.5503C17.044 15.4474 16.4391 15.3944 15.833 15.3919C13.765 15.3902 11.7401 15.9832 9.99966 17.1003C8.25926 15.9832 6.23436 15.3902 4.16633 15.3919C3.5602 15.3944 2.95533 15.4474 2.358 15.5503C2.24952 15.5675 2.14552 15.606 2.05197 15.6635C1.95842 15.7211 1.87716 15.7965 1.81289 15.8856C1.74861 15.9747 1.70257 16.0756 1.67742 16.1825C1.65227 16.2894 1.6485 16.4002 1.66633 16.5086C1.70868 16.725 1.83507 16.9158 2.01782 17.0392C2.20057 17.1626 2.42478 17.2085 2.64133 17.1669C3.83551 16.9602 5.059 16.9945 6.23972 17.2678C7.42044 17.5412 8.53452 18.0481 9.51633 18.7586C9.65747 18.8591 9.82641 18.9131 9.99966 18.9131C10.1729 18.9131 10.3419 18.8591 10.483 18.7586C11.4648 18.0481 12.5789 17.5412 13.7596 17.2678C14.9403 16.9945 16.1638 16.9602 17.358 17.1669C17.5745 17.2085 17.7988 17.1626 17.9815 17.0392C18.1643 16.9158 18.2906 16.725 18.333 16.5086C18.3508 16.4002 18.3471 16.2894 18.3219 16.1825C18.2968 16.0756 18.2507 15.9747 18.1864 15.8856C18.1222 15.7965 18.0409 15.7211 17.9474 15.6635C17.8538 15.606 17.7498 15.5675 17.6413 15.5503Z"
                          fill="#9999D3"
                        />
                      </svg>
                      {{ userInfo ? userInfo.courseRegisterStudying : "" }}
                    </div>
                  </div>
                  <!--end::Number-->

                  <!--begin::Label-->
                  <div class="fw-semibold fs-6 text-gray-400">เรียนต่อ</div>
                  <!--end::Label-->
                </div>
                <!--end::Stat-->

                <!--begin::Stat-->
                <div
                  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
                >
                  <!--begin::Number-->
                  <div class="d-flex align-items-center">
                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->
                    <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                    </span>
                    <!--end::Svg Icon-->
                    <div class="fs-2 fw-bold counted" data-kt-countup="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M17.9084 8.99141L17.0751 8.53307L9.57506 4.36641H9.48339C9.4323 4.34481 9.37929 4.32806 9.32506 4.31641H9.16673H9.01673C8.95979 4.32807 8.90402 4.34481 8.85006 4.36641H8.75839L1.25839 8.53307C1.13015 8.60575 1.02347 8.71115 0.949256 8.83852C0.87504 8.96589 0.835937 9.11066 0.835938 9.25807C0.835937 9.40549 0.87504 9.55026 0.949256 9.67763C1.02347 9.80499 1.13015 9.91039 1.25839 9.98307L3.33339 11.1331V15.0831C3.33339 15.7461 3.59679 16.382 4.06563 16.8508C4.53447 17.3197 5.17035 17.5831 5.83339 17.5831H12.5001C13.1631 17.5831 13.799 17.3197 14.2678 16.8508C14.7367 16.382 15.0001 15.7461 15.0001 15.0831V11.1331L16.6667 10.1997V12.5831C16.6667 12.8041 16.7545 13.016 16.9108 13.1723C17.0671 13.3286 17.279 13.4164 17.5001 13.4164C17.7211 13.4164 17.933 13.3286 18.0893 13.1723C18.2456 13.016 18.3334 12.8041 18.3334 12.5831V9.71641C18.3331 9.56874 18.2937 9.4238 18.219 9.29641C18.1443 9.16902 18.0371 9.06376 17.9084 8.99141ZM13.3334 15.0831C13.3334 15.3041 13.2456 15.516 13.0893 15.6723C12.933 15.8286 12.7211 15.9164 12.5001 15.9164H5.83339C5.61238 15.9164 5.40042 15.8286 5.24414 15.6723C5.08786 15.516 5.00006 15.3041 5.00006 15.0831V12.0581L8.75839 14.1414L8.88339 14.1914H8.9584C9.02757 14.2001 9.09756 14.2001 9.16673 14.1914C9.2359 14.2001 9.30589 14.2001 9.37506 14.1914H9.45006C9.4943 14.1821 9.53659 14.1652 9.57506 14.1414L13.3334 12.0581V15.0831ZM9.16673 12.4664L3.38339 9.24974L9.16673 6.03307L14.9501 9.24974L9.16673 12.4664Z"
                          fill="#9999D3"
                        />
                      </svg>
                      {{ userInfo ? userInfo.courseRegisterFinish : "" }}
                    </div>
                  </div>
                  <!--end::Number-->

                  <!--begin::Label-->
                  <div class="fw-semibold fs-6 text-gray-400">จบหลักสูตร</div>
                  <!--end::Label-->
                </div>
                <!--end::Stat-->
                <div
                  class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
                >
                  <!--begin::Number-->
                  <div class="d-flex align-items-center">
                    <!--begin::Svg Icon | path: icons/duotune/arrows/arr066.svg-->
                    <span class="svg-icon svg-icon-3 svg-icon-success me-2">
                    </span>
                    <!--end::Svg Icon-->
                    <div class="fs-2 fw-bold counted" data-kt-countup="true">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                      >
                        <path
                          d="M17.3921 14.875L15.1337 10.975C15.5958 10.1263 15.8366 9.17473 15.8337 8.20833C15.8337 6.66124 15.2191 5.17751 14.1252 4.08354C13.0312 2.98958 11.5475 2.375 10.0004 2.375C8.45329 2.375 6.96956 2.98958 5.8756 4.08354C4.78163 5.17751 4.16705 6.66124 4.16705 8.20833C4.16418 9.17473 4.40493 10.1263 4.86705 10.975L2.60872 14.875C2.53544 15.0019 2.49693 15.1459 2.49707 15.2925C2.49722 15.4391 2.53601 15.583 2.60954 15.7098C2.68308 15.8366 2.78875 15.9417 2.91589 16.0146C3.04304 16.0875 3.18716 16.1256 3.33372 16.125H5.72539L6.94205 18.175C6.98307 18.2429 7.03358 18.3047 7.09205 18.3583C7.24653 18.5072 7.45249 18.5908 7.66705 18.5917H7.78372C7.90953 18.5744 8.02974 18.5287 8.13517 18.4579C8.2406 18.3872 8.32846 18.2932 8.39205 18.1833L10.0004 15.4167L11.6087 18.2083C11.6732 18.3167 11.7615 18.409 11.8669 18.4783C11.9723 18.5476 12.092 18.592 12.2171 18.6083H12.3337C12.5512 18.6096 12.7605 18.5259 12.9171 18.375C12.9731 18.3244 13.0209 18.2654 13.0587 18.2L14.2754 16.15H16.6671C16.8139 16.1506 16.9583 16.1124 17.0856 16.0392C17.2129 15.966 17.3186 15.8605 17.3921 15.7333C17.4699 15.6037 17.5111 15.4554 17.5111 15.3042C17.5111 15.153 17.4699 15.0046 17.3921 14.875ZM7.65872 16.15L6.91705 14.9083C6.84402 14.7851 6.74048 14.6828 6.61641 14.6113C6.49233 14.5398 6.35192 14.5015 6.20872 14.5H4.76705L5.95872 12.4333C6.77932 13.2241 7.81357 13.7571 8.93372 13.9667L7.65872 16.15ZM10.0004 12.375C9.1763 12.375 8.37071 12.1306 7.68551 11.6728C7.00031 11.215 6.46625 10.5642 6.15089 9.80285C5.83552 9.04149 5.75301 8.20371 5.91378 7.39546C6.07455 6.5872 6.47139 5.84477 7.05411 5.26205C7.63683 4.67934 8.37926 4.2825 9.18751 4.12173C9.99576 3.96096 10.8335 4.04347 11.5949 4.35884C12.3563 4.6742 13.007 5.20825 13.4648 5.89346C13.9227 6.57866 14.1671 7.38424 14.1671 8.20833C14.1671 9.3134 13.7281 10.3732 12.9467 11.1546C12.1653 11.936 11.1055 12.375 10.0004 12.375ZM13.7921 14.5C13.6488 14.5015 13.5084 14.5398 13.3844 14.6113C13.2603 14.6828 13.1567 14.7851 13.0837 14.9083L12.3421 16.15L11.0754 13.9417C12.1916 13.7278 13.222 13.1953 14.0421 12.4083L15.2337 14.475L13.7921 14.5Z"
                          fill="#9999D3"
                        />
                      </svg>
                      {{ userInfo ? userInfo.syllabusCertificate : "" }}
                    </div>
                  </div>
                  <!--end::Number-->

                  <!--begin::Label-->
                  <div class="fw-semibold fs-6 text-gray-400">
                    ใบรับรอง (หลักสูตร)
                  </div>
                  <!--end::Label-->
                </div>
              </div>
              <!--end::Stats-->
            </div>
            <!--end::Wrapper-->

            <!--begin::Progress-->
            <!-- <div
              class="d-flex align-items-center w-200px w-sm-300px flex-column mt-3"
            >
              <div class="d-flex justify-content-between w-100 mt-auto mb-2">
                <span class="fw-semibold fs-6 text-gray-400">ภาพรวม</span>
                <span class="fw-bold fs-6">50%</span>
              </div>

              <div class="h-5px mx-3 w-100 bg-light mb-3">
                <div
                  class="bg-success rounded h-5px"
                  role="progressbar"
                  style="width: 50%;"
                  aria-valuenow="50"
                  aria-valuemin="0"
                  aria-valuemax="100"
                ></div>
              </div>
            </div> -->
            <!--end::Progress-->
          </div>
          <!--end::Stats-->
        </div>
        <!--end::Info-->
      </div>
      <!--end::Details-->

      <!--begin::Navs-->
      <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-5">
        <li class="nav-item">
          <a
            :class="tab == 1 ? 'nav-link active' : 'nav-link'"
            data-bs-toggle="tab"
            href="#kt_tab_pane_1"
            >ข้อมูลผู้ใช้งาน
          </a>
        </li>
        <li class="nav-item">
          <a
            :class="tab == 2 ? 'nav-link active' : 'nav-link'"
            data-bs-toggle="tab"
            href="#kt_tab_pane_2"
            >หลักสูตรทั่วไปของฉัน</a
          >
        </li>
        <li class="nav-item" v-if="syllabusList && syllabusList.length > 0">
          <a
            :class="tab == 3 ? 'nav-link active' : 'nav-link'"
            data-bs-toggle="tab"
            href="#kt_tab_pane_3"
            >หลักสูตรตามกฎหมายของฉัน</a
          >
        </li>

        <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_5"
            >นโยบายความเป็นส่วนตัว</a
          >
        </li>
        <!-- <li class="nav-item">
          <a class="nav-link" data-bs-toggle="tab" href="#kt_tab_pane_6"
            >ข้อมูลการสอบวัดผล</a
          >
        </li> -->
      </ul>
      <!--begin::Navs-->
    </div>
  </div>
  <div class="tab-content my-5 p-3" id="myTabContent">
    <div
      :class="tab == 1 ? 'tab-pane fade  active show' : 'tab-pane fade'"
      id="kt_tab_pane_1"
      role="tabpanel"
    >
      <div
        v-if="
          modelEdit.type == 1 && !showMandatoryTabs && !modelMandatory.facId
        "
        class="d-flex justify-content-end mb-5"
      >
        <button
          type="button"
          class="btn btn-primary"
          @click="showMandatoryTabs = true"
        >
          ลงทะเบียนเป็นผู้รับผิดชอบด้านพลังงาน
        </button>
      </div>
      <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-5">
        <li class="nav-item">
          <a
            class="nav-link active"
            data-bs-toggle="tab"
            href="#info_1"
            @click="activeInfoTab = 'info_1'"
            >1.ข้อมูลทั่วไป
            <span v-if="Object.keys(errors).length > 0" class="px-2 text-danger"
              >*</span
            ></a
          >
        </li>
        <li
          class="nav-item"
          v-if="modelEdit.type > 1 || showMandatoryTabs || modelMandatory.facId"
        >
          <a
            class="nav-link"
            data-bs-toggle="tab"
            href="#info_2"
            @click="activeInfoTab = 'info_2'"
            >2.ข้อมูลผู้ใช้งานสำหรับเรียนภาคบังคับ
            <span
              v-if="Object.keys(errors2).length > 0"
              class="px-2 text-danger"
              >*</span
            ></a
          >
        </li>
        <li
          class="nav-item"
          v-if="modelEdit.type > 1 || showMandatoryTabs || modelMandatory.facId"
        >
          <a
            class="nav-link"
            data-bs-toggle="tab"
            href="#info_3"
            @click="activeInfoTab = 'info_3'"
            >3.ข้อมูลจำเพาะของสถานประกอบการ</a
          >
        </li>
        <li
          class="nav-item"
          v-if="modelEdit.type > 1 || showMandatoryTabs || modelMandatory.facId"
        >
          <a
            class="nav-link"
            data-bs-toggle="tab"
            href="#info_4"
            @click="activeInfoTab = 'info_4'"
            >4.สำหรับผู้รับรอง</a
          >
        </li>
      </ul>

      <div class="tab-content my-5" id="infoTabContent">
        <div class="tab-pane fade  active show" id="info_1" role="tabpanel">
          <div class="row mb-5">
            <div class="card">
              <div class="card-header">
                <div class="card-title">
                  ข้อมูลเข้าสู่ระบบ
                </div>
              </div>
              <div class="card-body">
                <div v-if="needSetupAuth" class="row mb-5">
                  <div class="col-12 mb-3">
                    <div class="alert alert-warning mb-0">
                      กรุณาตั้งชื่อผู้ใช้งานและรหัสผ่านสำหรับเข้าสู่ระบบ
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-5">
                      <label class="form-label required">อีเมล</label>
                      <input
                        type="email"
                        v-model="authEmail"
                        @keydown="(e) => { if (/[฀-๿]/.test(e.key)) e.preventDefault() }"
                        @input="validateAuthEmail"
                        class="form-control "
                        placeholder="อีเมล"
                      />
                      <p
                        v-if="authEmail && !authEmailValid"
                        class="text-danger mb-0"
                      >
                        กรุณาระบุอีเมลให้ถูกต้อง
                      </p>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-5">
                      <label class="form-label required">รหัสผ่าน</label>
                      <div style="position: relative;">
                        <input
                          :type="passwordFieldType"
                          class="form-control "
                           @keydown="(e) => { if (/[฀-๿]/.test(e.key)) e.preventDefault() }"
                          v-model="authPassword"
                          @input="validateAuthPassword"
                          placeholder="รหัสผ่าน"
                        />
                        <button
                          style="position: absolute;top: 0;right: 5px;"
                          type="button"
                          class="btn"
                          @click="switchVisibility"
                        >
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                      <div class="d-flex align-items-center mt-2 mb-2">
                        <div
                          class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"
                          :class="[authValidate >= 1 && 'active']"
                        ></div>
                        <div
                          class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"
                          :class="[authValidate >= 2 && 'active']"
                        ></div>
                        <div
                          class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2"
                          :class="[authValidate >= 3 && 'active']"
                        ></div>
                        <div
                          class="flex-grow-1 bg-secondary bg-active-success rounded h-5px"
                          :class="[authValidate >= 4 && 'active']"
                        ></div>
                      </div>
                      <div class="text-danger required">
                        ใช้อักขระตั้งแต่ 8 ตัวขึ้นไป โดยมีทั้งตัวอักษร ตัวเลข
                        และ สัญลักษณ์
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-5">
                      <label class="form-label required">ยืนยันรหัสผ่าน</label>
                      <div style="position: relative;">
                        <input
                          :type="passwordFieldType2"
                           @keydown="(e) => { if (/[฀-๿]/.test(e.key)) e.preventDefault() }"
                          class="form-control "
                          v-model="authPasswordConfirm"
                          @input="validateAuthConfirm"
                          placeholder="ยืนยันรหัสผ่าน"
                        />
                        <button
                          style="position: absolute;top: 0;right: 5px;"
                          type="button"
                          class="btn"
                          @click="switchVisibility2"
                        >
                          <i class="fa fa-eye"></i>
                        </button>
                      </div>
                      <p v-if="!authValidateCpassword" class="text-danger">
                        รหัสผ่านและการยืนยันไม่เหมือนกัน
                      </p>
                    </div>
                  </div>
                  <div class="col-12">
                    <button
                      type="button"
                      class="btn btn-primary"
                      :disabled="
                        !authEmail ||
                          !authEmailValid ||
                          authValidate != 4 ||
                          !authValidateCpassword ||
                          !authPasswordConfirm
                      "
                      @click="submitUserAuth"
                    >
                      บันทึกข้อมูลเข้าสู่ระบบ
                    </button>
                  </div>
                </div>
                <div class="row" v-if="!needSetupAuth">
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label">อีเมล</label>
                      <input
                        type="email"
                        v-model="modelEdit.email"
                        class="form-control"
                        :class="{ 'is-invalid': errors.email }"
                        placeholder="อีเมล"
                        @input="errors.email = ''"
                      />
                      <div v-if="errors.email" class="text-danger">
                        {{ errors.email }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4" v-if="!modelEdit['googleId']">
                    <div class="d-flex flex-wrap align-items-center mb-10">
                      <!--begin::Label-->
                      <div
                        id="kt_signin_password"
                        class=""
                        v-if="!formpassword"
                      >
                        <div class="fs-6 fw-bold mb-1">รหัสผ่าน</div>
                        <div class="fw-semibold text-gray-600">
                          ************
                        </div>
                      </div>
                      <div id="kt_signin_password_button" class="ms-auto">
                        <button
                          v-if="!formpassword"
                          class="btn btn-light btn-active-light-primary"
                          @click="showForm(true)"
                        >
                          เปลี่ยนรหัสผ่าน
                        </button>
                      </div>
                    </div>
                    <!-- <div class="mb-10">
                      <label class="form-label">รหัสผ่าน</label>
                      <button
                        type="button"
                        class="btn btn-primary form-control"
                      >
                        เปลี่ยนรหัสผ่าน
                      </button>
                    </div> -->
                  </div>
                </div>
                <div
                  v-if="formpassword"
                  id="kt_signin_password_edit"
                  class="flex-row-fluid"
                >
                  <!--begin::Form-->
                  <form
                    id="kt_signin_change_password"
                    class="form fv-plugins-bootstrap5 fv-plugins-framework"
                  >
                    <div class="row mb-1">
                      <div class="col-lg-4">
                        <div class="fv-row mb-0 fv-plugins-icon-container">
                          <label
                            for="currentpassword"
                            class="form-label fs-6 fw-bold mb-3"
                            >รหัสผ่านปัจจุบัน</label
                          >
                          <div style="position: relative;">
                            <input
                              :type="passwordFieldType3"
                              class="form-control   "
                              v-model="oldPassword"
                              name="currentpassword"
                              id="currentpassword"
                            />
                            <button
                              style="position: absolute;top: 0;right: 5px;"
                              type="button"
                              class="btn"
                              @click="switchVisibility3"
                            >
                              <i class="fa fa-eye"></i>
                            </button>
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="fv-row mb-0 fv-plugins-icon-container">
                          <label
                            for="newpassword"
                            class="form-label fs-6 fw-bold mb-3"
                            >รหัสผ่านใหม่</label
                          >
                          <div style="position: relative;">
                            <input
                              :type="passwordFieldType"
                              class="form-control   "
                              name="newpassword"
                              @input="validatePassword"
                              v-model="newPassword"
                              id="newpassword"
                            />
                            <button
                              style="position: absolute;top: 0;right: 5px;"
                              type="button"
                              class="btn"
                              @click="switchVisibility"
                            >
                              <i class="fa fa-eye"></i>
                            </button>
                          </div>
                          <div
                            class="d-flex align-items-center mb-3"
                            data-kt-password-meter-control="highlight"
                            :key="validate"
                          >
                            <!-- <div  v-for="(item, index) in listValidate"  :key="index"
                        :class="'flex-grow-1 bg-secondary  rounded h-5px me-2' +item.class + ' ' + (validate<=item.id? 'active':'') "
                      >{{item.id}}</div> -->
                            <div
                              class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2 "
                              :class="[validate >= 1 && 'active']"
                            ></div>
                            <div
                              class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2 "
                              :class="[validate >= 2 && 'active']"
                            ></div>
                            <div
                              class="flex-grow-1 bg-secondary bg-active-success rounded h-5px me-2 "
                              :class="[validate >= 3 && 'active']"
                            ></div>
                            <div
                              class="flex-grow-1 bg-secondary bg-active-success rounded h-5px "
                              :class="[validate >= 4 && 'active']"
                            ></div>
                          </div>
                          <div class="text-danger required">
                            ใช้อักขระตั้งแต่ 8 ตัวขึ้นไป โดยมีทั้งตัวอักษร
                            ตัวเลข และ สัญลักษณ์
                          </div>
                        </div>
                      </div>

                      <div class="col-lg-4">
                        <div class="fv-row mb-0 fv-plugins-icon-container">
                          <label
                            for="confirmpassword"
                            class="form-label fs-6 fw-bold mb-3"
                            >ยืนยันรหัสผ่านใหม่</label
                          >
                          <div style="position: relative;">
                            <input
                              :type="passwordFieldType2"
                              class="form-control   "
                              name="confirmpassword"
                              v-model="newPasswordConfirm"
                              @input="validateConfirmpassword"
                              id="confirmpassword"
                            />
                            <button
                              style="position: absolute;top: 0;right: 5px;"
                              type="button"
                              class="btn"
                              @click="switchVisibility2"
                            >
                              <i class="fa fa-eye"></i>
                            </button>
                          </div>
                          <p v-if="!validateCpassword" class="text-danger">
                            รหัสผ่านและการยืนยันไม่เหมือนกัน
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="d-flex">
                      <button
                        id="kt_password_submit"
                        type="button"
                        class="btn btn-primary me-2 px-6"
                        :disabled="validate != 4"
                        @click="changePassword"
                      >
                        อัพเดตรหัสผ่าน
                      </button>
                      <button
                        id="kt_password_cancel"
                        @click="showForm(false)"
                        type="button"
                        class="btn btn-color-gray-400 btn-active-light-primary px-6"
                      >
                        ยกเลิก
                      </button>
                    </div>
                  </form>
                  <!--end::Form-->
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="card">
              <div class="card-header">
                <div class="card-title">
                  ข้อมูลสมาชิก
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 ">
                    <div class="mb-10">
                      <div
                        class="image-input image-input-empty image-input-outline"
                        id="kt_user_edit_avatar"
                      >
                        <div class="image-input-wrapper mx-auto">
                          <span @click="fileClick" class="icon-edit"
                            ><i class="fa fa-pencil-alt"></i
                          ></span>
                          <img
                            :src="
                              modelEdit.imageProfile
                                ? modelEdit.imageProfile
                                : 'media/avatars/blank.png'
                            "
                            alt=""
                            style="
                            vertical-align: middle;
                            width: 100%;
                            height: inherit;
                            object-fit: cover;
                          "
                            @error="setAltImg"
                          />
                          <p>
                            ขนาดไฟล์: สูงสุด 1 MB ไฟล์ที่รองรับ: .JPEG, .PNG
                          </p>
                        </div>
                        <input
                          type="file"
                          ref="file"
                          class="form-control   mt-5"
                          name="profile_avatar"
                          v-on:change="onFileChange($event)"
                          hidden
                          accept=".png, .jpg, .jpeg"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="mb-10">
                      <label for="" class="form-label required"
                        >เลขประจำตัวบัตรประชาชน</label
                      >
                      <input
                        type="text"
                        class="form-control "
                        placeholder="เลขประจำตัวบัตรประชาชน"
                        :maxlength="'13'"
                        v-model="modelEdit.idCard"
                        @keypress="isNumber($event)"
                        @keyup="assertThaiId(modelEdit.idCard)"
                        @input="errors.idCard = ''"
                      />
                      <div
                        v-if="
                          modelEdit.idCard &&
                            modelEdit.idCard.length == 13 &&
                            checkIdcard == false
                        "
                        class="text-danger"
                      >
                        กรุณาระบุให้ถูกต้อง
                      </div>
                      <div v-if="errors.idCard" class="text-danger">
                        {{ errors.idCard }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="mb-10">
                      <label for="" class="form-label required">คำนำหน้า</label>
                      <el-select
                        class="w-100"
                        v-model="modelEdit.prefix"
                        filterable
                        placeholder="กรุณาเลือกคำนำหน้า"
                        @change="errors.prefix = ''"
                      >
                        <el-option
                          v-for="pf in prefixList"
                          :key="pf.code"
                          :value="pf.name_th"
                          :label="pf.name_th"
                        />
                        <!-- <el-option value="นาย" label="นาย" />
                        <el-option value="นาง" label="นาง" />
                        <el-option value="นางสาว" label="นางสาว" /> -->
                      </el-select>
                      <div v-if="errors.prefix" class="text-danger">
                        {{ errors.prefix }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="mb-10">
                      <label for="" class="form-label required">ชื่อ</label>
                      <input
                        type="text"
                        class="form-control "
                        placeholder="ชื่อ"
                        v-model="modelEdit.firstName"
                        @input="
                          validateThai('firstName', modelEdit.firstName),
                            (errors.firstName = '')
                        "
                      />
                      <div v-if="errors.firstName" class="text-danger">
                        {{ errors.firstName }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="mb-10">
                      <label for="" class="form-label required">นามสกุล</label>
                      <input
                        type="text"
                        class="form-control "
                        placeholder="นามสกุล"
                        v-model="modelEdit.lastName"
                        @input="
                          validateThai('lastName', modelEdit.lastName),
                            (errors.lastName = '')
                        "
                      />
                      <div v-if="errors.lastName" class="text-danger">
                        {{ errors.lastName }}
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-md-3">
                    <div class="mb-10">
                      <label for="" class="form-label ">วันเกิด</label>
                      <!-- <input
                        class="form-control  "
                        type="date"
                        autocomplete="off"
                      /> -->
                      <el-config-provider :locale="locale">
                        <el-date-picker
                          v-model="modelEdit.birthDate"
                          type="date"
                          placeholder="วันเกิด"
                          format="DD/MM/YYYY"
                          value-format="DD/MM/YYYY"
                          class="w-100"
                          size="large"
                        />
                      </el-config-provider>
                      <span class="text-danger"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="mb-10">
                      <label for="" class="form-label required"
                        >เบอร์โทรศัพท์</label
                      >
                      <input
                        type="text"
                        class="form-control "
                        placeholder="เบอร์โทรศัพท์"
                        :maxlength="'10'"
                        v-model="modelEdit.phoneNumber"
                        @keypress="isNumber($event)"
                        @input="errors.phoneNumber = ''"
                      />
                      <div v-if="errors.phoneNumber" class="text-danger">
                        {{ errors.phoneNumber }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="card" style="position: relative;">
              <div v-if="dialogError" class="address-error-overlay">
                <div class="address-error-box">
                  <div class="error-dialog-icon">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="28"
                      height="28"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#ef4444"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                  </div>
                  <h3 class="error-dialog-title">แจ้งเตือนข้อผิดพลาด</h3>
                  <p class="error-dialog-msg" style="margin: 0;">
                    ไม่สามารถทำการแก้ไขข้อมูลได้เนื่องจากไม่สามารถเชื่อมต่อกับฐานข้อมูล
                    กพบ ได้ในขณะนี้
                  </p>
                  <div
                    v-if="listErrorApi && listErrorApi.length > 0"
                    class="error-dialog-list"
                    style="text-align: left; width: 100%;"
                  >
                    <div
                      class="error-dialog-item"
                      v-for="(item, index) in listErrorApi"
                      :key="index"
                    >
                      <span class="error-dialog-item-dot"></span>
                      <span
                        >{{ item.api }}
                        <span class="error-dialog-item-msg"
                          >({{ item.message }})</span
                        ></span
                      >
                    </div>
                  </div>
                  <button
                    class="error-dialog-btn error-dialog-btn--secondary"
                    type="button"
                    @click="dialogError = false"
                  >
                    ปิด
                  </button>
                </div>
              </div>
              <div class="card-header">
                <div class="card-title">
                  ที่อยู่ปัจจุบัน
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label required"
                        >เลขที่</label
                      >
                      <input
                        type="text"
                        class="form-control "
                        placeholder="เลขที่"
                        v-model="modelEdit.no"
                        @input="errors.no = ''"
                      />
                      <div v-if="errors.no" class="text-danger">
                        {{ errors.no }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label">หมู่</label>
                      <input
                        type="text"
                        class="form-control "
                        placeholder="หมู่"
                        v-model="modelEdit.moo"
                      />
                      <span class="text-danger"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label"
                        >ตรอก/ซอย</label
                      >
                      <input
                        type="text"
                        class="form-control "
                        placeholder="ตรอก/ซอย"
                        v-model="modelEdit.soi"
                      />
                      <span class="text-danger"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label">ถนน</label>
                      <input
                        type="text"
                        class="form-control "
                        placeholder="ถนน"
                        v-model="modelEdit.road"
                      />
                      <span class="text-danger"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="" class="form-label required">ภาค</label>
                      <el-select
                        class="w-100"
                        v-model="modelEdit.regionId"
                        filterable
                        @change="
                          callProvince($event, true);
                          errors.regionId = '';
                        "
                        placeholder="กรุณาเลือกภาค"
                      >
                        <el-option
                          v-for="r in regionList"
                          :key="r.region_code"
                          :value="r.region_code"
                          :label="r.region_name_th"
                        />
                      </el-select>
                      <div v-if="errors.regionId" class="text-danger">
                        {{ errors.regionId }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="" class="form-label required">จังหวัด</label>
                      <el-select
                        class="w-100"
                        v-model="modelEdit.provinceId"
                        filterable
                        @change="
                          callDistrict($event, true);
                          errors.provinceId = '';
                        "
                        placeholder="กรุณาเลือกจังหวัด"
                      >
                        <el-option
                          v-for="p in provinceList"
                          :key="p.province_code"
                          :value="p.province_code"
                          :label="p.province_name_th"
                        />
                      </el-select>
                      <div v-if="errors.provinceId" class="text-danger">
                        {{ errors.provinceId }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="" class="form-label required">อำเภอ</label>
                      <el-select
                        class="w-100"
                        @change="
                          callSubDistrict($event, true);
                          errors.districtId = '';
                        "
                        v-model="modelEdit.districtId"
                        filterable
                        placeholder="กรุณาเลือกอำเภอ"
                      >
                        <el-option
                          v-for="p in districtList"
                          :key="p.district_code"
                          :value="p.district_code"
                          :label="p.district_name_th"
                        />
                      </el-select>
                      <div v-if="errors.districtId" class="text-danger">
                        {{ errors.districtId }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="" class="form-label required">ตำบล</label>
                      <el-select
                        class="w-100"
                        filterable
                        @change="
                          callZipcode($event, true);
                          errors.subDistrictId = '';
                        "
                        v-model="modelEdit.subDistrictId"
                        placeholder="กรุณาเลือกตำบล"
                      >
                        <el-option
                          v-for="sd in subDistrictList"
                          :key="sd.sub_district_code"
                          :value="sd.sub_district_code"
                          :label="sd.sub_district_name_th"
                        />
                      </el-select>
                      <div v-if="errors.subDistrictId" class="text-danger">
                        {{ errors.subDistrictId }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="" class="form-label required"
                        >รหัสไปรษณีย์</label
                      >
                      <input
                        type="text"
                        class="form-control "
                        placeholder="รหัสไปรษณีย์"
                        v-model="modelEdit.zipcode"
                        @input="errors.zipcode = ''"
                      />
                      <div v-if="errors.zipcode" class="text-danger">
                        {{ errors.zipcode }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="card">
              <div class="card-header">
                <div class="card-title">
                  คุณวุฒิ
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label required"
                        >เลือกคุณวุฒิ</label
                      >
                      <el-select
                        class="w-100"
                        filterable
                        v-model="modelEdit.qualificationId"
                        placeholder="กรุณาเลือกคุณวุฒิ"
                        @change="errors.qualificationId = ''"
                      >
                        <el-option
                          v-for="q in qualificationList"
                          :key="q.code"
                          :value="q.code"
                          :label="q.name"
                        />
                      </el-select>
                      <div v-if="errors.qualificationId" class="text-danger">
                        {{ errors.qualificationId }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label required"
                        >สาขาวิชา</label
                      >
                      <input
                        class="form-control  "
                        type="text"
                        placeholder=""
                        v-model="modelEdit.qualificationMajor"
                        name="qualificationMajor"
                        autocomplete="off"
                        @input="errors.qualificationMajor = ''"
                      />
                      <div v-if="errors.qualificationMajor" class="text-danger">
                        {{ errors.qualificationMajor }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label "
                        >คุณวุฒิ อื่น ๆ โปรดระบุ</label
                      >
                      <input
                        class="form-control  "
                        type="text"
                        placeholder=""
                        autocomplete="off"
                        v-model="modelEdit.qualificationOther"
                      />
                      <span class="text-danger"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-5">
            <div class="card">
              <div class="card-header">
                <div class="card-title">
                  สถานที่ทำงาน
                </div>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label required"
                        >ประเภทของหน่วยงาน</label
                      >
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="กรุณาเลือกประเภทของหน่วยงาน"
                        v-model="modelEdit.officeTypeId"
                        @change="errors.officeTypeId = ''"
                      >
                        <el-option
                          v-for="o in officeTypeList"
                          :key="o.code"
                          :value="o.code"
                          :label="o.name"
                        />
                      </el-select>
                      <div v-if="errors.officeTypeId" class="text-danger">
                        {{ errors.officeTypeId }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label"
                        >ประสบการณ์ทำงาน (ปี)</label
                      >
                      <input
                        class="form-control  "
                        type="text"
                        v-model="modelEdit.officeExperience"
                        placeholder=""
                        name="officeExp"
                        autocomplete="off"
                      />
                      <span class="text-danger"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label"
                        >หน้าที่ปัจจุบัน</label
                      >
                      <input
                        class="form-control  "
                        type="text"
                        placeholder=""
                        v-model="modelEdit.officePosition"
                        name="officePosition"
                        autocomplete="off"
                      />
                      <span class="text-danger"></span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4">
                    <div class="mb-10">
                      <label for="emailField" class="form-label"
                        >ลักษณะงานที่ทำ</label
                      >
                      <input
                        class="form-control  "
                        type="text"
                        placeholder=""
                        v-model="modelEdit.officeJobDesc"
                        name="officeJobDesc"
                        autocomplete="off"
                      />
                      <span class="text-danger"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tab-pane fade" id="info_2" role="tabpanel">
          <div class="card mb-5">
            <div class="card-header">
              <div class="card-title">
                สถานที่ทำงาน <span class="text-danger">*</span>
                <span class="text-danger"
                  >กรณีเป็นผู้ตรวจประเมินให้กรอกที่ทำงานในช่องที่อยู่</span
                >
              </div>
              <div class="card-toolbar">
                <!-- <div class="me-2">
                  <label for="emailField" class="form-label"
                    >ค้นหาชื่อสถานที่ทำงาน
                  </label>
                  <input
                    type="text"
                    @change="callFactories()"
                    v-model="search"
                    class="form-control  "
                  />
                </div> -->
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-8">
                  <div class="mb-5">
                    <label for="" class="form-label required"
                      >ประเภทการสมัคร
                    </label>
                    <!-- :disabled="
                        modelEdit.type > 1 &&
                          modelEdit['currentSpecialistStatus'] == 2
                      " -->
                    <el-select
                      v-model="modelMandatory.type"
                      placeholder="กรุณาเลือกประเภทการสมัคร"
                      style="width: 100%;"
                      @change="onMandatoryTypeChange"
                    >
                      <el-option
                        :value="2"
                        label="ผู้รับผิดชอบด้านพลังงานสามัญ"
                      />
                      <el-option
                        :value="3"
                        label="ผู้รับผิดชอบด้านพลังงานอาวุโส"
                      />
                      <el-option :value="4" label="ผู้ตรวจประเมิน BEC" />
                    </el-select>
                  </div>
                  <div class="row mb-5">
                    <div class="mb-10">
                      <label
                        for="emailField"
                        :class="
                          modelMandatory.type == 4
                            ? 'form-label'
                            : 'form-label required'
                        "
                        >ชื่อสถานที่ทำงาน
                        <span
                          v-if="modelMandatory.type != 4"
                          class="text-danger"
                          >กรุณาเลือกสถานที่ทำงานเพื่อดำเนินการต่อเพื่อขออนุมัติภาคบังคับ</span
                        >
                      </label>
                      <div class="d-flex align-items-start gap-2">
                        <el-select
                          class="w-100"
                          v-model="modelMandatory.facId"
                          filterable
                          clearable
                          @change="
                            callFactoriesId();
                            errors2.facId = '';
                          "
                          :filter-method="(val) => callFactories(val)"
                          placeholder="ค้นหาชื่อสถานที่ทำงาน"
                          :disabled="modelMandatory.type == 4"
                        >
                          <el-option
                            v-for="f in factoriesList"
                            :key="f.facId"
                            :value="f.facId"
                            :label="f.tsicId + ' ' + f.factoryName"
                          />
                        </el-select>
                        <!-- <button
                          type="button"
                          class="btn btn-sm btn-default"
                          style="white-space: nowrap;"
                          @click="clearFactory"
                        >
                          ล้างข้อมูล
                        </button> -->
                      </div>
                      <div v-if="errors2.facId" class="text-danger">
                        {{ errors2.facId }}
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="mb-3">
                        <label class="form-label">ชื่อนิติบุคคล</label>
                        <input
                          class="form-control"
                          type="text"
                          :value="(factoryNow && factoryNow.juristicName) || ''"
                          placeholder="-"
                          :disabled="modelMandatory.type == 4"
                        />
                      </div>
                    </div>
                    <div class="col-12 col-md-6">
                      <div class="mb-3">
                        <label class="form-label">TSIC-ID</label>
                        <input
                          class="form-control"
                          type="text"
                          :value="(factoryNow && factoryNow.tsicId) || ''"
                          placeholder="-"
                          :disabled="modelMandatory.type == 4"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <label for="" class="form-label"
                    >เลขที่ผู้รับผิดชอบด้านพลังงาน(ถ้ามี)
                  </label>
                  <div class="mb-5">
                    <label
                      class="form-check form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input "
                        type="checkbox"
                        :checked="modelMandatory.preFactoryNo != ''"
                        value=""
                      />
                      <span class="form-check-label">ผชร.</span>
                      <input
                        type="text"
                        v-model="modelMandatory.preFactoryNo"
                        class="form-control mx-2 "
                      />
                    </label>
                  </div>
                  <div class="mb-5">
                    <label
                      class="form-check form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input"
                        :checked="modelMandatory.preBuildingNo != ''"
                        type="checkbox"
                        value=""
                      />
                      <span class="form-check-label">ผชอ.</span>
                      <input
                        type="text"
                        v-model="modelMandatory.preBuildingNo"
                        class="form-control mx-2 "
                      />
                    </label>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label
                      for="emailField"
                      :class="
                        modelMandatory.type == 4
                          ? 'form-label required'
                          : 'form-label'
                      "
                      >ที่อยู่</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      :class="{ 'is-invalid': errors2.addressNo }"
                      placeholder="ที่อยู่"
                      v-model="factoryNow.addressFac.no"
                      @input="errors2.addressNo = ''"
                    />
                    <div v-if="errors2.addressNo" class="text-danger">
                      {{ errors2.addressNo }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">หมู่</label>
                    <input
                      type="text"
                      class="form-control "
                      placeholder="หมู่"
                      v-model="factoryNow.addressFac.moo"
                      disabled
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">ตรอก/ซอย</label>
                    <input
                      type="text"
                      class="form-control "
                      placeholder="ตรอก/ซอย"
                      v-model="factoryNow.addressFac.soi"
                      disabled
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">ถนน</label>
                    <input
                      type="text"
                      class="form-control "
                      placeholder="ถนน"
                      v-model="factoryNow.addressFac.road"
                      disabled
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">ภาค </label>
                    <input
                      class="form-control  "
                      type="text"
                      v-model="factoryNow.addressFac.regionTh"
                      disabled
                      placeholder="ภาค"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">จังหวัด </label>
                    <input
                      class="form-control  "
                      type="text"
                      v-model="factoryNow.addressFac.provinceTh"
                      disabled
                      placeholder="จังหวัด"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>

                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">อำเภอ </label>
                    <input
                      class="form-control  "
                      type="text"
                      v-model="factoryNow.addressFac.districtTh"
                      disabled
                      placeholder="อำเภอ"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">ตำบล </label>
                    <input
                      class="form-control  "
                      type="text"
                      v-model="factoryNow.addressFac.subDistrictTh"
                      disabled
                      placeholder="ตำบล/แขวง"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>

                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >รหัสไปรษณีย์
                    </label>
                    <input
                      class="form-control  "
                      type="text"
                      v-model="factoryNow.addressFac.zipcode"
                      disabled
                      placeholder="รหัสไปรษณีย์"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <!-- <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >ประเภทของหน่วยงาน
                    </label>
                    <input
                      class="form-control  "
                      type="text"
                      placeholder="ประเภทของหน่วยงาน"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div> -->
              </div>
              <!-- <div class="row">
                <h3>{{ factoryNow.type }}ควบคุม</h3>
                <div class="col-12 col-md-4">
                  <label for="" class="form-label">ประเภทกิจการ </label>
                  <p>
                    <b
                      v-for="(item, index) in factoryBuildingTypesList"
                      :key="index"
                    >
                      <span v-if="item.code == factoryNow.facBuildTypeId">
                        {{ item.name }}</span
                      >
                    </b>
                  </p>
                </div>
              </div> -->
              <div class="row" v-if="factoryNow && factoryNow.type">
                <h3>{{ factoryNow.type }}ควบคุม</h3>
                <div class="col-12 col-md-6">
                  <label for="" class="form-label">ประเภทกิจการ </label>
                  <div class="row">
                    <div
                      class="col-12 col-md-6"
                      v-for="(item, index) in factoryBuildingTypesList"
                      :key="index"
                    >
                      <div class="mb-5">
                        <label
                          class="form-check form-check-custom form-check-solid"
                        >
                          <input
                            class="form-check-input "
                            disabled
                            type="checkbox"
                            v-model="modelMandatory.facBuildTypeId"
                            :value="item.code"
                          />
                          <span class="form-check-label">{{ item.name }}</span>

                          <input
                            v-if="item.flgOther == true"
                            type="text"
                            :disabled="
                              modelMandatory.factoryTypes &&
                              modelMandatory.factoryTypes.indexOf('10') > -1
                                ? false
                                : true
                            "
                            v-model="modelMandatory.factoryTypeOther"
                            class="form-control mx-2 "
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="row">
                <h3>อาคารควบคุม</h3>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label">ขนาดอาคาร</label>
                    <el-select
                      class="w-100"
                      v-model="modelMandatory.buildingSizeId"
                      filterable
                      placeholder="กรุณาเลือกขนาดอาคาร"
                    >
                      <el-option
                        v-for="b in buildingSizesList"
                        :key="b.id"
                        :value="b.code"
                        :label="b.name"
                      />
                    </el-select>
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <label for="" class="form-label">ประเภทอาคาร </label>
                  <div class="row">
                    <div
                      class="col-12 col-md-6"
                      v-for="(item, index) in buildingTypesList"
                      :key="index"
                    >
                      <div class="mb-5">
                        <label
                          class="form-check form-check-custom form-check-solid"
                        >
                          <input
                            class="form-check-input "
                            disabled
                            type="checkbox"
                            v-model="modelMandatory.buildingTypes"
                            :value="item.code"
                          />
                          <span class="form-check-label">{{ item.name }}</span>
                          <input
                            v-if="item.flgOther == true"
                            type="text"
                            :disabled="
                              modelMandatory.buildingTypes.indexOf('6') > -1
                                ? false
                                : true
                            "
                            v-model="modelMandatory.buildingTypeOther"
                            class="form-control mx-2 "
                          />
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <div class="card mb-5">
            <div class="card-header">
              <div class="card-title">
                คุณวุฒิการศึกษาของผู้สมัคร
              </div>
            </div>
            <div class="card-body">
              <div v-if="modelMandatory.type == 4" class="mb-5">
                <label class="form-label required">ประเภทใบประกอบวิชาชีพ</label>
                <div class="d-flex flex-column gap-3">
                  <label class="d-flex align-items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      v-model="modelMandatory.becProfType"
                      value="1"
                      class="form-check-input mt-0"
                      @change="errors2.becProfType = ''"
                    />
                    <span>ผู้ประกอบวิชาชีพวิศวกรรมควบคุม (กว.)</span>
                  </label>
                  <label class="d-flex align-items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      v-model="modelMandatory.becProfType"
                      value="2"
                      class="form-check-input mt-0"
                      @change="errors2.becProfType = ''"
                    />
                    <span>ผู้ประกอบวิชาชีพสถาปัตยกรรมควบคุม (สถ.)</span>
                  </label>
                </div>
                <div v-if="errors2.becProfType" class="text-danger">
                  {{ errors2.becProfType }}
                </div>
              </div>
              <label for="" class="form-label"
                >วุฒิการศึกษาตามคุณสมบัติของหลักสูตร (แนบไฟล์ 3 ไฟล์)
              </label>
              <div class="my-5">
                {{ modelMandatory.fileMultiple }}
                <div
                  v-if="
                    modelMandatory.qualificationImage &&
                      modelMandatory.qualificationImage.length > 0
                  "
                  style="border: 1px dashed #C4C4C4;
                      border-radius: 5px;height: 300px;display: flex;
                      flex-wrap: wrap;
                      flex-direction: row;
                      align-items: center;
                      justify-content: space-around;"
                >
                  <div
                    v-for="(item, index) in modelMandatory.qualificationImage"
                    :key="index"
                  >
                    <a :href="item" target="_blank">
                      <img :src="item" alt="" class="w-200 h-200px" />
                    </a>
                  </div>
                </div>
                <div
                  v-else
                  style="border: 1px dashed #C4C4C4;
                      border-radius: 5px;width: 350px; height: 300px;display: flex;
                      justify-content: center;
                      align-items: center;"
                >
                  <i class="fa fa-image fa-10x"></i>
                </div>
                <button
                  @click="fileMultipleClick"
                  type="button"
                  class="btn btn-sm my-2"
                  style="background: #DDEEFE;
                        border-radius: 6px;"
                >
                  <i class="fa fa-link"></i> Browse
                </button>
                <input
                  type="file"
                  ref="fileMultiple"
                  multiple
                  accept="image/*"
                  v-on:change="onFileChangeMultiple($event)"
                  hidden
                />
              </div>
              <div class="my-5">
                <label for="" class="form-label">รูปหน้าตรง 1 รูป </label>
                <!-- {{ modelMandatory.qualificationAvatar }} -->
                <div
                  v-if="modelMandatory.faceImage"
                  style="border: 1px dashed #C4C4C4;
                      border-radius: 5px;width: 350px; height: 300px;display: flex;
                      justify-content: center;
                      align-items: center;"
                >
                  <img
                    :src="modelMandatory.faceImage"
                    alt=""
                    class="w-250px h-250px"
                    style="object-fit: cover;border-radius: 10px;"
                  />
                </div>
                <div
                  v-else
                  style="border: 1px dashed #C4C4C4;
                      border-radius: 5px;width: 350px; height: 300px;display: flex;
                      justify-content: center;
                      align-items: center;"
                >
                  <i class="fa fa-user fa-10x"></i>
                </div>
                <div v-if="errors2.faceImage" class="text-danger">
                  {{ errors2.faceImage }}
                </div>
                <button
                  @click="fileAvatarClick"
                  type="button"
                  class="btn btn-sm my-2"
                  style="background: #DDEEFE;
                          border-radius: 6px;"
                >
                  <i class="fa fa-link"></i> Browse
                </button>
                <input
                  type="file"
                  ref="fileAvatar"
                  accept="image/*"
                  v-on:change="onFileChangeAvatar($event)"
                  hidden
                />
              </div>
              <div class="my-5" v-if="modelMandatory.type == 4">
                <label for="" class="form-label required"
                  >ใบประกอบวิชาชีพ
                </label>
                <div
                  v-if="modelMandatory.cerImagePreview"
                  style="border: 1px dashed #C4C4C4;border-radius: 5px;width: 350px;height: 300px;display: flex;justify-content: center;align-items: center;"
                >
                  <img
                    :src="modelMandatory.cerImagePreview"
                    alt=""
                    class="w-250px h-250px"
                    style="object-fit: cover;border-radius: 10px;"
                  />
                </div>
                <div
                  v-else
                  style="border: 1px dashed #C4C4C4;border-radius: 5px;width: 350px;height: 300px;display: flex;justify-content: center;align-items: center;"
                >
                  <i class="fa fa-file-image fa-10x"></i>
                </div>
                <button
                  @click="fileCerImageClick"
                  type="button"
                  class="btn btn-sm my-2"
                  style="background: #DDEEFE;border-radius: 6px;"
                >
                  <i class="fa fa-link"></i> Browse
                </button>
                <input
                  type="file"
                  ref="fileCerImage"
                  accept="image/*"
                  v-on:change="
                    onFileChangeCerImage($event);
                    errors2.cerImage = '';
                  "
                  hidden
                />
                <div v-if="errors2.cerImage" class="text-danger">
                  {{ errors2.cerImage }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="info_3" role="tabpanel">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                ข้อมูลจำเพาะของสถานประกอบการ
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >ปริมาณการใช้พลังงานไฟฟ้า</label
                    >
                    <div class="input-group mb-5">
                      <input
                        type="text"
                        v-model="modelMandatory.companyElectric"
                        class="form-control"
                        placeholder="ปริมาณการใช้พลังงานไฟฟ้า"
                      />
                      <span class="input-group-text">หน่วยต่อปี</span>
                    </div>

                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >หม้อแปลงไฟฟ้ารวม</label
                    >
                    <div class="input-group mb-5">
                      <input
                        type="text"
                        v-model="modelMandatory.companyTransformer"
                        class="form-control"
                        placeholder="หม้อแปลงไฟฟ้ารวม"
                      />
                      <span class="input-group-text">kVA</span>
                    </div>
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >ปริมาณการใช้พลังงานความร้อน</label
                    >
                    <div class="input-group mb-5">
                      <input
                        type="text"
                        v-model="modelMandatory.companyHeat"
                        class="form-control"
                        placeholder="ปริมาณการใช้พลังงานความร้อน"
                      />
                      <span class="input-group-text">MMJ/ปี</span>
                    </div>
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >ประเภทเชื้อเพลิงที่ใช้เป็นหลัก</label
                    >
                    <input
                      class="form-control  "
                      type="text"
                      placeholder="ประเภทเชื้อเพลิงที่ใช้เป็นหลัก"
                      v-model="modelMandatory.companyFuel"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
              </div>
              <div class="row">
                <label for="emailField" class="form-label"
                  >เครื่องจักรอุปกรณ์หลัก
                </label>
                <div
                  class="col-12 col-md-4"
                  v-for="(item, index) in machinesList"
                  :key="index"
                >
                  <div class="mb-5">
                    <label
                      class="form-check form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input "
                        type="checkbox"
                        v-model="modelMandatory.machines"
                        :value="item.code"
                      />
                      <span class="form-check-label">{{ item.name }}</span>
                      <input
                        v-if="item.flgOther == true"
                        type="text"
                        :disabled="
                          modelMandatory.machines &&
                          modelMandatory.machines.indexOf('6') > -1
                            ? false
                            : true
                        "
                        v-model="modelMandatory.machineOther"
                        class="form-control mx-2 "
                      />
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <label for="emailField" class="form-label"
                  >เทคโนโลยีประสิทธิภาพสูง
                </label>
                <div
                  class="col-12 col-md-4"
                  v-for="(item, index) in technologiesList"
                  :key="index"
                >
                  <div class="mb-5">
                    <label
                      class="form-check form-check-custom form-check-solid"
                    >
                      <input
                        class="form-check-input "
                        type="checkbox"
                        v-model="modelMandatory.technologies"
                        :value="item.code"
                      />
                      <span class="form-check-label">{{ item.name }}</span>
                      <input
                        v-if="item.flgOther == true"
                        type="text"
                        :disabled="
                          modelMandatory.technologies &&
                          modelMandatory.technologies.indexOf('6') > -1
                            ? false
                            : true
                        "
                        v-model="modelMandatory.technologieOther"
                        class="form-control mx-2 "
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="info_4" role="tabpanel">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                สำหรับผู้รับรอง
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >ชื่อผู้รับรอง</label
                    >
                    <input
                      class="form-control  "
                      type="text"
                      placeholder=""
                      v-model="modelMandatory.warrantorFirstname"
                      name="officePosition"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >นามสกุลผู้รับรอง</label
                    >
                    <input
                      class="form-control  "
                      type="text"
                      placeholder=""
                      v-model="modelMandatory.warrantorLastname"
                      name="officePosition"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >ตำแหน่งผู้รับรอง</label
                    >
                    <input
                      class="form-control  "
                      type="text"
                      placeholder=""
                      v-model="modelMandatory.warrantorPosition"
                      name="officePosition"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
                <div class="col-12 col-md-4">
                  <div class="mb-10">
                    <label for="emailField" class="form-label"
                      >ชื่อสถานที่ทำงาน (ชื่อตามนิติบุคคล)</label
                    >
                    <input
                      class="form-control  "
                      type="text"
                      placeholder=""
                      v-model="modelMandatory.warrantorOffice"
                      name="officePosition"
                      autocomplete="off"
                    />
                    <span class="text-danger"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- คอร์ส -->
    <div
      :class="tab == 2 ? 'tab-pane fade  active show' : 'tab-pane fade'"
      id="kt_tab_pane_2"
      role="tabpanel"
    >
      <div class="card mb-5">
        <!-- <div class="card-header">
          <div class="card-title">
            คอร์ส
          </div>
        </div> -->
        <div class="card-body">
          <div
            class="row mb-5"
            style="padding: 2vh;"
            v-if="myCourseList && myCourseList.length > 0"
          >
            <div
              class="col-12 col-md-6 col-lg-4 mb-3 d-flex"
              v-for="(item, index) in myCourseList"
              :key="index"
            >
              <div v-if="item.progressUpdate == 100" class="w-100 d-flex">
                <div
                  class="card box-item d-flex flex-column w-100"
                  style="border-radius: 10px;position: relative;border: 1px solid #E9E9EF;"
                >
                  <img
                    :src="
                      item.courseProfile
                        ? imageUrl + item.courseProfile.thumbnailsPath
                        : ''
                    "
                    @error="setAltImgCover"
                    alt=""
                    class="w-100"
                    style="border-top-left-radius: 10px;
                          border-top-right-radius: 10px;
                          height: 220px;
                          object-fit: cover;"
                  />
                  <div class="card-body flex-grow-1" style="min-height: 153px">
                    <div
                      class="mb-5 limit-text text-title"
                      style="font-weight: 700;
                line-height: 30px;
                color: #323563 !important;"
                    >
                      <router-link
                        :to="
                          '/course/voluntary/' +
                            (item.courseProfile ? item.courseProfile.id : null)
                        "
                      >
                        {{ item.courseProfile && item.courseProfile.title }}
                      </router-link>
                    </div>
                    <div class="d-flex justify-content-between flex-wrap">
                      <Rating :value="item.rate ? item.rate.avg : 0" :max="5" />
                      <a
                        href="#"
                        v-if="!item.rate && item.progressUpdate == 100"
                        class="btn"
                        data-bs-toggle="modal"
                        data-bs-target="#kt_modal_score"
                        @click="setId(item.id)"
                        style="border-radius: 100px; border: 1px solid var(--323563, #323563); background: #FFF;"
                        >ให้คะแนน</a
                      >
                    </div>
                    <!-- <div
                      class="mb-5 limit-text"
                      style="font-weight: 400;
                color: #9F9F9F;"
                      v-html="
                        removeStyle(
                          item.courseProfile
                            ? item.courseProfile.description
                            : '-'
                        )
                      "
                    ></div> -->
                  </div>
                  <div class="card-footer mt-auto">
                    <div
                      class="d-flex align-items-center flex-column mt-3 w-100"
                      v-if="item.progressUpdate != 100"
                    >
                      <div
                        class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
                      >
                        <span style="font-weight: 600;"
                          >สถานะ :
                          <span v-html="renderStatus(item.status)"></span
                        ></span>
                        <span>{{ item.progressUpdate }}%</span>
                      </div>
                      <div
                        class="h-8px mx-3 w-100 rounded"
                        style="background:#E1F2FF"
                      >
                        <div
                          class="bg-progressbar rounded h-8px"
                          data-bs-toggle="tooltip"
                          :title="item.progressUpdate + '%'"
                          role="progressbar"
                          :style="'width: ' + item.progressUpdate + '%'"
                          aria-valuenow="50"
                          aria-valuemin="0"
                          aria-valuemax="100"
                        ></div>
                      </div>
                    </div>
                    <div v-else class="d-flex justify-content-center">
                      <!-- <router-link
                        v-if="item.progressUpdate == 100"
                        to=""
                        type="button"
                        class="btn text-btn"
                        style="border-radius: 21px;background: #31B67C;color: #FFF;"
                      >
                        ดาวน์โหลดใบรับรอง
                      </router-link> -->
                      <!-- :disabled="item.courseProfile && !item.courseProfile.flgCertEnable"  -->
                      <button
                        type="button"
                        v-if="item.progressUpdate == 100"
                        class="btn text-btn"
                        @click="getCertificateId(item.id)"
                        style="border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;"
                        :style="
                          item.courseProfile &&
                          !item.courseProfile.flgCertEnable
                            ? 'border-radius: 21px;background: #E1E1E1;color: #999;min-width: 235px;pointer-events: none;'
                            : 'border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;'
                        "
                      >
                        ดาวน์โหลดใบรับรอง
                      </button>
                      <router-link
                        v-else
                        :to="'/course/voluntary/' + item.id"
                        type="button"
                        class="btn btn-register2 text-btn"
                      >
                        ลงทะเบียน
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="w-100 d-flex">
                <router-link
                  class="w-100 d-flex text-decoration-none"
                  :to="
                    '/course/voluntary/' +
                      (item.courseProfile ? item.courseProfile.id : null)
                  "
                >
                  <div
                    class="card box-item d-flex flex-column w-100"
                    style="border-radius: 10px;position: relative;border: 1px solid #E9E9EF;"
                  >
                    <img
                      :src="
                        item.courseProfile
                          ? imageUrl + item.courseProfile.thumbnailsPath
                          : ''
                      "
                      @error="setAltImgCover"
                      alt=""
                      class="w-100"
                      style="border-top-left-radius: 10px;
                          border-top-right-radius: 10px;
                          height: 220px;
                          object-fit: cover;"
                    />
                    <div
                      class="card-body flex-grow-1"
                      style="min-height: 153px"
                    >
                      <div
                        class="mb-5 limit-text text-title"
                        style="font-weight: 700;
                line-height: 30px;
                color: #323563 !important;"
                      >
                        {{ item.courseProfile && item.courseProfile.title }}
                      </div>
                      <div class="d-flex justify-content-between flex-wrap">
                        <Rating
                          :value="item.rate ? item.rate.avg : 0"
                          :max="5"
                        />
                        <a
                          href="#"
                          v-if="!item.rate && item.progressUpdate == 100"
                          class="btn"
                          data-bs-toggle="modal"
                          data-bs-target="#kt_modal_score"
                          @click="setId(item.id)"
                          style="border-radius: 100px; border: 1px solid var(--323563, #323563); background: #FFF;"
                          >ให้คะแนน</a
                        >
                      </div>
                      <!-- <div
                      class="mb-5 limit-text"
                      style="font-weight: 400;
                color: #9F9F9F;"
                      v-html="
                        removeStyle(
                          item.courseProfile
                            ? item.courseProfile.description
                            : '-'
                        )
                      "
                    ></div> -->
                    </div>
                    <div class="card-footer">
                      <div
                        class="d-flex align-items-center flex-column mt-3 w-100"
                        v-if="item.progressUpdate != 100"
                      >
                        <div
                          class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
                        >
                          <span style="font-weight: 600;"
                            >สถานะ :
                            <span v-html="renderStatus(item.status)"></span
                          ></span>
                          <span>{{ item.progressUpdate }}%</span>
                        </div>
                        <div
                          class="h-8px mx-3 w-100 rounded"
                          style="background:#E1F2FF"
                        >
                          <div
                            class="bg-progressbar rounded h-8px"
                            data-bs-toggle="tooltip"
                            :title="item.progressUpdate + '%'"
                            role="progressbar"
                            :style="'width: ' + item.progressUpdate + '%'"
                            aria-valuenow="50"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                      <div
                        v-else
                        style="display: flex;justify-content: center;"
                      >
                        <!-- <router-link
                        v-if="item.progressUpdate == 100"
                        to=""
                        type="button"
                        class="btn text-btn"
                        style="border-radius: 21px;background: #31B67C;color: #FFF;"
                      >
                        ดาวน์โหลดใบรับรอง
                      </router-link> -->
                        <!-- :disabled="item.courseProfile && !item.courseProfile.flgCertEnable" -->

                        <button
                          type="button"
                          v-if="item.progressUpdate == 100"
                          class="btn text-btn"
                          @click="getCertificateId(item.id)"
                          style="border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;"
                          :style="
                            item.courseProfile &&
                            !item.courseProfile.flgCertEnable
                              ? 'border-radius: 21px;background: #E1E1E1;color: #999;min-width: 235px;pointer-events: none;'
                              : 'border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;'
                          "
                        >
                          ดาวน์โหลดใบรับรอง
                        </button>
                        <router-link
                          v-else
                          :to="'/course/voluntary/' + item.id"
                          type="button"
                          class="btn btn-register2 text-btn"
                        >
                          ลงทะเบียน
                        </router-link>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class=" row mb-5" v-else>
            <img
              src="media/image-app/no-data.svg"
              alt=""
              style="height:300px"
            />
          </div>
          <div>
            <el-select
              v-model="limit"
              class="m-2 limit"
              placeholder="Select"
              size="large"
              style="width: 100px; border-radius: 30px"
              @change="searchData"
            >
              <el-option value="12" label="12"></el-option>
              <el-option value="24" label="24"></el-option>
              <el-option value="60" label="60"></el-option>
              <el-option value="80" label="80"></el-option>
              <el-option value="100" label="100"></el-option>
            </el-select>
            จำนวนทั้งหมด {{ myCourseList && myCourseList.totalElements }} รายการ
          </div>
          <ul class="pagination">
            <!-- <li :class="'page-item first ' + (page == 0 ? 'disabled' : '')">
              <button type="button" @click="changePage(1)" class="page-link">
                <i class="previous"></i
                ><i class="previous" style="opacity: 0.5;"></i>
              </button>
            </li> -->
            <li :class="'page-item previous ' + (page == 0 ? 'disabled' : '')">
              <button type="button" @click="backPage()" class="page-link">
                <i class="previous"></i>
              </button>
            </li>
            <div v-for="(item, index) in totalPage" :key="index">
              <li
                v-if="
                  (index > page - 5 && index < page + 5) ||
                    index === totalPage.length - 1
                "
                :class="'page-item ' + (index === page ? 'active' : '')"
              >
                <button
                  type="button"
                  @click="changePage(item)"
                  class="page-link"
                >
                  {{ item }}
                </button>
              </li>
              <li v-else-if="index === 6">
                <span class="page-link">...</span>
              </li>
            </div>
            <li
              :class="
                'page-item next ' + (page + 1 == totalPage ? 'disabled' : '')
              "
            >
              <button type="button" @click="nextPage()" class="page-link">
                <i class="next"></i>
              </button>
            </li>
            <!-- <li
              :class="
                'page-item last ' + (page + 1 == totalPage ? 'disabled' : '')
              "
            >
              <button
                type="button"
                @click="changePage(totalPage)"
                class="page-link"
              >
                <i class="next" style="opacity: 0.5;"></i><i class="next"></i>
              </button>
            </li> -->
          </ul>
        </div>
      </div>
    </div>
    <!-- หลักสูตร -->
    <div
      :class="tab == 3 ? 'tab-pane fade  active show' : 'tab-pane fade'"
      id="kt_tab_pane_3"
      role="tabpanel"
    >
      <div class="card">
        <!-- <div class="card-header">
          <div class="card-title">
            ใบรับรอง
          </div>
        </div> -->
        <div class="card-body">
          <div
            class="row mb-5"
            style="padding: 2vh;"
            v-if="syllabusList && syllabusList.length > 0"
          >
            <div
              class="col-12 col-lg-4 mb-3 d-flex"
              v-for="(item, index) in syllabusList"
              :key="index"
            >
              <div class="w-100 d-flex">
                <!-- ถ้าเรียนจบแล้ว + ได้ใบรับรอง -->
                <!-- item.progressUpdate == 100 &&  -->
                <div
                  v-if="item.certStatus == 2"
                  class="card box-item d-flex flex-column w-100"
                  style="border-radius: 10px;position: relative;border: 1px solid #E9E9EF;"
                >
                  <img
                    :src="
                      item.syllabusProfile
                        ? imageUrl + item.syllabusProfile.thumbnailsPath
                        : ''
                    "
                    @error="setAltImgCover"
                    alt=""
                    class="w-100"
                    style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 220px;
            object-fit: cover;"
                  />

                  <div class="card-body flex-grow-1">
                    <div class="mb-5 limit-text text-title">
                      <router-link
                        :to="'/course/mandatory-list/' + item.syllabusId"
                      >
                        {{ item.syllabusProfile && item.syllabusProfile.name }}
                      </router-link>
                    </div>

                    <div class="mb-5 text-subtitle"></div>
                  </div>

                  <div class="card-footer">
                    <div style="display: flex; justify-content: center;">
                      <!-- :disabled="item.syllabusProfile && !item.syllabusProfile.flgCertEnable" -->

                      <button
                        type="button"
                        class="btn text-btn"
                        style="border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;"
                        @click="getCertificateSyllabusId(item.id)"
                        :style="
                          item.syllabusProfile &&
                          !item.syllabusProfile.flgCertEnable
                            ? 'border-radius: 21px;background: #E1E1E1;color: #999;min-width: 235px;pointer-events: none;'
                            : 'border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;'
                        "
                      >
                        ดาวน์โหลดใบรับรอง
                      </button>
                    </div>
                  </div>
                </div>
                <div v-else-if="item.certStatus == 1" class="w-100 d-flex">
                  <div
                    class="card box-item d-flex flex-column w-100"
                    style="border-radius: 10px;position: relative;border: 1px solid #E9E9EF;"
                  >
                    <img
                      :src="
                        item.syllabusProfile
                          ? imageUrl + item.syllabusProfile.thumbnailsPath
                          : ''
                      "
                      @error="setAltImgCover"
                      alt=""
                      class="w-100"
                      style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 220px;
            object-fit: cover;"
                    />

                    <div class="card-body flex-grow-1">
                      <div class="mb-5 limit-text text-title">
                        {{ item.syllabusProfile && item.syllabusProfile.name }}
                      </div>

                      <div class="mb-5 text-subtitle"></div>
                    </div>

                    <div class="card-footer">
                      <div style="display: flex; justify-content: center;">
                        <button
                          class="btn"
                          style="background: #FFC700;color:#fff;border-radius: 21px;"
                        >
                          รออนุมัติใบรับรอง
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- การ์ดปกติ -->
                <router-link
                  v-else
                  :to="'/course/mandatory-list/' + item.syllabusId"
                  class="w-100 d-flex"
                  style="text-decoration: none;"
                >
                  <div
                    class="card box-item d-flex flex-column w-100"
                    style="border-radius: 10px;position: relative;border: 1px solid #E9E9EF;"
                  >
                    <img
                      :src="
                        item.syllabusProfile
                          ? imageUrl + item.syllabusProfile.thumbnailsPath
                          : ''
                      "
                      @error="setAltImgCover"
                      alt=""
                      class="w-100"
                      style="border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            height: 220px;
            object-fit: cover;"
                    />

                    <div class="card-body flex-grow-1">
                      <div class="mb-5 limit-text text-title">
                        {{ item.syllabusProfile && item.syllabusProfile.name }}
                      </div>

                      <div class="mb-5 text-subtitle"></div>
                    </div>

                    <div class="card-footer">
                      <!-- progress -->
                      <div
                        class="d-flex align-items-center flex-column mt-3 w-100"
                        v-if="item.progressUpdate != 100"
                      >
                        <div
                          class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
                        >
                          <span>ความก้าวหน้า </span>
                          <span>{{ item.progressUpdate }}%</span>
                        </div>
                        <div
                          class="h-8px mx-3 w-100 rounded"
                          style="background:#E1F2FF"
                        >
                          <div
                            class="bg-progressbar rounded h-8px"
                            data-bs-toggle="tooltip"
                            :title="item.progressUpdate + '%'"
                            role="progressbar"
                            :style="'width: ' + item.progressUpdate + '%'"
                            aria-valuenow="50"
                            aria-valuemin="0"
                            aria-valuemax="100"
                          ></div>
                        </div>
                      </div>
                      <!-- status button -->
                      <div v-else class="btn-center">
                        <!-- :disabled="item.syllabusProfile && !item.syllabusProfile.flgCertEnable" -->

                        <button
                          type="button"
                          v-if="
                            item.progressUpdate == 100 && item.certStatus == 2
                          "
                          class="btn text-btn btn-cert"
                          @click.prevent="getCertificateSyllabusId(item.id)"
                          :style="
                            item.syllabusProfile &&
                            !item.syllabusProfile.flgCertEnable
                              ? 'border-radius: 21px;background: #E1E1E1;color: #999;min-width: 235px;pointer-events: none;'
                              : 'border-radius: 21px;background: #31B67C;color: #FFF;min-width: 235px;'
                          "
                        >
                          ดาวน์โหลดใบรับรอง
                        </button>

                        <a
                          href="#"
                          v-else-if="
                            item.progressUpdate == 100 && item.certStatus == 1
                          "
                          class="btn text-btn btn-wait-approve"
                          @click.prevent
                        >
                          รออนุมัติ
                        </a>

                        <a
                          href="#"
                          v-else
                          class="btn btn-secondary text-btn btn-wait-exam"
                          @click.prevent
                        >
                          รอสอบ
                        </a>
                      </div>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
          <div class=" row mb-5" v-else>
            <img
              src="media/image-app/no-data.svg"
              alt=""
              style="height:300px"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="kt_tab_pane_4" role="tabpanel">
      <div class="card">
        <div class="card-header">
          <div class="card-title">
            บุคมาร์ค
          </div>
        </div>
        <div class="card-body">
          <div class="mb-5" style="border-bottom: 1px solid #dfd3d3;">
            <h4>หลักสูตรผู้รับผิดชอบด้านพลังงานโรงงานควบคุม</h4>
            <div
              class="mb-3"
              style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;"
            >
              <div class="w-50">
                <div class="d-flex align-items-center flex-column mt-3 w-100">
                  <div
                    class="d-flex justify-content-between fw-bold fs-6 text-dark w-100 mt-auto mb-2"
                  >
                    <span>ความก้าวหน้า</span>
                    <span>34%</span>
                  </div>
                  <div
                    class="h-8px mx-3 w-100 rounded"
                    style="background:#E1F2FF"
                  >
                    <div
                      class="bg-progressbar rounded h-8px"
                      data-bs-toggle="tooltip"
                      title="37%"
                      role="progressbar"
                      style="width: 37%"
                      aria-valuenow="50"
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>

                <br />
                <span class="mx-2">วันที่บันทึก : 17 มิถุนายน 2563</span>
              </div>

              <div>
                <button
                  class="btn mx-2"
                  style="background: #FFEBEB;
                        color: #FF7786;
                        border-radius: 6px;"
                >
                  <i class="fa fa-trash" style="color: #FF7786;"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
      <div class="card">
        <div class="card-header">
          <div class="card-title text-category">
            นโยบายความเป็นส่วนตัว
          </div>
        </div>
        <div class="card-body text-category">
          <div>
            <h1>
              นโยบายเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน Website
              Policy of Department of Alternative Energy Development and
              Efficiency จัดทำเมื่อวันที่ 15 กันยายน 2557
            </h1>
            <p>
              <b
                >1. วัตถุประสงค์
                กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานจัดทำเว็บไซต์ขึ้นเพื่อให้บริการ
                ข้อมูลข่าวสารแก่ประชาชนทั่วไป
                และบุคลากรในสังกัดกรมพัฒนาพลังงานทดแทนและอนุรักษ์ พลังงาน
                ในการใช้บริการเว็บไซต์ของผู้ใช้บริการจะอยู่ภายใต้เงื่อนไขและข้อกำหนดดังต่อไปนี้
                ผู้ใช้บริการจึงควรศึกษาเงื่อนไข
                และข้อกำหนดการใช้งานเว็บไซต์และ/หรือเงื่อนไขและข้อตกลง
                อื่นใดที่กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานได้แจ้งให้ทราบบนเว็บไซต์โดยละเอียด
                ก่อนการเข้าใช้บริการ
                ทั้งนี้ในการใช้บริการให้ถือว่าผู้ใช้บริการได้ตกลงที่จะปฏิบัติตามเงื่อนไข
                และข้อกำหนดการให้บริการที่กำหนดไว้นี้หากผู้ใช้บริการไม่ประสงค์ที่จะผูกพันตามข้อกำหนด
                และเงื่อนไขการให้บริการ
                ขอความกรุณาท่านยุติการเข้าชมและใช้งานเว็บไซต์นี้ในทันที</b
              >
            </p>
            <p>
              <b>2. เงื่อนไขและข้อกำหนดการใช้งานเว็บไซต์</b>
              <br />2.1 ผู้ใช้บริการอาจได้รับ เข้าถึง สร้าง ส่งหรือแสดงข้อมูล
              เช่น ไฟล์ข้อมูล ข้อความ ลายลักษณ์อักษร
              ซอฟต์แวร์คอมพิวเตอร์ดนตรีไฟล์เสียง หรือเสียงอื่นๆ ภาพถ่าย วิดีโอ
              หรือรูปภาพอื่นๆ โดยเป็นส่วนหนึ่งของบริการหรือโดยผ่านการใช้บริการ
              ซึ่งต่อไปนี้จะ เรียกว่า “เนื้อหา” <br />
              2.2 เนื้อหาที่นำเสนอต่อผู้ใช้บริการ
              อาจได้รับการคุ้มครองโดยสิทธิในทรัพย์สิน
              ทางปัญญาของเจ้าของเนื้อหานั้น
              ผู้ใช้บริการไม่มีสิทธิเปลี่ยนแปลงแก้ไข จำหน่ายจ่ายโอนหรือ
              สร้างผลงานต่อเนื่อง
              โดยอาศัยเนื้อหาดังกล่าวไม่ว่าจะทั้งหมดหรือบางส่วน
              เว้นแต่ผู้ใช้บริการจะ ได้รับอนุญาตโดยชัดแจ้ง จากเจ้าของเนื้อหานั้น
              <br />
              2.3 ผู้ใช้บริการอาจพบเนื้อหาที่ไม่เหมาะสม หรือหยาบคาย
              อันก่อให้เกิดความ ไม่พอใจ ภายใต้ความเสี่ยงของตนเอง
              <br />
              2.4 กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานทรงไว้ซึ่งสิทธิในการ
              คัดกรอง ตรวจทาน ทำเครื่องหมาย เปลี่ยนแปลง แก้ไข ปฏิเสธ
              หรือลบเนื้อหาใดๆ ที่ไม่ เหมาะสมออกจากบริการ
              ซึ่งกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานอาจจัดเตรียม 2
              เครื่องมือในการคัดกรองเนื้อหาอย่างชัดเจน โดยไม่ขัดต่อกฎหมาย
              กฎระเบียบของทางราชการที่ เกี่ยวข้อง <br />
              2.5 เว็บไซต์นี้อาจหยุดให้บริการเป็นการชั่วคราวหรือถาวร
              หรือยกเลิกการ ให้บริการ แก่ผู้ใช้บริการรายใดเป็นการเฉพาะ
              หากการให้บริการดังกล่าวส่งผลกระทบต่อ ผู้ใช้บริการอื่นๆ
              หรือขัดแย้งต่อกฎหมาย โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
              <br />
              2.6 การหยุดหรือการยกเลิกบริการตามข้อ <br />2.5
              ผู้ใช้บริการจะไม่สามารถเข้าใช้ บริการ
              และเข้าถึงรายละเอียดบัญชีของผู้ใช้บริการ ไฟล์เอกสารใดๆ
              หรือเนื้อหาอื่นๆ ที่อยู่ใน บัญชีของผู้ใช้บริการได้<br />
              2.7 ในกรณีที่เว็บไซต์นี้หยุดให้บริการเป็นการถาวร
              หรือยกเลิกบริการแก่ ผู้ใช้บริการ
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานมีสิทธิในการลบข้อมูลต่างๆ
              ที่อยู่ใน
              บัญชีของผู้ใช้บริการได้โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
            </p>
            <p>
              <b>3. สิทธิหน้าที่และความรับผิดชอบของผู้ใช้บริการ</b> <br />3.1
              ผู้ใช้บ ริการจะให้ข้อมูลเกี่ยวกับตนเอง เช่น ข้อมูลระบุตัวตนหรือ
              รายละเอียดการติดต่อ ที่ถูกต้อง เป็นจริง และเป็นปัจจุบันเสมอ
              แก่เว็บไซต์อันเป็นส่วนหนึ่งของ กระบวนการลงทะเบียนใช้บริการ
              หรือการใช้บริการที่ต่อเนื่อง <br />3.2
              ผู้ใช้บริการจะใช้บริการเว็บไซต์นี้เพื่อวัตถุประสงค์ที่ได้รับอนุญาตตาม
              ข้อกำหนดของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              และไม่ขัดต่อกฎหมาย กฎ ระเบียบ ข้อบังคับ
              หลักปฏิบัติที่เป็นที่ยอมรับโดยทั่วไป <br />3.3
              ผู้ใช้บริการจะไม่เข้าใช้หรือพยายามเข้าใช้บริการหนึ่งบริการใดโดยวิธีอื่น
              รวมถึง การใช้วิธีการอัตโนมัติ(การใช้สคริปต์)
              นอกจากช่องทางที่กรมพัฒนาพลังงานทดแทน
              และอนุรักษ์พลังงานจัดเตรียมไว้ให้เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตจากกรมพัฒนาพลังงาน
              ทดแทนและอนุรักษ์พลังงาน โดยชัดแจ้งให้ทำเช่นนั้นได้ <br />3.4
              ผู้ใช้บริการจะไม่ทำหรือมีส่วนร่วมในการขัดขวางหรือรบกวนบริการของ
              เว็บไซต์รวมทั้งเครื่องแม่ข่ายและเครือข่ายที่เชื่อมต่อกับบริการ
              <br />3.5 ผู้ใช้บริการจะไม่ทำสำเนา คัดลอก ทำซ้ำ ขาย แลกเปลี่ยน
              หรือขายต่อ บริการ เพื่อวัตถุประสงค์ใดๆ
              เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตจากกรมพัฒนาพลังงานทดแทน
              และอนุรักษ์พลังงาน โดยชัดแจ้งให้ทำเช่นนั้นได้ <br />3 3.6
              ผู้ใช้บริการมีหน้าที่ในการรักษาความลับของรหัสผ่านที่เชื่อมโยงกับบัญชีใดๆ
              ที่ใช้ในการเข้าถึงบริการ <br />3.7
              ผู้ใช้บริการจะเป็นผู้รับผิดชอบแต่เพียงผู้เดียวต่อบุคคลใดๆ รวมถึง
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              ในความเสียหายอันเกิดจากการละเมิด ข้อกำหนด
            </p>
            <p>
              <b>4. การเชื่อมโยงกับเว็บไซต์อื่นๆ</b> <br />4.1
              การเชื่อมโยงไปยังเว็บไซต์อื่นเป็นเพียงการให้บริการเพื่ออำนวยความ
              สะดวก แก่ผู้ใช้บริการเท่านั้น
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานมิได้มีส่วน เกี่ยวข้อง
              หรือมีอำนาจควบคุม รับรอง ความถูกต้อง ความน่าเชื่อถือ
              ตลอดจนความรับผิดชอบ ในเนื้อหาข้อมูลของเว็บไซต์นั้นๆ
              และกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานไม่ รับผิดชอบต่อเนื้อหาใด
              ๆ ที่แสดงบนเว็บไซต์อื่นที่เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงาน
              ทดแทนและอนุรักษ์พลังงาน หรือต่อความเสียหายใดๆ
              ที่เกิดขึ้นจากการเข้าเยี่ยมชมเว็บไซต์
              ดังกล่าวและการเชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              <br />4.2
              กรณีต้องการเชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและ
              อนุรักษ์พลังงาน ผู้ใช้บริการสามารถเชื่อมโยง
              มายังหน้าแรกของเว็บไซต์ได้โดยแจ้งความ ประสงค์เป็นหนังสือ
              แต่หากต้องการเชื่อมโยงมายังหน้าภายในของเว็บไซต์นี้จะต้องได้รับความ
              ยินยอมเป็นหนังสือจากกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานแล้วเท่านั้น
              และในการ ให้ความยินยอมดังกล่าว
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานขอสงวนสิทธิ์ที่จะ
              กำหนดเงื่อนไขใดๆ
              ไว้ด้วยก็ได้ในการที่เว็บไซต์อื่นที่เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนา
              พลังงานทดแทนและอนุรักษ์พลังงานจะไม่รับผิดชอบต่อเนื้อหาใดๆ
              ที่แสดงบนเว็บไซต์ที่
              เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              หรือต่อความเสียหาย ใดๆ ที่เกิดขึ้นจากการใช้เว็บไซต์เหล่านั้น
            </p>
            <p>
              <b>5. การปฏิเสธความรับผิด</b> <br />5.1
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานจะไม่รับผิดต่อความ
              เสียหายใดๆ รวมถึง ความเสียหาย สูญเสียและ
              ค่าใช้จ่ายที่เกิดขึ้นไม่ว่าโดยตรงหรือโดยอ้อม ที่
              เป็นผลหรือสืบเนื่องจากการที่ผู้ใช้เข้าใช้เว็บไซต์นี้หรือเว็บไซต์ที่เชื่อมโยงกับเว็บไซต์นี้หรือต่อ
              4 ความเสียหาย สูญเสีย
              หรือค่าใช้จ่ายที่เกิดจากความล้มเหลวในการใช้งาน ความผิดพลาด
              การละเว้น การหยุดชะงัก ข้อบกพร่อง ความไม่สมบูรณ์คอมพิวเตอร์ไวรัส
              ถึงแม้ว่ากรมพัฒนา พลังงานทดแทนและอนุรักษ์พลังงาน
              จะได้รับแจ้งว่าอาจจะเกิดความเสียหาย สูญเสียหรือ
              ค่าใช้จ่ายดังกล่าวขึ้น
              นอกจากนี้กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน ไม่รับผิดต่อผู้ใช้
              เว็บไซต์หรือบุคคลจากการเรียกร้องใดๆ
              ที่เกิดขึ้นจากบนเว็บไซต์หรือเนื้อหาใดๆ ซึ่งรวมถึงการ
              ตัดสินใจหรือการกระทำใดๆ ที่เกิดจาก
              ความเชื่อถือในเนื้อหาดังกล่าวของผู้ใช้เว็บไซต์หรือใน
              ความเสียหายใดๆ ไม่ว่าความเสียหายทางตรง หรือทางอ้อม รวมถึง
              ความเสียหายอื่นใดที่อาจ
              เกิดขึ้นได้ผู้ใช้บริการยอมรับและตระหนักดีว่ากรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              จะไม่ต้องรับผิดชอบต่อการกระทำใดของผู้ใช้บริการทั้งสิ้น
            </p>
            <p>
              <b>6. กรรมสิทธิ์และสิทธิในทรัพย์สินทางปัญญา</b> <br />6.1
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานหรือผู้ให้อนุญาตแก่เว็บไซต์
              เป็นผู้มีสิทธิตามกฎหมายแต่เพียงผู้เดียวใน
              กรรมสิทธิ์ผลประโยชน์ทั้งหมด รวมถึงสิทธิใน ทรัพย์สินทางปัญญาใดๆ
              ที่มีอยู่ในบริการ ซึ่งกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
              หรือผู้ให้อนุญาตแก่เว็บไซต์เป็นผู้จัดทำขึ้น
              ไม่ว่าสิทธิเหล่านั้นจะได้รับการจดทะเบียนไว้หรือไม่ก็ ตาม <br />6.2
              ผู้ใช้บริการจะต้องไม่เปิดเผยข้อมูลที่กรมพัฒนาพลังงานทดแทนและอนุรักษ์
              พลังงาน กำหนดให้เป็นความลับ
              โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน <br />6.3
              ผู้ใช้บริการจะต้องไม่ใช้ชื่อทางการค้า เครื่องหมายการค้า
              เครื่องหมายการ บริการ
              ตราสัญลักษณ์ชื่อโดเมนของเว็บไซต์โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจาก
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            </p>
            <p>
              <b>7. กฎหมายที่ใช้บังคับ</b> <br />7.1 การตีความ
              และการบังคับตามเงื่อนไขการให้บริการฉบับนี้ให้เป็นไปตาม กฎหมายไทย
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-pane fade" id="kt_tab_pane_6" role="tabpanel">
      <div class="card mb-5">
        <div class="card-header">
          <div class="card-title">
            ข้อมูลการสอบวัดผล
          </div>
        </div>
        <div class="card-body">
          <div class="mb-5" style="border-bottom: 1px solid #dfd3d3;">
            <h4>หลักสูตรผู้รับผิดชอบด้านพลังงานโรงงานควบคุม</h4>
            <div
              class="mb-3"
              style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;"
            >
              <div>
                <button
                  class="btn btn-sm"
                  style="background: #EEE5FF;border-radius: 6px;color: #8950FC;"
                >
                  จองคิวเข้าสอบวัดผลแล้ว
                </button>
                <span class="mx-2"
                  >วันที่ 13/04/2566 รอบเช้า (9.00-12.00 น.)</span
                >
              </div>
              <div>
                <button
                  class="btn"
                  style="background: #E9E9EF;
                        border: 1px solid #323563;
                        border-radius: 6px"
                >
                  ระบบสอบวัดผล
                </button>
                <button
                  class="btn mx-2"
                  style="background: #323563;
                        color: #FFFFFF;
                        border-radius: 6px;"
                >
                  ข้อมูลการจองสอบวัดผล
                </button>
              </div>
            </div>
          </div>
          <div class="mb-5" style="border-bottom: 1px solid #dfd3d3;">
            <h4>หลักสูตรผู้รับผิดชอบด้านพลังงานโรงงานควบคุม</h4>
            <div
              class="mb-3"
              style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;"
            >
              <div>
                <button
                  class="btn btn-sm"
                  style="background: #C9F7F5;border-radius: 6px;color: #1BC5BD;"
                >
                  ผ่านการทดสอบวัดผลแล้ว
                </button>
                <span class="mx-2"
                  >วันที่ 13/04/2566 รอบเช้า (9.00-12.00 น.)</span
                >
              </div>
              <div>
                <button
                  class="btn mx-2"
                  style="background: #9999D3;
                        color: #FFFFFF;
                        border-radius: 6px;"
                >
                  ข้อมูลใบรับรองของฉัน
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div style="display: flex;justify-content: flex-end;" class="mb-5">
    <button
      type="button"
      class="btn mx-2"
      @click="onBack"
      style="border-radius: 6px; background: var(--style, #FF7786);;color:#FFFFFF"
    >
      ยกเลิก
    </button>
    <!-- v-if="!listErrorApi || listErrorApi.length == 0" -->

    <button
      v-if="activeInfoTab === 'info_1'"
      type="button"
      @click="onSubmitRegister"
      class="btn  mx-2"
      style="border-radius: 6px;background: var(--323563, #323563);color:#FFFFFF"
    >
      บันทึก
    </button>
    <!-- (modelMandatory.facId || !modelMandatory.facId) && (modelEdit['currentSpecialistStatus'] == 1 || modelEdit['currentSpecialistStatus'] == 0 || modelEdit['currentSpecialistStatus'] == null) -->
    <button
      v-if="
        activeInfoTab === 'info_2' ||
          activeInfoTab === 'info_3' ||
          activeInfoTab === 'info_4'
      "
      type="button"
      @click="onSubmitSpecialist"
      class="btn  mx-2"
      style="border-radius: 6px;background: #31B67C;color:#FFFFFF"
    >
     {{ currentType &&  currentType == modelMandatory.type ? 'บันทึกข้อมูล' : 'ขออนุมัติสำหรับผู้รับผิดชอบด้านพลังงาน'}} 
    </button>
  </div>
  <div class="modal fade" id="kt_modal_score">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <h3 class="modal-title" style="text-align:center">ให้คะแนนประเมิน</h3>
          <div
            class="my-2"
            style="display: flex;
       justify-content: space-between;
    flex-wrap: wrap;"
          >
            <span>เนื้อหา</span>
            <Rating
              :value="rate1"
              v-model="rate1"
              :max="5"
              :form="true"
              @input="handleData1"
            />
          </div>
          <div
            class="my-2"
            style="display: flex;
        justify-content: space-between;
    flex-wrap: wrap;"
          >
            <span>รูปแบบการสอน</span>
            <Rating
              :value="rate2"
              v-model="rate2"
              :max="5"
              :form="true"
              @input="handleData2"
            />
          </div>
          <div
            style="display: flex;
        justify-content: space-between;
    flex-wrap: wrap;"
          >
            <span>ระยะเวลา</span>
            <Rating
              :value="rate3"
              v-model="rate3"
              :max="5"
              :form="true"
              @input="handleData3"
            />
          </div>
          <div
            class="my-2"
            style="display: flex;
       justify-content: space-between;
    flex-wrap: wrap;"
          >
            <span>ผลที่ได้รับ</span>
            <Rating
              :value="rate4"
              v-model="rate4"
              :max="5"
              :form="true"
              @input="handleData4"
            />
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light"
            data-bs-dismiss="modal"
            style="border-radius: 29px"
          >
            ปิด
          </button>
          <button
            type="button"
            class="btn "
            style="color: var(--ffffff, #FFF);border-radius: 29px;
background: var(--323563, #323563);"
            @click="sentScore"
          >
            บันทึก
          </button>
        </div>
      </div>
    </div>
  </div>

  <el-dialog
    v-model="dialogDeleteUser"
    title="ยกเลิกบัญชีผู้ใช้งาน"
    class="w-100 w-md-500px"
  >
    <div class="row p-5">
      <h4 class="mb-5">เหตุผลใดที่คุณต้องการยกเลิกบัญชีผู้ใช้งาน</h4>
      <div class="form-check form-check-custom form-check-solid mb-5">
        <input
          class="form-check-input"
          checked
          type="radio"
          name="radio_delete"
          value="1"
          id="flexRadioDefault1"
          @change="setRemarkDelete($event)"
        />
        <label class="form-check-label" for="flexRadioDefault1">
          ฉันไม่ต้องการใช้บัญชีนี้อีกต่อไป
        </label>
      </div>
      <div class="form-check form-check-custom form-check-solid mb-5">
        <input
          class="form-check-input"
          type="radio"
          name="radio_delete"
          value="2"
          id="flexRadioDefault2"
          @change="setRemarkDelete($event)"
        />
        <label class="form-check-label" for="flexRadioDefault2">
          ฉันไม่รู้สึกปลอดภัยในการใช้เว็บไซต์
        </label>
      </div>
      <div class="form-check form-check-custom form-check-solid mb-5">
        <input
          class="form-check-input"
          type="radio"
          name="radio_delete"
          value="3"
          id="flexRadioDefault3"
          @change="setRemarkDelete($event)"
        />
        <label class="form-check-label" for="flexRadioDefault3">
          ฉันมีข้อกังวลเกี่ยวกับความเป็นส่วนตัว
        </label>
      </div>
      <div class="form-check form-check-custom form-check-solid mb-5">
        <input
          class="form-check-input"
          type="radio"
          name="radio_delete"
          value="4"
          id="flexRadioDefault4"
          @change="setRemarkDelete($event)"
        />
        <label class="form-check-label" for="flexRadioDefault4"> อื่นๆ </label>
      </div>

      <div class="mb-2" v-if="remarkDeleteUser == '4'">
        <el-input
          v-model="remarkDeleteOther"
          type="textarea"
          rows="3"
          placeholder="กรุณาระบุ"
        />
      </div>
      <div style="text-align: center">
        <button
          type="button"
          class="btn"
          @click="(dialogDeleteConfirmed = true), (dialogDeleteUser = false)"
          :disabled="remarkDeleteUser == '4' && remarkDeleteOther == ''"
          style="
            border-radius: 8px;
            background: var(--blue, #31409b);
            color: var(--ffffff, #fff);
          "
        >
          ดำเนินการต่อ
        </button>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="dialogDeleteConfirmed"
    title="ยกเลิกบัญชีผู้ใช้งาน"
    class="w-100 w-md-500px"
    :key="cerKey"
    ><div class="row p-5">
      <h4>การยกเลิกบัญชีผู้ใช้งานจะมีผลดังนี้</h4>
      <p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 1.5C6.15 1.5 1.5 6.15 1.5 12C1.5 17.85 6.15 22.5 12 22.5C17.85 22.5 22.5 17.85 22.5 12C22.5 6.15 17.85 1.5 12 1.5ZM12 21C7.05 21 3 16.95 3 12C3 7.05 7.05 3 12 3C16.95 3 21 7.05 21 12C21 16.95 16.95 21 12 21Z"
            fill="#FF5C16"
          />
          <path
            d="M16.05 17.25L12 13.2L7.95 17.25L6.75 16.05L10.8 12L6.75 7.95L7.95 6.75L12 10.8L16.05 6.75L17.25 7.95L13.2 12L17.25 16.05L16.05 17.25Z"
            fill="#FF5C16"
          />
        </svg>
        คุณจะไม่สามารถเข้าสู่ระบบได้
      </p>
      <p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 1.5C6.15 1.5 1.5 6.15 1.5 12C1.5 17.85 6.15 22.5 12 22.5C17.85 22.5 22.5 17.85 22.5 12C22.5 6.15 17.85 1.5 12 1.5ZM12 21C7.05 21 3 16.95 3 12C3 7.05 7.05 3 12 3C16.95 3 21 7.05 21 12C21 16.95 16.95 21 12 21Z"
            fill="#FF5C16"
          />
          <path
            d="M16.05 17.25L12 13.2L7.95 17.25L6.75 16.05L10.8 12L6.75 7.95L7.95 6.75L12 10.8L16.05 6.75L17.25 7.95L13.2 12L17.25 16.05L16.05 17.25Z"
            fill="#FF5C16"
          />
        </svg>
        ระบบจะทำการลบข้อมูลผู้ใช้งานทั้งหมดของคุณ
      </p>
      <p>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M12 1.5C6.15 1.5 1.5 6.15 1.5 12C1.5 17.85 6.15 22.5 12 22.5C17.85 22.5 22.5 17.85 22.5 12C22.5 6.15 17.85 1.5 12 1.5ZM12 21C7.05 21 3 16.95 3 12C3 7.05 7.05 3 12 3C16.95 3 21 7.05 21 12C21 16.95 16.95 21 12 21Z"
            fill="#FF5C16"
          />
          <path
            d="M16.05 17.25L12 13.2L7.95 17.25L6.75 16.05L10.8 12L6.75 7.95L7.95 6.75L12 10.8L16.05 6.75L17.25 7.95L13.2 12L17.25 16.05L16.05 17.25Z"
            fill="#FF5C16"
          />
        </svg>
        หากต้องการเปิดใช้งาน กรุณาติดต่อเจ้าหน้าที่ดูแลระบบ
      </p>
      <div style="text-align: center">
        <button
          type="button"
          class="btn"
          @click="(dialogDeletePopup = true), (dialogDeleteConfirmed = false)"
          style="
            border-radius: 8px;
            background: #ff7786;
            color: var(--ffffff, #fff);
          "
        >
          ยกเลิกบัญชีผู้ใช้งาน
        </button>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="dialogDeletePopup"
    title=""
    class="dialog-delete-confirm"
    :key="cerKey"
    :show-close="false"
  >
    <div class="delete-confirm-content">
      <div class="delete-confirm-icon-wrap">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="48"
          height="48"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#f59e0b"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
          />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </div>
      <h4 class="delete-confirm-title">ยืนยันการยกเลิกบัญชีผู้ใช้งาน</h4>
      <p class="delete-confirm-desc">
        การดำเนินการนี้ไม่สามารถย้อนกลับได้ ข้อมูลทั้งหมดของคุณจะถูกลบออกจากระบบ
      </p>
      <div class="delete-confirm-actions">
        <button
          type="button"
          class="delete-confirm-btn delete-confirm-btn--cancel"
          @click="dialogDeletePopup = false"
        >
          ยกเลิก
        </button>
        <button
          type="button"
          class="delete-confirm-btn delete-confirm-btn--danger"
          @click="submitDelete"
        >
          ยืนยันลบบัญชี
        </button>
      </div>
    </div>
  </el-dialog>
  <el-dialog
    v-model="dialogDeletePdpa"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    title="ถอนคำยินยอม"
    class="w-100 w-md-50"
  >
    <div style="max-height: 60vh; overflow-y: auto;">
      <div class="container mt-3">
        <div>
          <h4>
            นโยบายเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน Website
            Policy of Department of Alternative Energy Development and
            Efficiency จัดทำเมื่อวันที่ 15 กันยายน 2557
          </h4>
          <p>
            <b
              >1. วัตถุประสงค์
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานจัดทำเว็บไซต์ขึ้นเพื่อให้บริการ
              ข้อมูลข่าวสารแก่ประชาชนทั่วไป
              และบุคลากรในสังกัดกรมพัฒนาพลังงานทดแทนและอนุรักษ์ พลังงาน
              ในการใช้บริการเว็บไซต์ของผู้ใช้บริการจะอยู่ภายใต้เงื่อนไขและข้อกำหนดดังต่อไปนี้
              ผู้ใช้บริการจึงควรศึกษาเงื่อนไข
              และข้อกำหนดการใช้งานเว็บไซต์และ/หรือเงื่อนไขและข้อตกลง
              อื่นใดที่กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานได้แจ้งให้ทราบบนเว็บไซต์โดยละเอียด
              ก่อนการเข้าใช้บริการ
              ทั้งนี้ในการใช้บริการให้ถือว่าผู้ใช้บริการได้ตกลงที่จะปฏิบัติตามเงื่อนไข
              และข้อกำหนดการให้บริการที่กำหนดไว้นี้หากผู้ใช้บริการไม่ประสงค์ที่จะผูกพันตามข้อกำหนด
              และเงื่อนไขการให้บริการ
              ขอความกรุณาท่านยุติการเข้าชมและใช้งานเว็บไซต์นี้ในทันที</b
            >
          </p>
          <p>
            <b>2. เงื่อนไขและข้อกำหนดการใช้งานเว็บไซต์</b>
            <br />2.1 ผู้ใช้บริการอาจได้รับ เข้าถึง สร้าง ส่งหรือแสดงข้อมูล เช่น
            ไฟล์ข้อมูล ข้อความ ลายลักษณ์อักษร ซอฟต์แวร์คอมพิวเตอร์ดนตรีไฟล์เสียง
            หรือเสียงอื่นๆ ภาพถ่าย วิดีโอ หรือรูปภาพอื่นๆ
            โดยเป็นส่วนหนึ่งของบริการหรือโดยผ่านการใช้บริการ ซึ่งต่อไปนี้จะ
            เรียกว่า "เนื้อหา" <br />
            2.2 เนื้อหาที่นำเสนอต่อผู้ใช้บริการ
            อาจได้รับการคุ้มครองโดยสิทธิในทรัพย์สิน
            ทางปัญญาของเจ้าของเนื้อหานั้น ผู้ใช้บริการไม่มีสิทธิเปลี่ยนแปลงแก้ไข
            จำหน่ายจ่ายโอนหรือ สร้างผลงานต่อเนื่อง
            โดยอาศัยเนื้อหาดังกล่าวไม่ว่าจะทั้งหมดหรือบางส่วน
            เว้นแต่ผู้ใช้บริการจะ ได้รับอนุญาตโดยชัดแจ้ง จากเจ้าของเนื้อหานั้น
            <br />
            2.3 ผู้ใช้บริการอาจพบเนื้อหาที่ไม่เหมาะสม หรือหยาบคาย
            อันก่อให้เกิดความ ไม่พอใจ ภายใต้ความเสี่ยงของตนเอง
            <br />
            2.4 กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานทรงไว้ซึ่งสิทธิในการ
            คัดกรอง ตรวจทาน ทำเครื่องหมาย เปลี่ยนแปลง แก้ไข ปฏิเสธ
            หรือลบเนื้อหาใดๆ ที่ไม่ เหมาะสมออกจากบริการ
            ซึ่งกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานอาจจัดเตรียม 2
            เครื่องมือในการคัดกรองเนื้อหาอย่างชัดเจน โดยไม่ขัดต่อกฎหมาย
            กฎระเบียบของทางราชการที่ เกี่ยวข้อง <br />
            2.5 เว็บไซต์นี้อาจหยุดให้บริการเป็นการชั่วคราวหรือถาวร หรือยกเลิกการ
            ให้บริการ แก่ผู้ใช้บริการรายใดเป็นการเฉพาะ
            หากการให้บริการดังกล่าวส่งผลกระทบต่อ ผู้ใช้บริการอื่นๆ
            หรือขัดแย้งต่อกฎหมาย โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
            <br />
            2.6 การหยุดหรือการยกเลิกบริการตามข้อ <br />2.5
            ผู้ใช้บริการจะไม่สามารถเข้าใช้ บริการ
            และเข้าถึงรายละเอียดบัญชีของผู้ใช้บริการ ไฟล์เอกสารใดๆ
            หรือเนื้อหาอื่นๆ ที่อยู่ใน บัญชีของผู้ใช้บริการได้<br />
            2.7 ในกรณีที่เว็บไซต์นี้หยุดให้บริการเป็นการถาวร หรือยกเลิกบริการแก่
            ผู้ใช้บริการ
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานมีสิทธิในการลบข้อมูลต่างๆ
            ที่อยู่ใน
            บัญชีของผู้ใช้บริการได้โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
          </p>
          <p>
            <b>3. สิทธิหน้าที่และความรับผิดชอบของผู้ใช้บริการ</b> <br />3.1
            ผู้ใช้บ ริการจะให้ข้อมูลเกี่ยวกับตนเอง เช่น ข้อมูลระบุตัวตนหรือ
            รายละเอียดการติดต่อ ที่ถูกต้อง เป็นจริง และเป็นปัจจุบันเสมอ
            แก่เว็บไซต์อันเป็นส่วนหนึ่งของ กระบวนการลงทะเบียนใช้บริการ
            หรือการใช้บริการที่ต่อเนื่อง <br />3.2
            ผู้ใช้บริการจะใช้บริการเว็บไซต์นี้เพื่อวัตถุประสงค์ที่ได้รับอนุญาตตาม
            ข้อกำหนดของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน และไม่ขัดต่อกฎหมาย
            กฎ ระเบียบ ข้อบังคับ หลักปฏิบัติที่เป็นที่ยอมรับโดยทั่วไป <br />3.3
            ผู้ใช้บริการจะไม่เข้าใช้หรือพยายามเข้าใช้บริการหนึ่งบริการใดโดยวิธีอื่น
            รวมถึง การใช้วิธีการอัตโนมัติ(การใช้สคริปต์)
            นอกจากช่องทางที่กรมพัฒนาพลังงานทดแทน
            และอนุรักษ์พลังงานจัดเตรียมไว้ให้เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตจากกรมพัฒนาพลังงาน
            ทดแทนและอนุรักษ์พลังงาน โดยชัดแจ้งให้ทำเช่นนั้นได้ <br />3.4
            ผู้ใช้บริการจะไม่ทำหรือมีส่วนร่วมในการขัดขวางหรือรบกวนบริการของ
            เว็บไซต์รวมทั้งเครื่องแม่ข่ายและเครือข่ายที่เชื่อมต่อกับบริการ
            <br />3.5 ผู้ใช้บริการจะไม่ทำสำเนา คัดลอก ทำซ้ำ ขาย แลกเปลี่ยน
            หรือขายต่อ บริการ เพื่อวัตถุประสงค์ใดๆ
            เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตจากกรมพัฒนาพลังงานทดแทน
            และอนุรักษ์พลังงาน โดยชัดแจ้งให้ทำเช่นนั้นได้ <br />3 3.6
            ผู้ใช้บริการมีหน้าที่ในการรักษาความลับของรหัสผ่านที่เชื่อมโยงกับบัญชีใดๆ
            ที่ใช้ในการเข้าถึงบริการ <br />3.7
            ผู้ใช้บริการจะเป็นผู้รับผิดชอบแต่เพียงผู้เดียวต่อบุคคลใดๆ รวมถึง
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            ในความเสียหายอันเกิดจากการละเมิด ข้อกำหนด
          </p>
          <p>
            <b>4. การเชื่อมโยงกับเว็บไซต์อื่นๆ</b> <br />4.1
            การเชื่อมโยงไปยังเว็บไซต์อื่นเป็นเพียงการให้บริการเพื่ออำนวยความ
            สะดวก แก่ผู้ใช้บริการเท่านั้น
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานมิได้มีส่วน เกี่ยวข้อง
            หรือมีอำนาจควบคุม รับรอง ความถูกต้อง ความน่าเชื่อถือ
            ตลอดจนความรับผิดชอบ ในเนื้อหาข้อมูลของเว็บไซต์นั้นๆ
            และกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานไม่ รับผิดชอบต่อเนื้อหาใด ๆ
            ที่แสดงบนเว็บไซต์อื่นที่เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงาน
            ทดแทนและอนุรักษ์พลังงาน หรือต่อความเสียหายใดๆ
            ที่เกิดขึ้นจากการเข้าเยี่ยมชมเว็บไซต์
            ดังกล่าวและการเชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            <br />4.2
            กรณีต้องการเชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและ
            อนุรักษ์พลังงาน ผู้ใช้บริการสามารถเชื่อมโยง
            มายังหน้าแรกของเว็บไซต์ได้โดยแจ้งความ ประสงค์เป็นหนังสือ
            แต่หากต้องการเชื่อมโยงมายังหน้าภายในของเว็บไซต์นี้จะต้องได้รับความ
            ยินยอมเป็นหนังสือจากกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานแล้วเท่านั้น
            และในการ ให้ความยินยอมดังกล่าว
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานขอสงวนสิทธิ์ที่จะ
            กำหนดเงื่อนไขใดๆ
            ไว้ด้วยก็ได้ในการที่เว็บไซต์อื่นที่เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนา
            พลังงานทดแทนและอนุรักษ์พลังงานจะไม่รับผิดชอบต่อเนื้อหาใดๆ
            ที่แสดงบนเว็บไซต์ที่
            เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            หรือต่อความเสียหาย ใดๆ ที่เกิดขึ้นจากการใช้เว็บไซต์เหล่านั้น
          </p>
          <p>
            <b>5. การปฏิเสธความรับผิด</b> <br />5.1
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานจะไม่รับผิดต่อความ เสียหายใดๆ
            รวมถึง ความเสียหาย สูญเสียและ
            ค่าใช้จ่ายที่เกิดขึ้นไม่ว่าโดยตรงหรือโดยอ้อม ที่
            เป็นผลหรือสืบเนื่องจากการที่ผู้ใช้เข้าใช้เว็บไซต์นี้หรือเว็บไซต์ที่เชื่อมโยงกับเว็บไซต์นี้หรือต่อ
            4 ความเสียหาย สูญเสีย หรือค่าใช้จ่ายที่เกิดจากความล้มเหลวในการใช้งาน
            ความผิดพลาด การละเว้น การหยุดชะงัก ข้อบกพร่อง
            ความไม่สมบูรณ์คอมพิวเตอร์ไวรัส ถึงแม้ว่ากรมพัฒนา
            พลังงานทดแทนและอนุรักษ์พลังงาน จะได้รับแจ้งว่าอาจจะเกิดความเสียหาย
            สูญเสียหรือ ค่าใช้จ่ายดังกล่าวขึ้น
            นอกจากนี้กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน ไม่รับผิดต่อผู้ใช้
            เว็บไซต์หรือบุคคลจากการเรียกร้องใดๆ
            ที่เกิดขึ้นจากบนเว็บไซต์หรือเนื้อหาใดๆ ซึ่งรวมถึงการ
            ตัดสินใจหรือการกระทำใดๆ ที่เกิดจาก
            ความเชื่อถือในเนื้อหาดังกล่าวของผู้ใช้เว็บไซต์หรือใน ความเสียหายใดๆ
            ไม่ว่าความเสียหายทางตรง หรือทางอ้อม รวมถึง ความเสียหายอื่นใดที่อาจ
            เกิดขึ้นได้ผู้ใช้บริการยอมรับและตระหนักดีว่ากรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            จะไม่ต้องรับผิดชอบต่อการกระทำใดของผู้ใช้บริการทั้งสิ้น
          </p>
          <p>
            <b>6. กรรมสิทธิ์และสิทธิในทรัพย์สินทางปัญญา</b> <br />6.1
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานหรือผู้ให้อนุญาตแก่เว็บไซต์
            เป็นผู้มีสิทธิตามกฎหมายแต่เพียงผู้เดียวใน
            กรรมสิทธิ์ผลประโยชน์ทั้งหมด รวมถึงสิทธิใน ทรัพย์สินทางปัญญาใดๆ
            ที่มีอยู่ในบริการ ซึ่งกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            หรือผู้ให้อนุญาตแก่เว็บไซต์เป็นผู้จัดทำขึ้น
            ไม่ว่าสิทธิเหล่านั้นจะได้รับการจดทะเบียนไว้หรือไม่ก็ ตาม <br />6.2
            ผู้ใช้บริการจะต้องไม่เปิดเผยข้อมูลที่กรมพัฒนาพลังงานทดแทนและอนุรักษ์
            พลังงาน กำหนดให้เป็นความลับ
            โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน <br />6.3
            ผู้ใช้บริการจะต้องไม่ใช้ชื่อทางการค้า เครื่องหมายการค้า
            เครื่องหมายการ บริการ
            ตราสัญลักษณ์ชื่อโดเมนของเว็บไซต์โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจาก
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
          </p>
          <p>
            <b>7. กฎหมายที่ใช้บังคับ</b> <br />7.1 การตีความ
            และการบังคับตามเงื่อนไขการให้บริการฉบับนี้ให้เป็นไปตาม กฎหมายไทย
          </p>
        </div>
      </div>
    </div>
    <template #footer>
      <div
        class="dialog-footer"
        style="
          display: flex;
          justify-content: center;
          flex-direction: column;
          flex-wrap: wrap;
          align-items: center;
        "
      >
        <button
          class="btn"
          type="button"
          @click="updatePdpaAllowed('false')"
          style="
            border-radius: 15px;
            font-size: 16px;
            background: var(--blue, #ff7786);
            color: #ffffff;
          "
        >
          ถอนคำยินยอม
        </button>
      </div>
    </template>
  </el-dialog>

  <!-- Survey Dialog -->
  <el-dialog
    v-model="dialogSurvey"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    title="แบบสอบถามความพึงพอใจการใช้งานระบบ"
    class="w-100"
    width="450px"
  >
    <div style="max-height: 500px; overflow: auto; padding: 0 10px;">
      <!-- Question 1 -->
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          1. ระบบ e-Learning ใช้งานง่ายและเข้าใจได้ชัดเจนเพียงใด
        </p>
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q1-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input
              type="radio"
              :value="opt.value"
              v-model="surveyData.q1"
              style="margin-top: 4px;"
            />
          </label>
        </div>
      </div>

      <!-- Question 2 -->
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          2. ความสะดวกและความรวดเร็วในการเข้าใช้งานระบบ
        </p>
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q2-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input
              type="radio"
              :value="opt.value"
              v-model="surveyData.q2"
              style="margin-top: 4px;"
            />
          </label>
        </div>
      </div>

      <!-- Question 3 -->
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          3. คุณภาพของเนื้อหา/บทเรียนตรงกับความต้องการในการเรียนรู้
        </p>
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q3-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input
              type="radio"
              :value="opt.value"
              v-model="surveyData.q3"
              style="margin-top: 4px;"
            />
          </label>
        </div>
      </div>

      <!-- Question 4 -->
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          4. ความเสถียรของระบบ (ไม่ค้าง ไม่หลุด ระหว่างใช้งาน)
        </p>
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q4-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input
              type="radio"
              :value="opt.value"
              v-model="surveyData.q4"
              style="margin-top: 4px;"
            />
          </label>
        </div>
      </div>

      <!-- Question 5 -->
      <div class="mb-4">
        <p style="font-weight: 600; font-size: 14px;">
          5. ภาพรวมความพึงพอใจต่อการใช้งานระบบ e-Learning
        </p>
        <div
          style="display: flex; justify-content: space-between; align-items: center;"
        >
          <label
            v-for="(opt, idx) in surveyOptions"
            :key="'q5-' + idx"
            style="display: flex; flex-direction: column; align-items: center; cursor: pointer;"
          >
            <span style="font-size: 28px;">{{ opt.emoji }}</span>
            <span style="font-size: 11px; color: #666;">{{ opt.label }}</span>
            <input
              type="radio"
              :value="opt.value"
              v-model="surveyData.q5"
              style="margin-top: 4px;"
            />
          </label>
        </div>
      </div>

      <!-- Suggestion -->
      <div class="mb-3">
        <p style="font-weight: 600; font-size: 14px;">6. ข้อเสนอแนะ</p>
        <textarea
          v-model="surveyData.suggestion"
          class="form-control"
          rows="3"
          placeholder="กรอก"
          maxlength="150"
          style="border-radius: 10px;"
        ></textarea>
        <div
          style="text-align: right; font-size: 12px; color: #999; margin-top: 4px;"
        >
          {{ (surveyData.suggestion || "").length }}/150
        </div>
      </div>
    </div>

    <template #footer>
      <div style="display: flex; justify-content: center;">
        <button
          class="btn px-8"
          type="button"
          style="border-radius: 21px; background: #323563; color: #FFF;"
          @click="submitSurvey"
        >
          ส่งแบบสอบถาม
        </button>
        <button
          class="btn px-8 ms-3"
          type="button"
          style="border-radius: 21px; background: #e5e7eb; color: #000;"
          @click="dialogSurvey = false"
        >
          ข้ามไปก่อน
        </button>
      </div>
    </template>
  </el-dialog>
  <el-dialog
    v-model="dialogPolicy"
    title="นโยบายความเป็นส่วนตัว"
    width="800px"
    :close-on-click-modal="false"
  >
    <div style="max-height: 60vh; overflow-y: auto;">
      <div class="container mt-3">
        <div>
          <h4>
            นโยบายเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน Website
            Policy of Department of Alternative Energy Development and
            Efficiency จัดทำเมื่อวันที่ 15 กันยายน 2557
          </h4>
          <p>
            <b
              >1. วัตถุประสงค์
              กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานจัดทำเว็บไซต์ขึ้นเพื่อให้บริการ
              ข้อมูลข่าวสารแก่ประชาชนทั่วไป
              และบุคลากรในสังกัดกรมพัฒนาพลังงานทดแทนและอนุรักษ์ พลังงาน
              ในการใช้บริการเว็บไซต์ของผู้ใช้บริการจะอยู่ภายใต้เงื่อนไขและข้อกำหนดดังต่อไปนี้
              ผู้ใช้บริการจึงควรศึกษาเงื่อนไข
              และข้อกำหนดการใช้งานเว็บไซต์และ/หรือเงื่อนไขและข้อตกลง
              อื่นใดที่กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานได้แจ้งให้ทราบบนเว็บไซต์โดยละเอียด
              ก่อนการเข้าใช้บริการ
              ทั้งนี้ในการใช้บริการให้ถือว่าผู้ใช้บริการได้ตกลงที่จะปฏิบัติตามเงื่อนไข
              และข้อกำหนดการให้บริการที่กำหนดไว้นี้หากผู้ใช้บริการไม่ประสงค์ที่จะผูกพันตามข้อกำหนด
              และเงื่อนไขการให้บริการ
              ขอความกรุณาท่านยุติการเข้าชมและใช้งานเว็บไซต์นี้ในทันที</b
            >
          </p>
          <p>
            <b>2. เงื่อนไขและข้อกำหนดการใช้งานเว็บไซต์</b>
            <br />2.1 ผู้ใช้บริการอาจได้รับ เข้าถึง สร้าง ส่งหรือแสดงข้อมูล เช่น
            ไฟล์ข้อมูล ข้อความ ลายลักษณ์อักษร ซอฟต์แวร์คอมพิวเตอร์ดนตรีไฟล์เสียง
            หรือเสียงอื่นๆ ภาพถ่าย วิดีโอ หรือรูปภาพอื่นๆ
            โดยเป็นส่วนหนึ่งของบริการหรือโดยผ่านการใช้บริการ ซึ่งต่อไปนี้จะ
            เรียกว่า "เนื้อหา" <br />
            2.2 เนื้อหาที่นำเสนอต่อผู้ใช้บริการ
            อาจได้รับการคุ้มครองโดยสิทธิในทรัพย์สิน
            ทางปัญญาของเจ้าของเนื้อหานั้น ผู้ใช้บริการไม่มีสิทธิเปลี่ยนแปลงแก้ไข
            จำหน่ายจ่ายโอนหรือ สร้างผลงานต่อเนื่อง
            โดยอาศัยเนื้อหาดังกล่าวไม่ว่าจะทั้งหมดหรือบางส่วน
            เว้นแต่ผู้ใช้บริการจะ ได้รับอนุญาตโดยชัดแจ้ง จากเจ้าของเนื้อหานั้น
            <br />
            2.3 ผู้ใช้บริการอาจพบเนื้อหาที่ไม่เหมาะสม หรือหยาบคาย
            อันก่อให้เกิดความ ไม่พอใจ ภายใต้ความเสี่ยงของตนเอง
            <br />
            2.4 กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานทรงไว้ซึ่งสิทธิในการ
            คัดกรอง ตรวจทาน ทำเครื่องหมาย เปลี่ยนแปลง แก้ไข ปฏิเสธ
            หรือลบเนื้อหาใดๆ ที่ไม่ เหมาะสมออกจากบริการ
            ซึ่งกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานอาจจัดเตรียม 2
            เครื่องมือในการคัดกรองเนื้อหาอย่างชัดเจน โดยไม่ขัดต่อกฎหมาย
            กฎระเบียบของทางราชการที่ เกี่ยวข้อง <br />
            2.5 เว็บไซต์นี้อาจหยุดให้บริการเป็นการชั่วคราวหรือถาวร หรือยกเลิกการ
            ให้บริการ แก่ผู้ใช้บริการรายใดเป็นการเฉพาะ
            หากการให้บริการดังกล่าวส่งผลกระทบต่อ ผู้ใช้บริการอื่นๆ
            หรือขัดแย้งต่อกฎหมาย โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
            <br />
            2.6 การหยุดหรือการยกเลิกบริการตามข้อ <br />2.5
            ผู้ใช้บริการจะไม่สามารถเข้าใช้ บริการ
            และเข้าถึงรายละเอียดบัญชีของผู้ใช้บริการ ไฟล์เอกสารใดๆ
            หรือเนื้อหาอื่นๆ ที่อยู่ใน บัญชีของผู้ใช้บริการได้<br />
            2.7 ในกรณีที่เว็บไซต์นี้หยุดให้บริการเป็นการถาวร หรือยกเลิกบริการแก่
            ผู้ใช้บริการ
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานมีสิทธิในการลบข้อมูลต่างๆ
            ที่อยู่ใน
            บัญชีของผู้ใช้บริการได้โดยไม่ต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
          </p>
          <p>
            <b>3. สิทธิหน้าที่และความรับผิดชอบของผู้ใช้บริการ</b> <br />3.1
            ผู้ใช้บ ริการจะให้ข้อมูลเกี่ยวกับตนเอง เช่น ข้อมูลระบุตัวตนหรือ
            รายละเอียดการติดต่อ ที่ถูกต้อง เป็นจริง และเป็นปัจจุบันเสมอ
            แก่เว็บไซต์อันเป็นส่วนหนึ่งของ กระบวนการลงทะเบียนใช้บริการ
            หรือการใช้บริการที่ต่อเนื่อง <br />3.2
            ผู้ใช้บริการจะใช้บริการเว็บไซต์นี้เพื่อวัตถุประสงค์ที่ได้รับอนุญาตตาม
            ข้อกำหนดของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน และไม่ขัดต่อกฎหมาย
            กฎ ระเบียบ ข้อบังคับ หลักปฏิบัติที่เป็นที่ยอมรับโดยทั่วไป <br />3.3
            ผู้ใช้บริการจะไม่เข้าใช้หรือพยายามเข้าใช้บริการหนึ่งบริการใดโดยวิธีอื่น
            รวมถึง การใช้วิธีการอัตโนมัติ(การใช้สคริปต์)
            นอกจากช่องทางที่กรมพัฒนาพลังงานทดแทน
            และอนุรักษ์พลังงานจัดเตรียมไว้ให้เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตจากกรมพัฒนาพลังงาน
            ทดแทนและอนุรักษ์พลังงาน โดยชัดแจ้งให้ทำเช่นนั้นได้ <br />3.4
            ผู้ใช้บริการจะไม่ทำหรือมีส่วนร่วมในการขัดขวางหรือรบกวนบริการของ
            เว็บไซต์รวมทั้งเครื่องแม่ข่ายและเครือข่ายที่เชื่อมต่อกับบริการ
            <br />3.5 ผู้ใช้บริการจะไม่ทำสำเนา คัดลอก ทำซ้ำ ขาย แลกเปลี่ยน
            หรือขายต่อ บริการ เพื่อวัตถุประสงค์ใดๆ
            เว้นแต่ผู้ใช้บริการจะได้รับอนุญาตจากกรมพัฒนาพลังงานทดแทน
            และอนุรักษ์พลังงาน โดยชัดแจ้งให้ทำเช่นนั้นได้ <br />3 3.6
            ผู้ใช้บริการมีหน้าที่ในการรักษาความลับของรหัสผ่านที่เชื่อมโยงกับบัญชีใดๆ
            ที่ใช้ในการเข้าถึงบริการ <br />3.7
            ผู้ใช้บริการจะเป็นผู้รับผิดชอบแต่เพียงผู้เดียวต่อบุคคลใดๆ รวมถึง
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            ในความเสียหายอันเกิดจากการละเมิด ข้อกำหนด
          </p>
          <p>
            <b>4. การเชื่อมโยงกับเว็บไซต์อื่นๆ</b> <br />4.1
            การเชื่อมโยงไปยังเว็บไซต์อื่นเป็นเพียงการให้บริการเพื่ออำนวยความ
            สะดวก แก่ผู้ใช้บริการเท่านั้น
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานมิได้มีส่วน เกี่ยวข้อง
            หรือมีอำนาจควบคุม รับรอง ความถูกต้อง ความน่าเชื่อถือ
            ตลอดจนความรับผิดชอบ ในเนื้อหาข้อมูลของเว็บไซต์นั้นๆ
            และกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานไม่ รับผิดชอบต่อเนื้อหาใด ๆ
            ที่แสดงบนเว็บไซต์อื่นที่เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงาน
            ทดแทนและอนุรักษ์พลังงาน หรือต่อความเสียหายใดๆ
            ที่เกิดขึ้นจากการเข้าเยี่ยมชมเว็บไซต์
            ดังกล่าวและการเชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            <br />4.2
            กรณีต้องการเชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและ
            อนุรักษ์พลังงาน ผู้ใช้บริการสามารถเชื่อมโยง
            มายังหน้าแรกของเว็บไซต์ได้โดยแจ้งความ ประสงค์เป็นหนังสือ
            แต่หากต้องการเชื่อมโยงมายังหน้าภายในของเว็บไซต์นี้จะต้องได้รับความ
            ยินยอมเป็นหนังสือจากกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานแล้วเท่านั้น
            และในการ ให้ความยินยอมดังกล่าว
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานขอสงวนสิทธิ์ที่จะ
            กำหนดเงื่อนไขใดๆ
            ไว้ด้วยก็ได้ในการที่เว็บไซต์อื่นที่เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนา
            พลังงานทดแทนและอนุรักษ์พลังงานจะไม่รับผิดชอบต่อเนื้อหาใดๆ
            ที่แสดงบนเว็บไซต์ที่
            เชื่อมโยงมายังเว็บไซต์ของกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            หรือต่อความเสียหาย ใดๆ ที่เกิดขึ้นจากการใช้เว็บไซต์เหล่านั้น
          </p>
          <p>
            <b>5. การปฏิเสธความรับผิด</b> <br />5.1
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานจะไม่รับผิดต่อความ เสียหายใดๆ
            รวมถึง ความเสียหาย สูญเสียและ
            ค่าใช้จ่ายที่เกิดขึ้นไม่ว่าโดยตรงหรือโดยอ้อม ที่
            เป็นผลหรือสืบเนื่องจากการที่ผู้ใช้เข้าใช้เว็บไซต์นี้หรือเว็บไซต์ที่เชื่อมโยงกับเว็บไซต์นี้หรือต่อ
            4 ความเสียหาย สูญเสีย หรือค่าใช้จ่ายที่เกิดจากความล้มเหลวในการใช้งาน
            ความผิดพลาด การละเว้น การหยุดชะงัก ข้อบกพร่อง
            ความไม่สมบูรณ์คอมพิวเตอร์ไวรัส ถึงแม้ว่ากรมพัฒนา
            พลังงานทดแทนและอนุรักษ์พลังงาน จะได้รับแจ้งว่าอาจจะเกิดความเสียหาย
            สูญเสียหรือ ค่าใช้จ่ายดังกล่าวขึ้น
            นอกจากนี้กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน ไม่รับผิดต่อผู้ใช้
            เว็บไซต์หรือบุคคลจากการเรียกร้องใดๆ
            ที่เกิดขึ้นจากบนเว็บไซต์หรือเนื้อหาใดๆ ซึ่งรวมถึงการ
            ตัดสินใจหรือการกระทำใดๆ ที่เกิดจาก
            ความเชื่อถือในเนื้อหาดังกล่าวของผู้ใช้เว็บไซต์หรือใน ความเสียหายใดๆ
            ไม่ว่าความเสียหายทางตรง หรือทางอ้อม รวมถึง ความเสียหายอื่นใดที่อาจ
            เกิดขึ้นได้ผู้ใช้บริการยอมรับและตระหนักดีว่ากรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            จะไม่ต้องรับผิดชอบต่อการกระทำใดของผู้ใช้บริการทั้งสิ้น
          </p>
          <p>
            <b>6. กรรมสิทธิ์และสิทธิในทรัพย์สินทางปัญญา</b> <br />6.1
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงานหรือผู้ให้อนุญาตแก่เว็บไซต์
            เป็นผู้มีสิทธิตามกฎหมายแต่เพียงผู้เดียวใน
            กรรมสิทธิ์ผลประโยชน์ทั้งหมด รวมถึงสิทธิใน ทรัพย์สินทางปัญญาใดๆ
            ที่มีอยู่ในบริการ ซึ่งกรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
            หรือผู้ให้อนุญาตแก่เว็บไซต์เป็นผู้จัดทำขึ้น
            ไม่ว่าสิทธิเหล่านั้นจะได้รับการจดทะเบียนไว้หรือไม่ก็ ตาม <br />6.2
            ผู้ใช้บริการจะต้องไม่เปิดเผยข้อมูลที่กรมพัฒนาพลังงานทดแทนและอนุรักษ์
            พลังงาน กำหนดให้เป็นความลับ
            โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน <br />6.3
            ผู้ใช้บริการจะต้องไม่ใช้ชื่อทางการค้า เครื่องหมายการค้า
            เครื่องหมายการ บริการ
            ตราสัญลักษณ์ชื่อโดเมนของเว็บไซต์โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรจาก
            กรมพัฒนาพลังงานทดแทนและอนุรักษ์พลังงาน
          </p>
          <p>
            <b>7. กฎหมายที่ใช้บังคับ</b> <br />7.1 การตีความ
            และการบังคับตามเงื่อนไขการให้บริการฉบับนี้ให้เป็นไปตาม กฎหมายไทย
          </p>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="d-flex justify-content-center">
        <button
          type="button"
          class="btn px-10"
          style="border-radius: 21px; background: #FF7786; color: #FFF;"
          @click="dialogPolicy = false"
        >
          ไม่ยอมรับ
        </button>
        <button
          type="button"
          class="btn px-10 ms-3"
          style="border-radius: 21px; background: #31B67C; color: #FFF;"
          @click="updatePdpaAllowed('true')"
        >
          ยอมรับ
        </button>
      </div>
    </template>
  </el-dialog>

  <!-- Notification Dialog -->
  <el-dialog
    v-model="dialogNotification"
    :show-close="false"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    class="dialog-notification-custom"
  >
    <div class="notification-body">
      <div class="notification-icon-wrap">
        <span class="notification-icon">!</span>
      </div>
      <h3 class="notification-title">แจ้งเตือน</h3>
      <div class="notification-steps">
        <div class="notification-step">
          <div class="notification-step-icon">
            <i class="fas fa-edit"></i>
          </div>
          <span>กรอกข้อมูล</span>
        </div>
        <div class="notification-step">
          <div class="notification-step-icon">
            <i class="fas fa-search"></i>
          </div>
          <span>เจ้าหน้าที่ตรวจสอบ</span>
        </div>
        <div class="notification-step">
          <div class="notification-step-icon">
            <i class="fas fa-check-circle"></i>
          </div>
          <span>อนุมัติข้อมูลผู้สมัคร</span>
        </div>
      </div>
      <p class="notification-desc">
        การยืนยันตัวตนสำหรับบุคลากรด้านพลังงานจะต้องกรอกข้อมูลผู้ใช้งาน
        สำหรับเรียกภาคปฏิบัติ ข้อมูลสถานประกอบการ และข้อมูลผู้รับรองให้ครบถ้วน
        จากนั้นกดปุ่ม "ส่งคำร้อง" ไปยังเจ้าหน้าที่
        เพื่อให้เจ้าหน้าที่ตรวจสอบและอนุมัติ ก่อนสอบเพื่อรับใบประกาศต่อไป
      </p>
      <button
        type="button"
        class="notification-btn"
        @click="dialogNotification = false"
      >
        เข้าใจแล้ว
      </button>
    </div>
  </el-dialog>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Rating from "../Rating.vue";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import router from "@/router";
import axios from "axios";
import ReferenceDataApi from "@/core/services/ReferenceDataApi";
import th from "@element-plus/locale/lang/th.js";
import { bu } from "@fullcalendar/core/internal-common";
const userInfo = ref<any>(null);
const modelEdit = ref({
  email: "",
  password: "",
  cpassword: "",
  prefix: "",
  firstName: "",
  lastName: "",
  idCard: "",
  birthDate: "",
  phoneNumber: "",
  regionId: "",
  provinceId: "",
  districtId: "",
  subDistrictId: "",
  provinceTh: "",
  provinceEn: "",
  districtTh: "",
  subDistrictTh: "",
  zipcode: "",
  road: "",
  no: "",
  moo: "",
  soi: "",
  qualificationId: "",
  qualificationOther: "",
  qualificationMajor: "",
  officeTypeId: "",
  officeExperience: "",
  officePosition: "",
  officeJobDesc: "",
  toc: false,
  imageProfile: "",
  file: null,
  type: 1,
});
const modelEditLoaded = ref(false);
const modelMandatory = ref({
  facId: "",
  preFactoryNo: "",
  preBuildingNo: "",
  officeTypeId: "",
  factorySizeId: "",
  factoryTypes: [],
  factoryTypeOther: "",
  buildingSizeId: "",
  buildingTypes: [],
  buildingTypeOther: "",
  companyElectric: "",
  companyTransformer: "",
  companyHeat: "",
  companyFuel: "",
  machines: [],
  machineOther: "",
  technologies: [],
  technologieOther: "",
  warrantorFirstname: "",
  warrantorLastname: "",
  warrantorPosition: "",
  warrantorOffice: "",
  qualificationImage: [],
  faceImage: "",
  delImages: [],
  fileAvatar: null,
  fileImages: [],
  imagesList: [],
  facBuildTypeId: [],
  type: 2,
  becProfType: "",
  cerImage: null as File | null,
  cerImagePreview: "",
});
const factoriesList = ref([]);
const factoryNow = ref({
  address: "",
  addressProfile: {},
  addressFac: {
    no: "",
    moo: "",
    soi: "",
    road: "",
    regionTh: "",
    provinceTh: "",
    districtTh: "",
    subDistrictTh: "",
    zipcode: "",
  },
});
const myCourseList = ref();
const syllabusList = ref();
const search = ref("");
const limit = ref(12);
const page = ref(0);
const totalPage = ref(0);
const listCertificate = ref();
const checkIdcard = ref(true);
const currentAdress = ref();
const dialogError = ref(false);
const showMandatoryTabs = ref(false);
const activeInfoTab = ref("info_1");
const dialogDeleteUser = ref(false);
const dialogDeleteConfirmed = ref(false);
const dialogDeletePopup = ref(false);
const dialogDeletePdpa = ref(false);
const dialogSurvey = ref(false);
const dialogPolicy = ref(false);
const dialogNotification = ref(false);
const surveyCourseId = ref(null);
const surveyOptions = ref([
  { emoji: "😆", label: "มากที่สุด", value: 5 },
  { emoji: "😊", label: "มาก", value: 4 },
  { emoji: "😐", label: "ปานกลาง", value: 3 },
  { emoji: "😟", label: "น้อย", value: 2 },
  { emoji: "😢", label: "น้อยที่สุด", value: 1 },
]);
const currentType =ref(null);
const surveyData = ref({
  q1: null,
  q2: null,
  q3: null,
  q4: null,
  q5: null,
  suggestion: "",
});
const errors = ref<any>({});
const errors2 = ref<any>({});
export default defineComponent({
  name: "profile",
  components: {
    Rating,
  },
  data() {
    return {
      locale: th,
      imageUrl: process.env.VUE_APP_IMG_URL,
      provinceList: [],
      districtList: [],
      subDistrictList: [],
      qualificationList: [],
      officeTypeList: [],
      myCourseSize: 0,
      factoriesList: [],
      buildingSizesList: [],
      buildingTypesList: [],
      technologiesList: [],
      machinesList: [],
      factorySizesList: [],
      factoryTypesList: [],
      factory: {
        addressProfile: {},
      },
      factoryBuildingTypesList: [],
      search: "",
      myCertificateList: [],
      rateId: null,
      rate1: 0,
      rate2: 0,
      rate3: 0,
      rate4: 0,
      localeConfig: {
        lang: th, // Set the language code (e.g., 'en' for English, 'fr' for French, etc.)
      },
      formpassword: false,
      validate: 0,
      oldPassword: "",
      newPassword: "",
      newPasswordConfirm: "",
      validateCpassword: true,
      authEmail: "",
      authEmailValid: false,
      authPassword: "",
      authPasswordConfirm: "",
      authValidate: 0,
      authValidateCpassword: true,
      passwordFieldType: "password",
      passwordFieldType2: "password",
      passwordFieldType3: "password",
      prefixList: [],
      accessToken: null,
      regionList: [],
      listErrorApi: [],
      remarkDeleteUser: "1",
      remarkDeleteOther: "",
      flgPdpaIndex: 0,
    };
  },

  setup() {
    /* eslint-disable */
    const tab1 = ref(false);
    const router = useRouter();
    const route = useRoute();
    const tab = ref();
    onMounted(() => {
      if (localStorage.getItem("id_token") != null) {
        getCourseRegister();
        axios
          .get(
            process.env.VUE_APP_API_URL +
              "/getSyllabusRegister?userId=" +
              localStorage.getItem("u_id"),
            {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            },
          )
          .then((response) => {
            syllabusList.value = response.data.data.content;
            // console.log("syllabusList");
            // console.log(syllabusList.value);
          })
          .catch((error) => {
            // console.log(error);
          });
        axios
          .get(
            process.env.VUE_APP_API_URL +
              "/getProfile?id=" +
              localStorage.getItem("u_id"),
            {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            },
          )
          .then((response) => {
            // console.log("getProfile");
            // console.log(response.data.data);
            userInfo.value = response.data.data;
            modelEdit.value = response.data.data;
            modelEditLoaded.value = true;

            if (
              modelEdit.value["imageProfile"] &&
              modelEdit.value["imageProfile"].indexOf("http") == -1
            ) {
              modelEdit.value["imageProfile"] =
                process.env.VUE_APP_IMG_URL + modelEdit.value["imageProfile"];
            }

            modelEdit.value.birthDate = setDate(modelEdit.value.birthDate) + "";

            // console.log("====================================");
            // console.log(modelEdit.value.birthDate);
            // console.log("====================================");
            modelEdit.value.no = modelEdit.value["address"]
              ? modelEdit.value["address"]["no"]
              : "";
            modelEdit.value.moo = modelEdit.value["address"]
              ? modelEdit.value["address"]["moo"]
              : "";
            modelEdit.value.soi = modelEdit.value["address"]
              ? modelEdit.value["address"]["soi"]
              : "";
            modelEdit.value.road = modelEdit.value["address"]
              ? modelEdit.value["address"]["road"]
              : "";
            modelEdit.value.regionId = modelEdit.value["address"]
              ? modelEdit.value["address"]["regionCode"]
              : "";
            modelEdit.value.provinceId = modelEdit.value["address"]
              ? modelEdit.value["address"]["provinceCode"]
              : "";
            modelEdit.value.districtId = modelEdit.value["address"]
              ? modelEdit.value["address"]["districtCode"]
              : "";
            modelEdit.value.subDistrictId = modelEdit.value["address"]
              ? modelEdit.value["address"]["subDistrictCode"]
              : "";
            modelEdit.value.zipcode = modelEdit.value["address"]
              ? modelEdit.value["address"]["zipcode"]
              : "";
            // specialist
            if (response.data.data.currentSpecialistStatus != 2) {
              dialogNotification.value = true;
            }

            if (response.data.data.specialist) {
              // console.log(response.data.data.specialist);
              modelMandatory.value = response.data.data.specialist;
              currentType.value =  response.data.data["type"]
              if (
                modelEdit.value["currentSpecialistStatus"] == 0 ||
                modelEdit.value["currentSpecialistStatus"] == 1 ||
                modelEdit.value["currentSpecialistStatus"] == 3
              ) {
                showMandatoryTabs.value = true;
                modelMandatory.value.type =
                  response.data.data.requestSpecialistType > 1
                    ? response.data.data.requestSpecialistType
                    : "";
              } else {
                modelMandatory.value.type =
                  response.data.data["type"] != 1
                    ? response.data.data["type"]
                    : "";
                showMandatoryTabs.value = false;
              }
              if (modelMandatory.value.type == 4) {
                factoryNow.value.addressFac.no =
                  modelMandatory.value["addressType4"];
              }
              modelMandatory.value.facId = modelMandatory.value["factoryId"];
              const newfactoryType: any = [];
              if (modelMandatory.value.factoryTypes) {
                for (const loopData of modelMandatory.value.factoryTypes) {
                  newfactoryType.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.factoryTypeOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.becProfType =
                modelMandatory.value["certType"];
              modelMandatory.value.factoryTypes = newfactoryType;

              const newbuildingType: any = [];
              if (modelMandatory.value.buildingTypes) {
                for (const loopData of modelMandatory.value.buildingTypes) {
                  newbuildingType.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.buildingTypeOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.buildingTypes = newbuildingType;

              const newmachine: any = [];
              if (modelMandatory.value.machines != null) {
                for (const loopData of modelMandatory.value.machines) {
                  newmachine.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.machineOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.machines = newmachine;

              const newtechnologie: any = [];
              if (modelMandatory.value.technologies != null) {
                for (const loopData of modelMandatory.value.technologies) {
                  newtechnologie.push(loopData["code"]);
                  if (loopData["other"] != "") {
                    modelMandatory.value.technologieOther = loopData["other"];
                  }
                }
              }
              modelMandatory.value.technologies = newtechnologie;

              const newqualificationImages: any = [];
              const listId: any = [];
              if (modelMandatory.value.qualificationImage) {
                for (const loopData of modelMandatory.value
                  .qualificationImage) {
                  listId.push(loopData);
                  newqualificationImages.push(
                    process.env.VUE_APP_IMG_URL + loopData,
                  );
                }
              }
              modelMandatory.value.qualificationImage = newqualificationImages;
              modelMandatory.value.imagesList = listId;

              if (modelMandatory.value.faceImage != null) {
                modelMandatory.value.faceImage =
                  process.env.VUE_APP_IMG_URL + modelMandatory.value.faceImage;
              }
              if (modelMandatory.value.cerImage != null) {
                modelMandatory.value.cerImagePreview =
                  (process.env.VUE_APP_IMG_URL ?? "") +
                  modelMandatory.value.cerImage;
                modelMandatory.value.cerImage = null;
              }
            }
          })
          .catch((error) => {
            // console.log(error);
            localStorage.removeItem("u_id");
            localStorage.removeItem("id_token");
            localStorage.removeItem("userInfo");
            router.push({ name: "sign-in" });
          });
      } else {
        router.push({ name: "sign-in" });
      }
      if (route.query.tab) {
        tab.value = route.query.tab;
      } else {
        tab.value = 1;
      }
      if (route.hash) {
        setTimeout(() => {
          const el = document.querySelector(
            `a[href="${route.hash}"]`,
          ) as HTMLElement;
          if (el) el.click();
        }, 300);
      }
      // getDocuments();
      // getBookmark();
    });

    watch(
      () => route.query.tab,
      (newValue) => {
        if (newValue) {
          tab.value = newValue;
        } else {
          tab.value = 1;
        }
        router.go(0);
      },
    );
    const setDate = (birthDate) => {
      let date = new Date(modelEdit.value.birthDate);
      let data = "";
      data += date.getDate() + "/";
      if (date.getMonth() + 1 >= 10) {
        data += date.getMonth() + 1 + "/";
      } else {
        data += "0" + (date.getMonth() + 1) + "/";
      }
      data += date.getFullYear();
      // console.log("====================================");
      // console.log(data);
      // console.log("====================================");
      return data;
    };
    const getCourseRegister = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourseRegister?userId=" +
            localStorage.getItem("u_id") +
            "&page=" +
            page.value +
            "&sizeContents=" +
            limit.value,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        )
        .then((response) => {
          myCourseList.value = response.data.data.content;
          myCourseList.value["totalElements"] =
            response.data.data.totalElements;
          totalPage.value = response.data.data.totalPages;
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const changePage = (pageEvent) => {
      page.value = pageEvent - 1;
      getCourseRegister();
    };
    const backPage = () => {
      page.value = page.value - 1;
      getCourseRegister();
    };
    const nextPage = () => {
      page.value = page.value + 1;
      getCourseRegister();
    };
    const searchData = () => {
      page.value = 0;
      getCourseRegister();
    };
    const checkRequire = (tab2) => {
      errors.value = {};
      errors2.value = {};
      if (!modelEdit.value.firstName) errors.value.firstName = "กรุณาระบุชื่อ";
      if (!modelEdit.value.lastName) errors.value.lastName = "กรุณาระบุนามสกุล";
      if (!modelEdit.value.idCard)
        errors.value.idCard = "กรุณาระบุเลขประจำตัวบัตรประชาชน";
      if (checkIdcard.value == false)
        errors.value.idCard = "กรุณาระบุเลขประจำตัวบัตรประชาชนให้ถูกต้อง";
      if (!modelEdit.value.phoneNumber)
        errors.value.phoneNumber = "กรุณาระบุเบอร์โทรศัพท์";
      if (
        modelEdit.value.phoneNumber &&
        modelEdit.value.phoneNumber.length < 10
      )
        errors.value.phoneNumber = "กรุณาระบุเบอร์โทรศัพท์ให้ครบ 10 หลัก";
      if (!modelEdit.value.qualificationId)
        errors.value.qualificationId = "กรุณาระบุคุณวุฒิ";
      if (!modelEdit.value.qualificationMajor)
        errors.value.qualificationMajor = "กรุณาระบุสาขาวิชา";
      if (!modelEdit.value.officeTypeId)
        errors.value.officeTypeId = "กรุณาเลือกประเภทของหน่วยงาน";
      if (!dialogError.value) {
        if (!modelEdit.value.prefix) errors.value.prefix = "กรุณาระบุคำนำหน้า";
        if (!modelEdit.value.no) errors.value.no = "กรุณาระบุเลขที่";
        if (!modelEdit.value.regionId)
          errors.value.regionId = "กรุณาเลือกภาค";
        if (!modelEdit.value.provinceId)
          errors.value.provinceId = "กรุณาเลือกจังหวัด";
        if (!modelEdit.value.districtId)
          errors.value.districtId = "กรุณาเลือกอำเภอ";
        if (!modelEdit.value.subDistrictId)
          errors.value.subDistrictId = "กรุณาเลือกตำบล";
        if (!modelEdit.value.zipcode)
          errors.value.zipcode = "กรุณาระบุรหัสไปรษณีย์";
      }
      if (
        modelEdit.value.email &&
        !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(modelEdit.value.email)
      )
        errors.value.email = "กรุณาระบุอีเมลให้ถูกต้อง";

      // Specialist fields (if needed by logic)
      // if (modelMandatory.value.facId != "") {
      //   if (!modelMandatory.value.faceImage)
      //     errors2.value.faceImage = "กรุณาแนบรูปหน้าตรง";
      // }
      if (tab2 == true) {
        if (modelMandatory.value.type == 4) {
          if (!modelMandatory.value.becProfType) {
            errors2.value.becProfType = "กรุณาเลือกประเภทวิชาชีพ";
          }
          if (
            !modelMandatory.value.cerImage &&
            !modelMandatory.value.cerImagePreview
          ) {
            errors2.value.cerImage = "กรุณาแนบใบประกอบวิชาชีพ";
          }
          if (!factoryNow.value.addressFac.no)
            errors2.value.addressNo = "กรุณาระบุที่อยู่ที่ทำงาน";
        }
        if (
          modelMandatory.value.type == 1 ||
          modelMandatory.value.type == 2 ||
          modelMandatory.value.type == 3
        ) {
          if (!modelMandatory.value.facId)
            errors2.value.facId = "กรุณาเลือกชื่อสถานที่ทำงาน";
        }
      }

      if (
        Object.keys(errors.value).length === 0 &&
        Object.keys(errors2.value).length === 0
      ) {
        tab1.value = true;
      } else {
        tab1.value = false;
        Swal.fire({
          title: "กรุณากรอกข้อมูลให้ครบถ้วน",
          html:
            Object.values(errors.value)
              .map((err) => `<div class="text-start">- ${err}</div>`)
              .join("") +
            Object.values(errors2.value)
              .map((err) => `<div class="text-start">- ${err}</div>`)
              .join(""),
          icon: "warning",
          confirmButtonText: "ตกลง",
        }).then(() => {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
            document.documentElement.scrollTop = 350;
            document.body.scrollTop = 350;
          }, 500);
        });
      }
      if (tab1.value) {
        return true;
      } else {
        return false;
      }
    };
    const onSubmitRegister = async () => {
      Swal.fire({
        title: "กำลังดำเนินการ...",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      if (checkRequire(false)) {
        let birthDate: number | string = "";
        if (modelEdit.value.birthDate) {
          const parts = modelEdit.value.birthDate.split("/");
          const reordered = parts[1] + "/" + parts[0] + "/" + parseInt(parts[2]);
          birthDate = new Date(reordered).getTime();
        }
        const formData = new FormData();
        formData.append("id ", modelEdit.value["id"]);
        formData.append("type", String(modelEdit.value["type"]));
        formData.append(
          "prefix ",
          modelEdit.value.prefix != null ? modelEdit.value.prefix : "",
        );
        formData.append(
          "firstName",
          modelEdit.value.firstName != null ? modelEdit.value.firstName : "",
        );
        formData.append(
          "lastName",
          modelEdit.value.lastName != null ? modelEdit.value.lastName : "",
        );
        formData.append(
          "idCard",
          modelEdit.value.idCard != null ? modelEdit.value.idCard : "",
        );
        formData.append("birthDate", String(birthDate));
        formData.append("regionCode", modelEdit.value.regionId);
        formData.append(
          "regionTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.region_c
            : "",
        );
        formData.append("provinceCode", modelEdit.value.provinceId);
        formData.append(
          "provinceTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_th
            : "",
        );
        formData.append(
          "provinceEn",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_en
            : "",
        );
        formData.append("districtCode", modelEdit.value.districtId);
        formData.append(
          "districtTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.city_th
            : "",
        );
        formData.append("subDistrictCode", modelEdit.value.subDistrictId);
        formData.append(
          "subDistrictTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.sub_district_name_th
            : "",
        );
        formData.append(
          "zipcode",
          modelEdit.value.zipcode != null && modelEdit.value.zipcode != "null"
            ? modelEdit.value.zipcode
            : "",
        );
        formData.append(
          "road",
          modelEdit.value.road != null && modelEdit.value.road != "null"
            ? modelEdit.value.road
            : "",
        );
        formData.append(
          "no",
          modelEdit.value.no != null && modelEdit.value.no != "null"
            ? modelEdit.value.no
            : "",
        );
        formData.append(
          "moo",
          modelEdit.value.moo != null && modelEdit.value.moo != "null"
            ? modelEdit.value.moo
            : "",
        );
        formData.append(
          "soi",
          modelEdit.value.soi != null && modelEdit.value.soi != "null"
            ? modelEdit.value.soi
            : "",
        );
        formData.append(
          "phoneNumber",
          modelEdit.value.phoneNumber != null &&
            modelEdit.value.phoneNumber != "null"
            ? modelEdit.value.phoneNumber
            : "",
        );
        formData.append("qualificationId", modelEdit.value.qualificationId);
        formData.append(
          "qualificationOther",
          modelEdit.value.qualificationOther != null
            ? modelEdit.value.qualificationOther
            : "",
        );
        formData.append(
          "qualificationMajor",
          modelEdit.value.qualificationMajor != null
            ? modelEdit.value.qualificationMajor
            : "",
        );
        formData.append(
          "officeTypeId",
          modelEdit.value.officeTypeId != null
            ? modelEdit.value.officeTypeId
            : "",
        );
        formData.append(
          "officeExperience",
          modelEdit.value.officeExperience != null
            ? modelEdit.value.officeExperience
            : "",
        );
        formData.append(
          "officePosition",
          modelEdit.value.officePosition != null
            ? modelEdit.value.officePosition
            : "",
        );
        formData.append(
          "officeJobDesc",
          modelEdit.value.officeJobDesc != null
            ? modelEdit.value.officeJobDesc
            : "",
        );

        /* eslint-disable */
        if (modelEdit.value.file != null) {
          const formUploadImage = new FormData();
          formUploadImage.append("file ", modelEdit.value.file!);
          let uploadImage = await axios.post(
            process.env.VUE_APP_API_URL + "/uploadImage",
            formUploadImage,
            { headers: { token: localStorage.getItem("id_token") } },
          );
          // console.log(uploadImage);

          formData.append("imageProfile", uploadImage.data.data!);
        }
        axios
          .post(process.env.VUE_APP_API_URL + "/editProfile", formData, {
            headers: { token: localStorage.getItem("id_token") },
          })
          .then((res) => {
            if (res.data.code == 200) {
              const jsonUser = JSON.stringify({
                email: res.data.data.email,
                firstName: res.data.data.firstName,
                lastName: res.data.data.lastName,
                imageProfile: res.data.data.imageProfile,
              });
              localStorage.setItem("userInfo", jsonUser);
              if (modelMandatory.value.facId != "") {
                // eslint-disable-next-line @typescript-eslint/no-use-before-define
                saveMandatory();
              } else {
                Swal.fire({
                  title: "บันทึกรายการสำเร็จ",
                  text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "ตกลง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-primary",
                  },
                }).then(function(res) {
                  router.go(0);
                });
              }
            } else {
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: res.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: error.response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          });
      }
    };
    const onSubmitSpecialist = async () => {
      Swal.fire({
        title: "กำลังดำเนินการ...",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });

      if (checkRequire(true)) {
        let birthDate: number | string = "";
        if (modelEdit.value.birthDate) {
          const parts = modelEdit.value.birthDate.split("/");
          const reordered = parts[1] + "/" + parts[0] + "/" + parseInt(parts[2]);
          birthDate = new Date(reordered).getTime();
        }
        const formData = new FormData();
        formData.append("id ", modelEdit.value["id"]);
        formData.append("type", String(modelEdit.value["type"]));
        formData.append(
          "prefix ",
          modelEdit.value.prefix != null ? modelEdit.value.prefix : "",
        );
        formData.append(
          "firstName",
          modelEdit.value.firstName != null ? modelEdit.value.firstName : "",
        );
        formData.append(
          "lastName",
          modelEdit.value.lastName != null ? modelEdit.value.lastName : "",
        );
        formData.append(
          "idCard",
          modelEdit.value.idCard != null ? modelEdit.value.idCard : "",
        );

        formData.append("birthDate", String(birthDate));
        formData.append("regionCode", modelEdit.value.regionId);
        formData.append(
          "regionTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.region_c
            : "",
        );
        formData.append("provinceCode", modelEdit.value.provinceId);
        formData.append(
          "provinceTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_th
            : "",
        );
        formData.append(
          "provinceEn",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.province_en
            : "",
        );
        formData.append("districtCode", modelEdit.value.districtId);
        formData.append(
          "districtTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.city_th
            : "",
        );
        formData.append("subDistrictCode", modelEdit.value.subDistrictId);
        formData.append(
          "subDistrictTh",
          currentAdress.value != null && currentAdress.value != undefined
            ? currentAdress.value.sub_district_name_th
            : "",
        );
        formData.append(
          "zipcode",
          modelEdit.value.zipcode != null ? modelEdit.value.zipcode : "",
        );
        console.log("formData", formData);

        formData.append(
          "road",
          modelEdit.value.road != null && modelEdit.value.road != "null"
            ? modelEdit.value.road
            : "",
        );
        formData.append(
          "no",
          modelEdit.value.no != null && modelEdit.value.no != "null"
            ? modelEdit.value.no
            : "",
        );
        formData.append(
          "moo",
          modelEdit.value.moo != null && modelEdit.value.moo != "null"
            ? modelEdit.value.moo
            : "",
        );
        formData.append(
          "soi",
          modelEdit.value.soi != null && modelEdit.value.soi != "null"
            ? modelEdit.value.soi
            : "",
        );
        formData.append(
          "phoneNumber",
          modelEdit.value.phoneNumber != null &&
            modelEdit.value.phoneNumber != "null"
            ? modelEdit.value.phoneNumber
            : "",
        );
        formData.append("qualificationId", modelEdit.value.qualificationId);
        formData.append(
          "qualificationOther",
          modelEdit.value.qualificationOther != null
            ? modelEdit.value.qualificationOther
            : "",
        );
        formData.append(
          "qualificationMajor",
          modelEdit.value.qualificationMajor != null
            ? modelEdit.value.qualificationMajor
            : "",
        );
        formData.append(
          "officeTypeId",
          modelEdit.value.officeTypeId != null
            ? modelEdit.value.officeTypeId
            : "",
        );
        formData.append(
          "officeExperience",
          modelEdit.value.officeExperience != null
            ? modelEdit.value.officeExperience
            : "",
        );
        formData.append(
          "officePosition",
          modelEdit.value.officePosition != null
            ? modelEdit.value.officePosition
            : "",
        );
        formData.append(
          "officeJobDesc",
          modelEdit.value.officeJobDesc != null
            ? modelEdit.value.officeJobDesc
            : "",
        );
        /* eslint-disable */
        if (modelEdit.value.file != null) {
          const formUploadImage = new FormData();
          formUploadImage.append("file ", modelEdit.value.file!);
          let uploadImage = await axios.post(
            process.env.VUE_APP_API_URL + "/uploadImage",
            formUploadImage,
            { headers: { token: localStorage.getItem("id_token") } },
          );
          // console.log(uploadImage);

          formData.append("imageProfile", uploadImage.data.data!);
        }
        axios
          .post(process.env.VUE_APP_API_URL + "/editProfile", formData, {
            headers: { token: localStorage.getItem("id_token") },
          })
          .then((res) => {
            if (res.data.code == 200) {
              const jsonUser = JSON.stringify({
                email: res.data.data.email,
                firstName: res.data.data.firstName,
                lastName: res.data.data.lastName,
                imageProfile: res.data.data.imageProfile,
              });
              localStorage.setItem("userInfo", jsonUser);
              saveMandatoryTrue();
              // if (modelMandatory.value.facId != "") {
              //   // eslint-disable-next-line @typescript-eslint/no-use-before-define
              //   saveMandatoryTrue();
              // } else {
              //   Swal.fire({
              //     title: "บันทึกรายการสำเร็จ",
              //     text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              //     icon: "success",
              //     buttonsStyling: false,
              //     confirmButtonText: "ตกลง!",
              //     customClass: {
              //       confirmButton: "btn fw-semobold btn-light-primary",
              //     },
              //   }).then(function(res) {
              //     router.go(0);
              //   });
              // }
            } else {
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: res.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            }
          })
          .catch((error) => {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: error.response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          });
      }
    };

    /* eslint-disable */
    const saveMandatory = () => {
      const factoryTypes: any = [];
      for (const loopFactory of modelMandatory.value.factoryTypes) {
        if (loopFactory != undefined) {
          factoryTypes.push({
            code: loopFactory,
            other:
              loopFactory == "10" ? modelMandatory.value.factoryTypeOther : "",
          });
        }
      }

      const buildingTypes: any = [];
      for (const loopBuild of modelMandatory.value.buildingTypes) {
        if (loopBuild != undefined) {
          buildingTypes.push({
            code: loopBuild,
            other:
              loopBuild == "6" ? modelMandatory.value.buildingTypeOther : "",
          });
        }
      }

      const machinesMap: any = [];
      if (modelMandatory.value.machines != null) {
        for (const loopMachine of modelMandatory.value.machines) {
          if (loopMachine != undefined) {
            machinesMap.push({
              code: loopMachine,
              other:
                loopMachine == "6" ? modelMandatory.value.machineOther : "",
            });
          }
        }
      }

      let technologiesMap: any = [];
      if (modelMandatory.value.technologies != null) {
        for (const loopTech of modelMandatory.value.technologies) {
          if (loopTech != undefined) {
            technologiesMap.push({
              code: loopTech,
              other:
                loopTech == "6" ? modelMandatory.value.technologieOther : "",
            });
          }
        }
      }

      const formData = new FormData();
      formData.append("requestSpecialist", "false");
      formData.append("factoryId", modelMandatory.value.facId);
      formData.append(
        "preFactoryNo",
        modelMandatory.value.preFactoryNo != null
          ? modelMandatory.value.preFactoryNo
          : "",
      );
      formData.append(
        "preBuildingNo",
        modelMandatory.value.preBuildingNo != null
          ? modelMandatory.value.preBuildingNo
          : "",
      );
      formData.append(
        "officeTypeId",
        modelMandatory.value.officeTypeId != null
          ? modelMandatory.value.officeTypeId
          : "",
      );
      formData.append(
        "factorySizeId",
        modelMandatory.value.factorySizeId != null
          ? modelMandatory.value.factorySizeId
          : "",
      );
      formData.append("factoryTypes", JSON.stringify(factoryTypes));
      formData.append(
        "buildingSizeId",
        modelMandatory.value.buildingSizeId != null
          ? modelMandatory.value.buildingSizeId
          : "",
      );
      formData.append("buildingTypes", JSON.stringify(buildingTypes));
      formData.append("companyElectric", modelMandatory.value.companyElectric);
      formData.append(
        "companyTransformer",
        modelMandatory.value.companyTransformer,
      );
      formData.append("companyHeat", modelMandatory.value.companyHeat);
      formData.append("companyFuel", modelMandatory.value.companyFuel);
      formData.append("machines", JSON.stringify(machinesMap));
      formData.append("technologies", JSON.stringify(technologiesMap));
      formData.append(
        "warrantorFirstname",
        modelMandatory.value.warrantorFirstname,
      );
      formData.append(
        "warrantorLastname",
        modelMandatory.value.warrantorLastname,
      );
      formData.append(
        "warrantorPosition",
        modelMandatory.value.warrantorPosition,
      );
      formData.append("warrantorOffice", modelMandatory.value.warrantorOffice);
      formData.append("type", modelMandatory.value.type + "");
      formData.append("certType", modelMandatory.value.becProfType + "");
      if (modelMandatory.value.fileImages) {
        for (const loopfile of modelMandatory.value.fileImages) {
          formData.append("qualificationImage", loopfile);
        }
      }
      /* eslint-disable */
      if (modelMandatory.value.fileAvatar != null) {
        formData.append("faceImage", modelMandatory.value.fileAvatar!);
      }
      if (modelMandatory.value.cerImage != null) {
        formData.append("cerImage", modelMandatory.value.cerImage!);
      }
      if (modelMandatory.value.delImages) {
        for (const loopfile of modelMandatory.value.delImages) {
          formData.append("deleteQualificationImage", loopfile);
        }
      }
      if (modelMandatory.value.type == 4) {
        formData.append("addressType4", factoryNow.value.addressFac.no);
      } else {
        formData.append("addressType4", "");
      }
      axios
        .post(process.env.VUE_APP_API_URL + "/editSpecialist", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function(res) {
              router.go(0);
            });
          } else {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              router.go(-1);
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const saveMandatoryTrue = () => {
      const factoryTypes: any = [];
      for (const loopFactory of modelMandatory.value.factoryTypes) {
        if (loopFactory != undefined) {
          factoryTypes.push({
            code: loopFactory,
            other:
              loopFactory == "10" ? modelMandatory.value.factoryTypeOther : "",
          });
        }
      }

      const buildingTypes: any = [];
      for (const loopBuild of modelMandatory.value.buildingTypes) {
        if (loopBuild != undefined) {
          buildingTypes.push({
            code: loopBuild,
            other:
              loopBuild == "6" ? modelMandatory.value.buildingTypeOther : "",
          });
        }
      }

      let machinesMap: any = [];
      if (modelMandatory.value.machines != null) {
        for (const loopMachine of modelMandatory.value.machines) {
          if (loopMachine != undefined) {
            machinesMap.push({
              code: loopMachine,
              other:
                loopMachine == "6" ? modelMandatory.value.machineOther : "",
            });
          }
        }
      }

      let technologiesMap: any = [];
      if (modelMandatory.value.technologies != null) {
        for (const loopTech of modelMandatory.value.technologies) {
          if (loopTech != undefined) {
            technologiesMap.push({
              code: loopTech,
              other:
                loopTech == "6" ? modelMandatory.value.technologieOther : "",
            });
          }
        }
      }

      const formData = new FormData();
      formData.append("requestSpecialist", currentType.value && currentType.value == modelMandatory.value.type ? "false" : "true");
      formData.append("factoryId", modelMandatory.value.facId);
      formData.append(
        "preFactoryNo",
        modelMandatory.value.preFactoryNo != null
          ? modelMandatory.value.preFactoryNo
          : "",
      );
      formData.append(
        "preBuildingNo",
        modelMandatory.value.preBuildingNo != null
          ? modelMandatory.value.preBuildingNo
          : "",
      );
      formData.append(
        "officeTypeId",
        modelMandatory.value.officeTypeId != null
          ? modelMandatory.value.officeTypeId
          : "",
      );
      formData.append(
        "factorySizeId",
        modelMandatory.value.factorySizeId != null
          ? modelMandatory.value.factorySizeId
          : "",
      );
      formData.append("factoryTypes", JSON.stringify(factoryTypes));
      formData.append(
        "buildingSizeId",
        modelMandatory.value.buildingSizeId != null
          ? modelMandatory.value.buildingSizeId
          : "",
      );
      formData.append("buildingTypes", JSON.stringify(buildingTypes));
      formData.append("companyElectric", modelMandatory.value.companyElectric);
      formData.append(
        "companyTransformer",
        modelMandatory.value.companyTransformer,
      );
      formData.append(
        "companyHeat",
        modelMandatory.value.companyHeat != null
          ? modelMandatory.value.companyHeat
          : "",
      );
      formData.append(
        "companyFuel",
        modelMandatory.value.companyFuel != null
          ? modelMandatory.value.companyFuel
          : "",
      );
      formData.append("machines", JSON.stringify(machinesMap));
      formData.append("technologies", JSON.stringify(technologiesMap));
      formData.append(
        "warrantorFirstname",
        modelMandatory.value.warrantorFirstname,
      );
      formData.append(
        "warrantorLastname",
        modelMandatory.value.warrantorLastname,
      );
      formData.append(
        "warrantorPosition",
        modelMandatory.value.warrantorPosition,
      );
      formData.append("warrantorOffice", modelMandatory.value.warrantorOffice);
      formData.append("type", modelMandatory.value.type + "");
      formData.append("certType", modelMandatory.value.becProfType + "");
      if (modelMandatory.value.fileImages) {
        for (const loopfile of modelMandatory.value.fileImages) {
          formData.append("qualificationImage", loopfile);
        }
      }
      /* eslint-disable */
      if (modelMandatory.value.fileAvatar != null) {
        formData.append("faceImage", modelMandatory.value.fileAvatar!);
      }
      if (modelMandatory.value.cerImage != null) {
        formData.append("cerImage", modelMandatory.value.cerImage!);
      }
      if (modelMandatory.value.delImages) {
        for (const loopfile of modelMandatory.value.delImages) {
          formData.append("deleteQualificationImage", loopfile);
        }
      }
      if (modelMandatory.value.type == 4) {
        formData.append("addressType4", factoryNow.value.addressFac.no);
      } else {
        formData.append("addressType4", "");
      }
      axios
        .post(process.env.VUE_APP_API_URL + "/editSpecialist", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "กรุณารอการอนุมัติข้อมูลจากแอดมิน",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function(res) {
              router.go(0);
            });
          } else {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              router.go(-1);
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const callFactories = async (val) => {
      // console.log(val);
      if (val.length > 2) {
        const factories = await axios.get(
          process.env.VUE_APP_API_URL +
            `/getFactory?sizeContents=100&keyWord=${val}`,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        );
        // console.log(factories.data.data.content);
        factoriesList.value = factories.data.data.content;
      }
    };
    const clearFactory = () => {
      modelMandatory.value.facId = "";
      modelMandatory.value.factoryTypes = [];
      modelMandatory.value.buildingTypes = [];
      modelMandatory.value.facBuildTypeId = [];
      search.value = "";
      factoriesList.value = [];
      factoryNow.value = {
        address: "",
        addressProfile: {},
        addressFac: {
          no: "",
          moo: "",
          soi: "",
          road: "",
          regionTh: "",
          provinceTh: "",
          districtTh: "",
          subDistrictTh: "",
          zipcode: "",
        },
      };
    };
    const callFactoriesId = async () => {
      modelMandatory.value.factoryTypes = [];
      modelMandatory.value.buildingTypes = [];
      const factory = await axios.get(
        process.env.VUE_APP_API_URL +
          `/getFactory?facId=${modelMandatory.value.facId}`,
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      // console.log(factory.data.data);
      const factoryData = factory.data.data.content[0];
      if (!factoryData) return;
      if (!factoryData["addressFac"]) {
        factoryData["addressFac"] = {
          no: "",
          moo: "",
          soi: "",
          road: "",
          regionTh: "",
          provinceTh: "",
          districtTh: "",
          subDistrictTh: "",
          zipcode: "",
        };
      }
      factoryNow.value = factoryData;
      search.value = factoryNow.value["factoryName"];
      let facBuildTypeId: any = [];
      facBuildTypeId.push(factoryNow.value["facBuildTypeId"]);
      // console.log(factoryNow.value["facBuildTypeId"]);
      if (factoryNow.value["type"] == "โรงงาน") {
        modelMandatory.value.facBuildTypeId = facBuildTypeId;
      } else {
        modelMandatory.value.facBuildTypeId = facBuildTypeId;
      }
      // modelMandatory.value.factoryTypes
      callFactories(search.value);
    };
    const getCertificateId = async (id) => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let checkSurvey = await axios.get(
        process.env.VUE_APP_API_URL + "/checkCertApproveSurvey",
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      console.log("checkSurvey", checkSurvey.data.data, checkSurvey.data.code);
      if (checkSurvey.data.code == 400) {
        if (certWindow) certWindow.close();
        dialogSurvey.value = true;
        console.log("getCertificateId", dialogSurvey.value);
        surveyCourseId.value = id;
        surveyData.value = {
          q1: null,
          q2: null,
          q3: null,
          q4: null,
          q5: null,
          suggestion: "",
        };
      } else {
        proceedDownloadCertificate(id, certWindow);
      }
    };
    const proceedDownloadCertificate = async (id, certWindow: any = null) => {
      const certificate = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?id=" +
          id +
          "&userId=" +
          localStorage.getItem("u_id"),
        {
          headers: { token: localStorage.getItem("id_token") },
        },
      );
      listCertificate.value = certificate.data.data.content[0];
      downloadCertificate(id, certWindow);
    };
    const submitSurvey = async () => {
      // เปิดหน้าต่างทันทีขณะยังอยู่ใน user gesture ป้องกัน popup blocker บน iOS Safari
      const certWindow = window.open("", "_blank");
      let fromData = new FormData();
      fromData.append("q1", surveyData.value.q1 + "");
      fromData.append("q2", surveyData.value.q2 + "");
      fromData.append("q3", surveyData.value.q3 + "");
      fromData.append("q4", surveyData.value.q4 + "");
      fromData.append("q5", surveyData.value.q5 + "");
      fromData.append("q6", surveyData.value.suggestion);
      await axios.post(
        process.env.VUE_APP_API_URL + "/addEditCertApproveSurvey",
        fromData,
        {
          headers: {
            token: localStorage.getItem("id_token"),
            "Content-Type": "multipart/form-data",
          },
        },
      );
      console.log("Survey submitted:", surveyData.value);
      dialogSurvey.value = false;
      proceedDownloadCertificate(surveyCourseId.value, certWindow);
    };
    const getCertificateSyllabusId = async (id) => {
      Swal.fire({
        title: "กำลังดาวน์โหลดใบประกาศนียบัตร",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getSyllabusCertPdf?syllabusRegisterId=" +
            id,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        )
        .then((response) => {
          const content = response.data.data.content;
          if (content?.length > 0 && content[0].certificate) {
            window.open(
              process.env.VUE_APP_IMG_URL + content[0].certificate,
              "_blank",
            );
            Swal.close();
          } else {
            Swal.fire({
              title: "ไม่พบใบประกาศนียบัตร",
              text: "กรุณาลองใหม่อีกครั้ง",
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response?.data?.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const downloadCertificate = async (id, certWindow: any = null) => {
      // ถ้ายังไม่มีหน้าต่างที่เปิดไว้จาก user gesture (เช่น มาจากฟอร์มแบบสำรวจ) ให้เปิดตอนนี้
      if (!certWindow) {
        certWindow = window.open("", "_blank");
      }
      Swal.fire({
        title: "กำลังดาวน์โหลดใบประกาศนียบัตร",
        allowOutsideClick: false,
        onBeforeOpen: () => {
          Swal.showLoading();
        },
      });
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/downloadCertificateCourse?courseRegisterId=" +
            id,
          {
            headers: { token: localStorage.getItem("id_token") },
            responseType: "blob", // กำหนดให้รับข้อมูลเป็น Blob
          },
        )
        .then(async (res) => {
          console.log(res);

          if (res.data) {
            const contentDisposition = res.headers["content-disposition"];
            const fileName = contentDisposition
              ? contentDisposition.split("filename=")[1]
              : "certificate.pdf";

            // ตรวจสอบเนื้อหาในกรณีเกิดข้อผิดพลาด
            if (res.data.type === "application/json") {
              const text = await res.data.text();
              const errorData = JSON.parse(text);
              console.error("Error downloading PDF:", errorData.message);
              if (certWindow) certWindow.close();
              Swal.fire({
                title: "ดาวน์โหลดไฟล์ไม่สำเร็จ",
                text: "กรุณาลองใหม่อีกครั้ง",
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "ตกลง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-primary",
                },
              });
              return;
            }

            // สร้าง Blob URL แล้วนำหน้าต่างที่เปิดไว้ตั้งแต่ตอน user gesture ไปที่ URL นั้น
            // (iOS Safari บล็อก window.open ที่เรียกหลัง await/.then เพราะไม่ถือเป็น user gesture แล้ว)
            const url = window.URL.createObjectURL(
              new Blob([res.data], { type: "application/pdf" }),
            );
            if (certWindow) {
              certWindow.location.href = url;
            } else {
              window.open(url, "_blank");
            }
            Swal.close();
          } else {
            if (certWindow) certWindow.close();
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          if (certWindow) certWindow.close();
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    };
    const assertThaiId = (thaiId: string): boolean => {
      // console.log("assertThaiId : " + thaiId);
      const m = thaiId.match(/(\d{12})(\d)/);
      if (!m) {
        console.warn("Bad input from user, invalid thaiId=", thaiId);
        throw new Error("thai-id-must-be-13-digits");
      }
      const digits = m[1].split("");
      const sum = digits.reduce((total: number, digit: string, i: number) => {
        return total + (13 - i) * +digit;
      }, 0);
      const lastDigit = `${(11 - (sum % 11)) % 10}`;
      const inputLastDigit = m[2];
      if (lastDigit !== inputLastDigit) {
        console.warn("Bad input from user, invalid checksum thaiId=", thaiId);
        // throw new Error("thai-id-checksum-mismatched");
        checkIdcard.value = false;
        return false;
      } else {
        checkIdcard.value = true;
        return true;
      }
    };
    const arabic_to_thai = (text) => {
      let data = text
        .replaceAll("1", "๑")
        .replaceAll("2", "๒")
        .replaceAll("3", "๓")
        .replaceAll("4", "๔")
        .replaceAll("5", "๕")
        .replaceAll("6", "๖")
        .replaceAll("7", "๗")
        .replaceAll("8", "๘")
        .replaceAll("9", "๙")
        .replaceAll("0", "๐");
      return data;
    };
    const updatePdpaAllowed = async (flg) => {
      try {
        const response = await axios.post(
          process.env.VUE_APP_API_URL + "/updatePdpaAllowed?pdpaAllowed=" + flg,
          null,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        );
        console.log(response.data);

        if (response.data.code == 200) {
          dialogPolicy.value = false;
          dialogDeletePdpa.value = false;
          userInfo.value.pdpaAllowed = flg == "true";
          if (flg == "false") {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "คุณได้ยกเลิกความยินยอมในการเก็บข้อมูลส่วนบุคคลแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function(res) {
              router.go(0);
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    return {
      route,
      userInfo,
      modelEdit,
      modelEditLoaded,
      onSubmitRegister,
      checkRequire,
      modelMandatory,
      saveMandatory,
      saveMandatoryTrue,
      onSubmitSpecialist,
      tab,
      callFactoriesId,
      clearFactory,
      callFactories,
      search,
      factoriesList,
      factoryNow,
      myCourseList,
      syllabusList,
      getCourseRegister,
      getCertificateId,
      listCertificate,
      downloadCertificate,
      tab1,
      getCertificateSyllabusId,
      assertThaiId,
      checkIdcard,
      arabic_to_thai,
      changePage,
      backPage,
      nextPage,
      searchData,
      limit,
      page,
      totalPage,
      currentAdress,
      dialogError,
      dialogDeleteUser,
      dialogDeleteConfirmed,
      dialogDeletePopup,
      dialogDeletePdpa,
      dialogSurvey,
      surveyOptions,
      surveyData,
      submitSurvey,
      dialogPolicy,
      dialogNotification,
      updatePdpaAllowed,
      errors,
      errors2,
      showMandatoryTabs,
      activeInfoTab,
      currentType
    };
  },
  computed: {
    needSetupAuth() {
      // รอจนกว่า modelEdit จะถูก set จาก API ก่อน ค่อยประเมิน
      if (!(this as any).modelEditLoaded) return false;
      const m: any = (this as any).modelEdit;
      if (!m) return false;
      const hasEmail =
        m.email && String(m.email).trim() !== "" && m.email != null;
      const hasIdCard = m.idCard && String(m.idCard).trim() !== "";
      return !hasEmail && hasIdCard;
    },
  },
  methods: {
    onMandatoryTypeChange(val: number) {
      if (val === 4) {
        (this as any).clearFactory();
        (this as any).errors2.addressNo = "";
      } else {
        (this as any).errors2.facId = "";
      }
    },
    validateAuthEmail() {
      this.authEmail = (this.authEmail || "").replace(/[฀-๿]/g, "");
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.authEmailValid = emailRegex.test(this.authEmail || "");
    },
    validateAuthPassword() {
      this.authValidate = 0;
      const letterRegex = /[a-zA-Z]/;
      const numberRegex = /[0-9]/;
      const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;
      const pwd = this.authPassword || "";
      if (pwd.length >= 8) this.authValidate++;
      if (letterRegex.test(pwd)) this.authValidate++;
      if (numberRegex.test(pwd)) this.authValidate++;
      if (symbolRegex.test(pwd)) this.authValidate++;
      this.validateAuthConfirm();
    },
    validateAuthConfirm() {
      this.authValidateCpassword =
        this.authPasswordConfirm === "" ||
        this.authPassword === this.authPasswordConfirm;
    },
    async submitUserAuth() {
      this.validateAuthEmail();
      if (
        !this.authEmail ||
        !this.authEmailValid ||
        this.authValidate !== 4 ||
        this.authPassword !== this.authPasswordConfirm
      ) {
        Swal.fire({
          title: "ข้อมูลไม่ครบถ้วน",
          text: "กรุณากรอกอีเมลและรหัสผ่านให้ถูกต้องตามเงื่อนไข",
          icon: "warning",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-warning",
          },
        });
        return;
      }
      const formData = new FormData();
      formData.append("email", this.authEmail);
      formData.append("userName", this.authEmail);
      formData.append("password", this.authPassword);
      await axios
        .post(process.env.VUE_APP_API_URL + "/updateUserAuth", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกสำเร็จ",
              text: "ตั้งชื่อผู้ใช้งานและรหัสผ่านเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(() => {
              this.authEmail = "";
              this.authPassword = "";
              this.authPasswordConfirm = "";
              this.authValidate = 0;
              this.$router.go(0);
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    validateThai(input, value) {
      const thaiRegex = /^[\u0E00-\u0E7F]+$/;
      let check = thaiRegex.test(value);
      if (input == "firstName" && check != true) {
        modelEdit.value.firstName = "";
      }
      if (input == "lastName" && check != true) {
        modelEdit.value.lastName = "";
      }
    },
    formatDate(date) {
      const event = new Date(date);
      let dateString =
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) + "";
      return dateString;
    },
    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
    switchVisibility2() {
      this.passwordFieldType2 =
        this.passwordFieldType2 === "password" ? "text" : "password";
    },
    switchVisibility3() {
      this.passwordFieldType3 =
        this.passwordFieldType3 === "password" ? "text" : "password";
    },

    setAltImg(event) {
      event.target.src = "media/avatars/blank.png";
    },
    setAltImgCover(event) {
      event.target.src = "media/image-app/no-data.svg";
    },
    removeStyle(html) {
      const regex = /(style=".+?")/gm;
      const str = html;
      const subst = ``;
      const result = str.replace(regex, subst);
      return result;
    },
    onFileChange(event) {
      modelEdit.value.file = event.target.files[0];
      modelEdit.value.imageProfile = URL.createObjectURL(event.target.files[0]);
    },
    onFileChangeMultiple(event) {
      const deleteFile: any = [];
      if (modelMandatory.value.imagesList) {
        for (const loopDel of modelMandatory.value.imagesList) {
          deleteFile.push(loopDel);
        }
      }
      modelMandatory.value.delImages = deleteFile;
      modelMandatory.value.fileImages = event.target.files;
      if (event.target.files.length > 0 || event.target.files.length == 3) {
        const image: any = [];
        for (const loopFile of event.target.files) {
          image.push(URL.createObjectURL(loopFile));
        }
        modelMandatory.value.qualificationImage = image;
      } else {
        Swal.fire({
          title: "แจ้งเตือนข้อผิดพลาด",
          text: "จำนวนรูปไม่ถูกต้อง แนบไฟล์จำนวน 3 ไฟล์",
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
          customClass: {
            confirmButton: "btn fw-semobold btn-light-danger",
          },
        });
      }
    },
    onFileChangeAvatar(event) {
      modelMandatory.value.fileAvatar = event.target.files[0];
      modelMandatory.value.faceImage = URL.createObjectURL(
        event.target.files[0],
      );
    },
    onFileChangeCerImage(event) {
      const file = event.target.files[0];
      if (!file) return;
      modelMandatory.value.cerImage = file;
      modelMandatory.value.cerImagePreview = URL.createObjectURL(file);
    },
    fileCerImageClick() {
      (this.$refs.fileCerImage as HTMLInputElement).click();
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      // eslint-disable-next-line prefer-const
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    async callProvince(regionId, clear) {
      if (clear == true) {
        modelEdit.value.provinceId = "";
        modelEdit.value.districtId = "";
        modelEdit.value.subDistrictId = "";
        modelEdit.value.zipcode = "";
      }
      const provinces = await ReferenceDataApi.getProvinces();
      this.provinceList = (provinces.data.data || []).filter(
        (p) => p.region_code == regionId,
      );
    },
    async callDistrict(provinceId, clear) {
      if (clear == true) {
        modelEdit.value.districtId = "";
        modelEdit.value.subDistrictId = "";
        modelEdit.value.zipcode = "";
      }
      const districts = await ReferenceDataApi.getDistricts(provinceId);
      this.districtList = districts.data.data;
    },
    async callSubDistrict(districtId, clear) {
      if (clear == true) {
        modelEdit.value.subDistrictId = "";
        modelEdit.value.zipcode = "";
      }
      try {
        let response = await ReferenceDataApi.getSubDistricts(
          modelEdit.value.provinceId,
          districtId,
        );
        this.subDistrictList = response.data.data;
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferenceSubDistricts",
          message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
        });
      }
    },
    callZipcode(subDistrictId, clear) {
      if (clear == true) {
        modelEdit.value.zipcode = "";
      }
      if (this.subDistrictList.length > 0) {
        for (const loopData of this.subDistrictList) {
          if (loopData["sub_district_code"] == subDistrictId) {
            currentAdress.value = loopData;
            modelEdit.value.zipcode = loopData["postcode"];
          }
        }
      }
    },

    // async callFactories() {
    //   const factories = await axios.get(
    //     process.env.VUE_APP_API_URL + `/getFactory?sizeContents=99999&keyWord=${this.search}`
    //   ,{
    //     headers:headers
    //   });
    // console.log(factories.data.data.content);
    //   this.factoriesList = factories.data.data.content;
    // },
    // async callFactoriesId() {
    //   const factory = await axios.get(
    //     process.env.VUE_APP_API_URL +
    //       `/getFactory?id=${modelMandatory.value.facId}`
    //   ,{
    //     headers:headers
    //   });
    // console.log(factory.data.data);
    //   this.factory = factory.data.data.content[0];
    //   this.search = this.factory["factoryName"];
    //   this.callFactories();
    // },
    setBuildingTypes(id) {
      if (
        modelMandatory.value &&
        modelMandatory.value.buildingTypes.length > 0
      ) {
        for (const loopdata of modelMandatory.value.buildingTypes) {
          if (loopdata["buildingTypeId"] == id) {
            return true;
          }
        }
      } else {
        return false;
      }
    },
    fileMultipleClick() {
      // console.log(this.$refs.fileMultiple);
      const input: any = this.$refs.fileMultiple;
      input.click();
    },
    fileAvatarClick() {
      // console.log(this.$refs.fileAvatar);
      const input: any = this.$refs.fileAvatar;
      input.click();
    },
    fileClick() {
      // console.log(this.$refs.file);
      const input: any = this.$refs.file;
      input.click();
    },
    renderCategory(list) {
      let data: any = [];
      if (list.length > 0) {
        for (const looplist of list) {
          data.push(looplist[0].data);
        }
      }
      if (data.length > 0) {
        return data.join(",");
      } else {
        return "-";
      }
    },
    renderStatus(status) {
      if (status == 1 || status == 2) {
        return "<span style='color:#9999D3'>เรียนต่อ</span>";
      } else if (status == 3) {
        return "<span style='color:#31B67C'>เรียนจบ</span>";
      } else if (status == 4) {
        return "<span style='color:#FF7786'>ไม่ผ่านหลักสูตร</span>";
      } else if (status == 5) {
        return "<span style='color:#F2A17D'>หมดเวลาเรียน</span>";
      } else {
        return "-";
      }
    },
    handleData1(data) {
      this.rate1 = data;
    },
    handleData2(data) {
      this.rate2 = data;
    },
    handleData3(data) {
      this.rate3 = data;
    },
    handleData4(data) {
      this.rate4 = data;
    },
    async setId(id) {
      this.rateId = id;
      this.rate1 = 0;
      this.rate2 = 0;
      this.rate3 = 0;
      this.rate4 = 0;
    },
    async sentScore() {
      const formData = new FormData();
      formData.append("id", this.rateId + "");
      formData.append("rate1", this.rate1 + "");
      formData.append("rate2", this.rate2 + "");
      formData.append("rate3", this.rate3 + "");
      formData.append("rate4", this.rate4 + "");
      formData.append("remark", "");

      await axios
        .post(process.env.VUE_APP_API_URL + "/updateCourseRate", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(function() {
              router.go(0);
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    onBack() {
      this.$router.go(-1);
    },
    showForm(data) {
      this.formpassword = data;
    },
    validatePassword() {
      this.validate = 0;
      const letterRegex = /[a-zA-Z]/;
      const numberRegex = /[0-9]/;
      const symbolRegex = /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-]/;

      const isValidLength = this.newPassword.length >= 8;
      const hasLetter = letterRegex.test(this.newPassword);
      const hasNumber = numberRegex.test(this.newPassword);
      const hasSymbol = symbolRegex.test(this.newPassword);

      if (isValidLength) {
        this.validate = this.validate + 1;
      }
      if (hasLetter) {
        this.validate = this.validate + 1;
      }
      if (hasNumber) {
        this.validate = this.validate + 1;
      }
      if (hasSymbol) {
        this.validate = this.validate + 1;
      }
      // console.log("validatePassword");
      // console.log(this.validate);
      // return isValidLength && hasLetter && hasNumber && hasSymbol;
    },
    validateConfirmpassword() {
      if (this.newPassword == this.newPasswordConfirm) {
        this.validateCpassword = true;
      } else {
        this.validateCpassword = false;
      }
    },
    async changePassword() {
      const formData = new FormData();
      formData.append("oldPassword", this.oldPassword);
      formData.append("newPassword", this.newPassword);
      formData.append("newPasswordConfirm", this.newPasswordConfirm);

      await axios
        .post(process.env.VUE_APP_API_URL + "/changeUserPassword", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "เปลี่ยนรหัสผ่านสำเร็จ",
              text: "รหัสผ่านถูกเปลี่ยนแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(() => {
              this.oldPassword = "";
              this.newPassword = "";
              this.newPasswordConfirm = "";
              this.formpassword = false;
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    onBaclk() {
      this.$router.go(-1);
    },
    setRemarkDelete(event) {
      this.remarkDeleteUser = event.target.value;
    },
    submitDelete() {
      axios
        .delete(
          process.env.VUE_APP_API_URL +
            `/deleteProfileByUser?deleteRemarkId=${this.remarkDeleteUser}&deleteRemarkOth=${this.remarkDeleteOther}`,
          {
            headers: { token: localStorage.getItem("id_token") },
          },
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.dialogDeletePopup = false;
            this.dialogDeleteConfirmed = false;
            this.dialogDeleteUser = false;
            this.dialogDeletePdpa = false;
            this.dialogError = false;
            this.dialogSurvey = false;
            Swal.fire({
              title: "การลบบัญชีผู้ใช้งานสำเร็จ",
              text: "",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-primary",
              },
            }).then((res) => {
              const preserveKeys = ["timer", ...Object.keys(localStorage).filter(k => k.startsWith("ExamQuestion_") || k.startsWith("ExamLearnQuestion_") || k.startsWith("examLearnAnswersList_") || k.startsWith("ExamAnswersList_"))];
              const preserved = preserveKeys.map(k => [k, localStorage.getItem(k) ?? ""]);
              localStorage.clear();
              preserved.forEach(([k, v]) => { if (v) localStorage.setItem(k, v); });
              router.push({ name: "sign-in" });
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    deleteActivity() {
      Swal.fire({
        title: "แจ้งเตือน",
        text: "ต้องลบข้อมูลการลงทะเบียนเรียนทั้งหมดใช่หรือไม่ !",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#323563",
        cancelButtonColor: "#ff7786",
        allowOutsideClick: false,
        confirmButtonText: "ใช่",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete(process.env.VUE_APP_API_URL + "/deleteActivity", {
              headers: {
                token: localStorage.getItem("id_token"),
              },
            })
            .then((res) => {
              if (res.data.code == 200) {
                Swal.fire({
                  title: "ลบข้อมูลการลงทะเบียนเรียนสำเร็จ",
                  text: "",
                  icon: "success",
                  buttonsStyling: false,
                  confirmButtonText: "ตกลง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-app-primary",
                  },
                }).then((res) => {
                  this.$router.go(0);
                });
              } else {
                Swal.fire({
                  title: "แจ้งเตือนข้อผิดพลาด",
                  text: res.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              }
            })
            .catch((error) => {
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.response.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      });
    },
    dateDifference(startDate, endDate) {
      let start: any = new Date(startDate);
      let end: any = new Date(endDate);

      var difference = Math.abs(end - start) / 1000;
      // Calculate minutes and seconds
      var minutes = Math.floor(difference / 60);
      var seconds = Math.floor(difference % 60);

      // Format minutes and seconds
      var formattedMinutes = minutes < 10 ? "0" + minutes : minutes;
      var formattedSeconds = seconds < 10 ? "0" + seconds : seconds;

      return formattedMinutes + ":" + formattedSeconds;
    },
  },
  async mounted() {
    // if (localStorage.getItem("reloaded")) {
    //   location.reload();
    //   localStorage.removeItem("reloaded");
    // }
    Swal.fire({
      title: "กำลังโหลดข้อมูล",
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      },
    });
    try {
      const qualifications = await axios.get(
        process.env.VUE_APP_API_URL + "/getQualification",
      );
      this.qualificationList = qualifications.data.data;

      const officeTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getOfficeType",
      );
      this.officeTypeList = officeTypes.data.data;
      const buildingSizes = await axios.get(
        process.env.VUE_APP_API_URL + "/getBuildingSize",
      );
      this.buildingSizesList = buildingSizes.data.data;

      const buildingTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getBuildingTypes",
      );
      this.buildingTypesList = buildingTypes.data.data;

      const factorySizes = await axios.get(
        process.env.VUE_APP_API_URL + "/getFactorySize",
      );
      this.factorySizesList = factorySizes.data.data;

      const factoryTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getFactoryTypes",
      );
      this.factoryTypesList = factoryTypes.data.data;

      const technologies = await axios.get(
        process.env.VUE_APP_API_URL + "/getTechnologies",
      );
      this.technologiesList = technologies.data.data;

      const machines = await axios.get(
        process.env.VUE_APP_API_URL + "/getMachines",
      );
      this.machinesList = machines.data.data;

      const factoryBuildingTypes = await axios.get(
        process.env.VUE_APP_API_URL + "/getFactoryBuildingTypes",
      );
      this.factoryBuildingTypesList = factoryBuildingTypes.data.data;
      setTimeout(() => {
        if (modelMandatory.value.facId) {
          this.callFactoriesId();
        }
      }, 1000);

      try {
        let response = await ReferenceDataApi.getPrenames();
        this.prefixList = response.data.data;
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferencePrenames",
          message: "ไม่สามารถเชื่อมต่อกับฐานข้อมูล กพบ ได้ในขณะนี้",
        });
      }
      try {
        let response = await ReferenceDataApi.getRegions();
        this.regionList = response.data.data;
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferenceRegions",
          message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
        });
      }

      try {
        if (
          modelEdit.value.regionId &&
          this.regionList &&
          this.regionList.length > 0
        ) {
          await this.callProvince(modelEdit.value.regionId, false);
        }
        if (
          modelEdit.value.provinceId &&
          this.provinceList &&
          this.provinceList.length > 0
        ) {
          await this.callDistrict(modelEdit.value.provinceId, false);
        }
        if (
          modelEdit.value.districtId &&
          this.districtList &&
          this.districtList.length > 0
        ) {
          await this.callSubDistrict(modelEdit.value.districtId, false);
        }
        if (
          modelEdit.value.subDistrictId &&
          this.subDistrictList &&
          this.subDistrictList.length > 0
        ) {
          await this.callZipcode(modelEdit.value.subDistrictId, false);
        }
      } catch (error) {
        (this.listErrorApi as any).push({
          api: process.env.VUE_APP_API_URL + "/getReferenceProvinces",
          message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
        });
      }

      if (this.listErrorApi && this.listErrorApi.length > 0) {
        dialogError.value = true;
      } else {
        dialogError.value = false;
      }
    } catch (error) {
      (this.listErrorApi as any).push({
        api: process.env.VUE_APP_API_URL,
        message: "ไม่สามารถเชื่อมต่อกับเซิร์ฟเวอร์ได้",
      });
      dialogError.value = true;
    } finally {
      Swal.close();
    }
  },
  beforeUnmount() {
    this.listErrorApi = [];
    dialogError.value = false;
    Swal.close();
  },
});
</script>
<style lang="scss">
/* el-select solid style to match  */
.tab-content .el-select .el-input__wrapper {
  background-color: #f4f7fa !important;
  box-shadow: 0 0 0 1px #f4f7fa inset !important;
}
.tab-content .el-select .el-input__wrapper:hover {
  box-shadow: 0 0 0 1px #f4f7fa inset !important;
}
.tab-content .el-select .el-input.is-focus .el-input__wrapper,
.tab-content .el-select .el-input__wrapper.is-focus,
.tab-content .el-select:focus-within .el-input__wrapper {
  background-color: #e8ecf0 !important;
  box-shadow: 0 0 0 1px #e8ecf0 inset !important;
}
.tab-content .el-select input.el-input__inner {
  height: 43px !important;
  color: #5e6278 !important;
  /* background-color: #F4F7FA !important; */
}
.tab-content .el-select input.el-input__inner::placeholder {
  color: #a1a5b7 !important;
  /* background-color: #F4F7FA !important; */
}

/* Address card error overlay */
.address-error-overlay {
  position: absolute;
  inset: 0;
  z-index: 10;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(3px);
  border-radius: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
}

.address-error-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  padding: 24px;
}

.error-dialog-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.error-dialog-icon {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #fef2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.error-dialog-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
}

.error-dialog-body {
  max-height: 300px;
  overflow-y: auto;
}

.error-dialog-msg {
  font-size: 14px;
  line-height: 1.7;
  color: #4a4a68;
  margin: 0 0 16px 0;
}

.error-dialog-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fef2f2;
  border-radius: 10px;
  padding: 12px 16px;
  border: 1px solid #fecaca;
}

.error-dialog-item {
  display: flex;
  align-items: baseline;
  gap: 8px;
  font-size: 13px;
  color: #dc2626;
  line-height: 1.5;
}

.error-dialog-item-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #ef4444;
  flex-shrink: 0;
  margin-top: 6px;
}

.error-dialog-item-msg {
  color: #9ca3af;
  font-size: 12px;
}

.error-dialog-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
  flex-wrap: wrap;
}

.error-dialog-btn {
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 24px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.error-dialog-btn--primary {
  background: #323563;
  color: #fff;
}

.error-dialog-btn--primary:hover {
  background: #3d3f78;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(50, 53, 99, 0.3);
}

.error-dialog-btn--secondary {
  background: #fff;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.error-dialog-btn--secondary:hover {
  background: #f9fafb;
  color: #374151;
  border-color: #d1d5db;
}

@media (max-width: 480px) {
  .dialog-error-custom {
    max-width: 100%;
    width: 100%;
    margin: 0;
  }

  .error-dialog-footer {
    flex-direction: column;
  }

  .error-dialog-btn {
    width: 100%;
    text-align: center;
  }
}

/* Delete Confirm Dialog */
.dialog-delete-confirm {
  max-width: 440px;
  width: calc(100% - 32px);
  border-radius: 20px;
  overflow: hidden;
}

.delete-confirm-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 0;
}

.delete-confirm-icon-wrap {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fffbeb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}

.delete-confirm-title {
  margin: 0 0 8px 0;
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
}

.delete-confirm-desc {
  margin: 0 0 24px 0;
  font-size: 13px;
  line-height: 1.6;
  color: #6b7280;
  max-width: 320px;
}

.delete-confirm-actions {
  display: flex;
  gap: 12px;
  width: 100%;
  justify-content: center;
}

.delete-confirm-btn {
  padding: 10px 28px;
  font-size: 14px;
  font-weight: 600;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 140px;
}

.delete-confirm-btn--cancel {
  background: #f3f4f6;
  color: #6b7280;
}

.delete-confirm-btn--cancel:hover {
  background: #e5e7eb;
  color: #374151;
}

.delete-confirm-btn--danger {
  background: linear-gradient(135deg, #ef4444, #dc2626);
  color: #fff;
}

.delete-confirm-btn--danger:hover {
  background: linear-gradient(135deg, #f87171, #ef4444);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(239, 68, 68, 0.3);
}

@media (max-width: 480px) {
  .dialog-delete-confirm {
    max-width: 100%;
    width: 100%;
  }

  .delete-confirm-actions {
    flex-direction: column;
  }

  .delete-confirm-btn {
    width: 100%;
  }
}

.image-input .image-input-wrapper {
  width: 150px;
  height: 150px;
  border-radius: 0.475rem;
  background-repeat: no-repeat;
  background-size: cover;
}
.icon-edit {
  position: absolute;
  right: -5px;
  top: -5px;
  background: #ffffff;
  height: 23px;
  width: 23px;
  text-align: center;
  border-radius: 20px;
  border: 1px solid #dadada;
}

/* Notification Dialog */
.dialog-notification-custom {
  max-width: 420px;
  width: calc(100% - 32px);
  border-radius: 20px;
  overflow: hidden;
}

.dialog-notification-custom .el-dialog__header {
  display: none;
}

.notification-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 24px 24px;
  text-align: center;
}

.notification-icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #ffa800;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.notification-icon {
  font-size: 28px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
}

.notification-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0 0 24px;
}

.notification-steps {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 20px;
  width: 100%;
}

.notification-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #4a4a68;
}

.notification-step-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #f3f4f6;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #6b7280;
}

.notification-desc {
  font-size: 13px;
  line-height: 1.8;
  color: #4a4a68;
  margin: 0 0 24px;
}

.notification-btn {
  width: 100%;
  padding: 12px;
  background: #323563;
  color: #fff;
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}

.notification-btn:hover {
  background: #3d3f78;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(50, 53, 99, 0.3);
}

@media (max-width: 480px) {
  .dialog-notification-custom {
    max-width: 100%;
    width: 100%;
  }

  .notification-steps {
    gap: 12px;
  }

  .notification-step-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }
}
</style>
